/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/authoring-homepage-ui/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('HomepageServices', ['x1.ui.select', 'x1.ui.tabs', 'ngFileUpload', 'matchmedia-ng', 'pascalprecht.translate', 'ShellServices', 'ui.router', 'homepage.contentUI.tabs']);
	
	__webpack_require__(2);
	__webpack_require__(3);
	__webpack_require__(4);
	__webpack_require__(5);
	__webpack_require__(6);
	__webpack_require__(7);
	__webpack_require__(20);
	
	__webpack_require__(24);
	__webpack_require__(32);
	__webpack_require__(37);
	__webpack_require__(48);
	__webpack_require__(53);
	__webpack_require__(60);
	__webpack_require__(66);
	
	__webpack_require__(48);
	__webpack_require__(71);
	__webpack_require__(112);
	__webpack_require__(118);
	__webpack_require__(124);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ShellServices').run(['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
			$translatePartialLoader.addPart('authoring-homepage-ui');
			$translate.refresh();
	}]);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// An interface between the Asset Upload widget and the Asset Upload authoring UI via a service placed in Shell UI.
	var assetUploadService = function () {
	    function assetUploadService(assetUploadFileManager) {
	        _classCallCheck(this, assetUploadService);
	
	        this.assetUploadFileManager = assetUploadFileManager;
	    }
	
	    // Creates a new upload file list and stores them within this service.
	    // Return the ID for the new file list
	
	
	    _createClass(assetUploadService, [{
	        key: 'addFileList',
	        value: function addFileList(files) {
	            return this.assetUploadFileManager.addFileList(files);
	        }
	
	        // Get the number of upload file lists currently active on this service.
	
	    }, {
	        key: 'getNumberOfFileLists',
	        value: function getNumberOfFileLists() {
	            return this.assetUploadFileManager.getNumberOfFileLists();
	        }
	
	        // Get the string that defines the accepted file types.
	
	    }, {
	        key: 'getFileAcceptType',
	        value: function getFileAcceptType() {
	            return this.assetUploadFileManager.getFileAcceptType();
	        }
	
	        // Get the promise to the string that defines the maximum size accepted for a single file for this tenant.
	
	    }, {
	        key: 'getFileMaxSize',
	        value: function getFileMaxSize() {
	            return this.assetUploadFileManager.getFileMaxSize();
	        }
	
	        // Get the string that defines the default maximum size accepted for a single file.
	
	    }, {
	        key: 'getDefaultFileMaxSize',
	        value: function getDefaultFileMaxSize() {
	            return this.assetUploadFileManager.getDefaultFileMaxSize();
	        }
	
	        // Get the string that defines the maximum number of files that can be uploaded in a single upload instance.
	
	    }, {
	        key: 'getMaxFilesPerUpload',
	        value: function getMaxFilesPerUpload() {
	            return this.assetUploadFileManager.getMaxFilesPerUpload();
	        }
	
	        // Get the integer that defines the maximum upload instances allowed.
	
	    }, {
	        key: 'getMaxUploadInstances',
	        value: function getMaxUploadInstances() {
	            return this.assetUploadFileManager.getMaxUploadInstances();
	        }
	    }]);
	
	    return assetUploadService;
	}();
	
	angular.module('HomepageServices').service('assetUploadService', ['assetUploadFileManager', assetUploadService]);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TypeaheadObject = function () {
	    function TypeaheadObject(field, value, fieldLabel, valueLabel) {
	        _classCallCheck(this, TypeaheadObject);
	
	        this.isSeparator = false;
	        this.field = field;
	        this.value = value;
	        this.fieldLabel = fieldLabel;
	        this.valueLabel = valueLabel;
	    }
	
	    _createClass(TypeaheadObject, [{
	        key: "setSeparator",
	        value: function setSeparator(isSeparator) {
	            this.isSeparator = isSeparator;
	        }
	
	        /* istanbul ignore next */
	
	    }, {
	        key: "getValue",
	        value: function getValue() {
	            return this.value;
	        }
	
	        /* istanbul ignore next */
	
	    }, {
	        key: "getField",
	        value: function getField() {
	            return this.field;
	        }
	
	        /* istanbul ignore next */
	
	    }, {
	        key: "getValueLabel",
	        value: function getValueLabel() {
	            return this.valueLabel || this.value;
	        }
	
	        /* istanbul ignore next */
	
	    }, {
	        key: "getFieldLabel",
	        value: function getFieldLabel() {
	            return this.fieldLabel || this.field;
	        }
	    }]);
	
	    return TypeaheadObject;
	}();
	
	;
	
	var _SearchFilter = function () {
	    function SearchFilter(field, value, fieldLabel, valueLabel) {
	        _classCallCheck(this, SearchFilter);
	
	        this.field = field;
	        this.value = value;
	        this.fieldLabel = fieldLabel;
	        this.valueLabel = valueLabel;
	    }
	
	    _createClass(SearchFilter, [{
	        key: "getValue",
	        value: function getValue() {
	            return this.value;
	        }
	    }, {
	        key: "getField",
	        value: function getField() {
	            return this.field;
	        }
	    }, {
	        key: "getValueLabel",
	        value: function getValueLabel() {
	            return this.valueLabel || this.value;
	        }
	    }, {
	        key: "getFieldLabel",
	        value: function getFieldLabel() {
	            return this.fieldLabel || this.field;
	        }
	    }]);
	
	    return SearchFilter;
	}();
	
	;
	
	var _SearchRequest = function () {
	    function SearchRequest() {
	        _classCallCheck(this, SearchRequest);
	
	        this.query = "";
	        this.classifications = [];
	        this.filters = [];
	
	        this.rootPath = "?";
	        this.sortField = "lastModified";
	        this.sortDirection = "desc";
	        /** how many rows each query return */
	        this.rows = 20;
	        /** the query start index */
	        this.start = 0;
	
	        this.typeaheadQueryTemplate = 'q=*"$query$"*&defType=edismax&facet.contains=$query$&rows=0&facet.contains.ignoreCase=true&qf=id+name%5E20+type%5E10+assetType+tags+status+locale+categoryLeaves+keywords+text+text_ar+text_cjk+text_da+text_de+text_el+text_en+text_es+text_fi+text_fr+text_he+text_hi+text_it+text_ja+text_nl+text_no+text_pl+text_pt+text_pt_br+text_ru+text_sv+text_th+text_tr+text_zh_cn&fq=classification:(content%20OR%20asset)&fq=isManaged:("true")&facet=on&facet.mincount=1&facet.limit=3&facet.field=name&facet.field=assetType&facet.field=type&facet.field=tags&facet.field=status&facet.field=locale&facet.field=categoryLeaves&facet.field=keywords';
	        this.fulltextQueryTemplate = "q=*$query$*&defType=edismax&indent=on&qf=name%5E15+description+creator+lastModifier+tags+status%5E20+path&wt=json&facet.field=created&facet.field=lastModified&facet.field=tags&facet.range=created&facet.range=lastModified&f.created.facet.mincount=0&f.lastModified.facet.mincount=0&facet.range.start=NOW/DAY-30DAYS&facet.range.end=NOW&facet.range.gap=%2B1DAY";
	        this.facetFields = ["name", "assetType", "type", "tags", "status", "locale", "categoryLeaves", "keywords"];
	    }
	
	    _createClass(SearchRequest, [{
	        key: "getQuery",
	        value: function getQuery() {
	            return this.query;
	        }
	    }, {
	        key: "setQuery",
	        value: function setQuery(query) {
	            this.query = query;
	        }
	    }, {
	        key: "getFilters",
	        value: function getFilters() {
	            return this.filters;
	        }
	    }, {
	        key: "setFilters",
	        value: function setFilters(filters) {
	            this.filters = filters;
	        }
	    }, {
	        key: "getClassification",
	        value: function getClassification() {
	            return this.classifications;
	        }
	    }, {
	        key: "setClassifications",
	        value: function setClassifications(classification) {
	            this.classifications = classification;
	        }
	    }, {
	        key: "setSortField",
	        value: function setSortField(field) {
	            this.sortField = field;
	        }
	    }, {
	        key: "setSortDirection",
	        value: function setSortDirection(direction) {
	            var direct = direction.toLowerCase();
	            if (direct === 'desc' || direct === 'asc') {
	                this.sortDirection = direct;
	            }
	        }
	    }, {
	        key: "setRows",
	        value: function setRows(rows) {
	            this.rows = rows;
	        }
	    }, {
	        key: "getRows",
	        value: function getRows() {
	            return this.rows;
	        }
	    }, {
	        key: "setStart",
	        value: function setStart(start) {
	            this.start = start;
	        }
	    }, {
	        key: "getStart",
	        value: function getStart() {
	            return this.start;
	        }
	    }, {
	        key: "getFullTextSearchString",
	        value: function getFullTextSearchString() {
	            var input = this.query;
	            var queryString = this.rootPath;
	            if (input != null && input.trim() !== "") {
	                queryString += this.fulltextQueryTemplate.replace(/\$query\$/g, encodeURIComponent(input));
	            } else {
	                queryString += this.fulltextQueryTemplate.replace(/\$query\$/g, ":");
	            }
	            return queryString + this.sortString() + this.classificationString() + this.filterString() + this.facetsString() + this.sortString() + this.rowsString() + this.timezone();
	        }
	    }, {
	        key: "getTypeaheadSearchString",
	        value: function getTypeaheadSearchString(input) {
	            if (input != null && input.trim().length > 0) {
	                return this.rootPath + this.typeaheadQueryTemplate.replace(/\$query\$/g, encodeURIComponent(input)) + this.classificationString() + this.filterString();
	            }
	        }
	    }, {
	        key: "getFacetOfField",
	        value: function getFacetOfField(field, input) {
	            if (input != null && field != null) {
	                var query = this.rootPath + "facet=true&facet.field=" + field + this.filterString();
	                if (input.trim().length > 0) {
	                    query += "&facet.contains=" + encodeURIComponent(input);
	                }
	                return query;
	            }
	        }
	    }, {
	        key: "rowsString",
	        value: function rowsString() {
	            return "&rows=" + this.rows + "&start=" + this.start;
	        }
	    }, {
	        key: "timezone",
	        value: function timezone() {
	            return "";
	        }
	        /**
	         * Generate the sort query string
	         * @returns {string}
	         */
	
	    }, {
	        key: "sortString",
	        value: function sortString() {
	            return "&sort=" + encodeURIComponent(this.sortField + " " + this.sortDirection);
	        }
	
	        /**
	         * Generate facet query string
	         */
	
	    }, {
	        key: "facetsString",
	        value: function facetsString() {
	            var str = "";
	            var facetFields = this.getValidFacetsFields();
	            if (facetFields != null && facetFields.length > 0) {
	                str = "&facet=true&facet.mincount=1&facet.limit=30";
	                facetFields.forEach(function (value) {
	                    str += "&facet.field=" + value;
	                });
	            }
	            return str;
	        }
	
	        /**
	         *
	         * @param filters An array of Filter object in format {field: xxx, name: xxx}
	         */
	
	    }, {
	        key: "filterString",
	        value: function filterString() {
	            var filtesrStr = "";
	            if (this.filters != null) {
	                this.filters.forEach(function (value) {
	                    filtesrStr += "&fq=" + value.getField() + ":" + encodeURIComponent(value.getValue());
	                });
	            }
	            return filtesrStr;
	        }
	    }, {
	        key: "classificationString",
	        value: function classificationString() {
	            var classStr = "";
	            if (this.classifications != null && this.classifications.length > 0) {
	                classStr = "&fq=classification:(" + encodeURIComponent(this.classifications.join(" OR ")) + ")";
	            }
	            return classStr;
	        }
	        /**
	         * Remove those facet field that already have filter assigned to get the valid facet field
	         * for next search, improve the serch performance.
	         * @returns {string[]}
	         */
	
	    }, {
	        key: "getValidFacetsFields",
	        value: function getValidFacetsFields() {
	            var facets = this.facetFields;
	            if (this.filters && this.filters.length > 0) {
	                var filters = this.filters.map(function (element) {
	                    return element.getField();
	                });
	                facets = this.facetFields.filter(function (value) {
	                    return filters.indexOf(value) < 0 || value === "tags";
	                });
	            }
	            return facets;
	        }
	    }]);
	
	    return SearchRequest;
	}();
	
	;
	
	/**
	 * Transformer of the search result from search service
	 */
	
	var _SearchResult = function () {
	    function SearchResult(result) {
	        _classCallCheck(this, SearchResult);
	
	        this.documents = [];
	        this.numFound = 0;
	        this.facets = new SearchFacets({}, {}, 0);
	
	        var resultJson = result.data ? result.data : result;
	        if (resultJson) {
	            if (resultJson.documents != null) {
	                // this could happen for pure facet search
	                resultJson.documents.forEach(function (element) {
	                    element.id = element.id.substring(element.id.lastIndexOf("-") + 1);
	                });
	            }
	            this.documents = resultJson.documents == null ? [] : resultJson.documents;
	            this.numFound = resultJson.numFound;
	            this.facets = new SearchFacets(resultJson.facets == null ? {} : resultJson.facets, resultJson.facet_ranges == null ? {} : resultJson.facet_ranges, this.numFound);
	        } else {
	            this.documents = [];
	            this.numFound = 0;
	            this.facets = new SearchFacets({}, {}, 0);
	        }
	    }
	
	    /**
	     * documents
	     * @returns {any}
	     */
	
	
	    _createClass(SearchResult, [{
	        key: "getDocuments",
	        value: function getDocuments() {
	            return this.documents;
	        }
	
	        /**
	         * Facets
	         * @returns {SearchFacets}
	         */
	
	    }, {
	        key: "getFacets",
	        value: function getFacets() {
	            return this.facets;
	        }
	    }, {
	        key: "getNumFound",
	        value: function getNumFound() {
	            return this.numFound;
	        }
	    }]);
	
	    return SearchResult;
	}();
	
	;
	
	/**
	 * Facet value, like
	 * Red: 123
	 */
	
	var FacetValue = function () {
	    function FacetValue(value, count) {
	        _classCallCheck(this, FacetValue);
	
	        this.value = value;
	        this.count = count;
	        this.label = "";
	    }
	
	    _createClass(FacetValue, [{
	        key: "getValue",
	        value: function getValue() {
	            return this.value;
	        }
	    }, {
	        key: "getCount",
	        value: function getCount() {
	            return this.count;
	        }
	
	        /* istanbul ignore next */
	
	    }, {
	        key: "setLabel",
	        value: function setLabel(label) {
	            this.label = label;
	        }
	
	        /* istanbul ignore next */
	
	    }, {
	        key: "getLabel",
	        value: function getLabel() {
	            return this.label || this.value;
	        }
	    }]);
	
	    return FacetValue;
	}();
	
	;
	
	/**
	 * One Facet field, like
	 * classification {
	 *      content: 130,
	 *      content-type: 200,
	 *      asset: 300
	 * }
	 */
	
	var SearchFacet = function () {
	    function SearchFacet(field, values) {
	        _classCallCheck(this, SearchFacet);
	
	        this.field = field;
	        this.values = values;
	    }
	
	    /* istanbul ignore next */
	
	
	    _createClass(SearchFacet, [{
	        key: "add",
	        value: function add(value) {
	            this.values.push(value);
	        }
	
	        /* istanbul ignore next */
	
	    }, {
	        key: "getField",
	        value: function getField() {
	            return this.field;
	        }
	    }, {
	        key: "getValues",
	        value: function getValues() {
	            return this.values;
	        }
	
	        /* istanbul ignore next */
	
	    }, {
	        key: "getCount",
	        value: function getCount(value) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = this.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var facetValue = _step.value;
	
	                    if (value === facetValue.getValue()) {
	                        return facetValue.getCount();
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return -1;
	        }
	
	        /* istanbul ignore next */
	
	    }, {
	        key: "isEmpty",
	        value: function isEmpty() {
	            return this.values == null || this.values.length === 0;
	        }
	    }]);
	
	    return SearchFacet;
	}();
	
	;
	
	/**
	 * Facets in a search result.
	 */
	
	var SearchFacets = function () {
	    function SearchFacets(facets, ranges, numFound) {
	        _classCallCheck(this, SearchFacets);
	
	        this.facetMap = this.parseFacetsResult(facets);
	        this.ranges = new SearchFacetRanges(ranges, numFound);;
	        this.numFound = numFound;
	
	        this.emptyFacet = new SearchFacet("empty", []);
	    }
	
	    _createClass(SearchFacets, [{
	        key: "getFacet",
	        value: function getFacet(field) {
	            if (field && this.facetMap[field]) {
	                return this.facetMap[field];
	            } else {
	                return this.emptyFacet;
	            }
	        }
	    }, {
	        key: "getFacets",
	        value: function getFacets() {
	            return this.facetMap;
	        }
	
	        /**
	         * Facet ranges
	         * @returns {SearchFacetRanges}
	         */
	        /* istanbul ignore next */
	
	    }, {
	        key: "getFacetRanges",
	        value: function getFacetRanges() {
	            return this.ranges;
	        }
	
	        /* istanbul ignore next */
	
	    }, {
	        key: "getResultCount",
	        value: function getResultCount() {
	            return this.numFound;
	        }
	    }, {
	        key: "parseFacetsResult",
	        value: function parseFacetsResult(facets) {
	            var result = {};
	            for (var field in facets) {
	                if (facets.hasOwnProperty(field) && facets[field] && Array.isArray(facets[field]) && facets[field].length > 0) {
	                    var facet = facets[field];
	                    var valueArray = [];
	                    for (var i = 0; i < facet.length; i = i + 2) {
	                        valueArray.push(new FacetValue(facet[i], facet[i + 1]));
	                    }
	                    result[field] = new SearchFacet(field, valueArray);
	                }
	            }
	            return result;
	        }
	    }]);
	
	    return SearchFacets;
	}();
	
	;
	
	/**
	 * Facet range object, like
	 * last week: 20
	 */
	
	var Range = function () {
	    function Range(label, field, start, end, count) {
	        _classCallCheck(this, Range);
	
	        this.label = label;
	        this.field = field;
	        this.start = start;
	        this.end = end;
	        this.count = count;
	    }
	
	    /* istanbul ignore next */
	
	
	    _createClass(Range, [{
	        key: "getValue",
	        value: function getValue() {
	            return "[" + this.start + " TO " + this.end + "]";
	        }
	
	        /* istanbul ignore next */
	
	    }, {
	        key: "getLabel",
	        value: function getLabel() {
	            return this.label;
	        }
	
	        /* istanbul ignore next */
	
	    }, {
	        key: "setLabel",
	        value: function setLabel(label) {
	            return this.label = label;
	        }
	
	        /* istanbul ignore next */
	
	    }, {
	        key: "getCount",
	        value: function getCount() {
	            return this.count;
	        }
	
	        /* istanbul ignore next */
	
	    }, {
	        key: "getField",
	        value: function getField() {
	            return this.field;
	        }
	    }]);
	
	    return Range;
	}();
	
	;
	
	/**
	 * One facet range result. like
	 * created: [{Today...},{This week...}]
	 */
	
	var SearchFacetRange = function () {
	    function SearchFacetRange(field, values, numFound) {
	        _classCallCheck(this, SearchFacetRange);
	
	        this.field = field;
	        this.values = values;
	        this.numFound = numFound;
	        this.result = [];
	
	        this.calculate();
	    }
	
	    /* istanbul ignore next */
	
	
	    _createClass(SearchFacetRange, [{
	        key: "getField",
	        value: function getField() {
	            return this.field;
	        }
	
	        /* istanbul ignore next */
	
	    }, {
	        key: "getResult",
	        value: function getResult() {
	            return this.result;
	        }
	    }, {
	        key: "calculate",
	        value: function calculate() {
	            if (this.values && this.values.length > 0) {
	                /* TEMP commented out --> need to import moment to get this to work
	                const dayOfWeek = moment().day();
	                const dayOfLastWeek = moment().day() + 7;
	                const dayOfMonth = moment().date(); */
	                // TEMP WORKAROUND
	                var dayOfWeek = 0;
	                var dayOfLastWeek = 7;
	                var dayOfMonth = 5;
	
	                var sum = 0;
	                var countThisWeek = 0;
	                var totalThisMonth = 0;
	
	                /**  define each of separately to keep the order */
	                var today = void 0,
	                    yesterday = void 0,
	                    thisWeek = void 0,
	                    lastWeek = void 0,
	                    thisMonth = void 0,
	                    before = void 0;
	                for (var i = 0; i < this.values.length; i++) {
	                    sum += this.values[i].getCount();
	                    // Calculate
	                    /* istanbul ignore else */
	                    if (i === 0 && this.values[i].getCount() > 0) {
	                        today = new Range(SearchFacetRange.RANGE_TODAY, this.field, "NOW/DAY", SearchFacetRange.NOW, this.values[i].getCount());
	                    }
	                    /* istanbul ignore next */
	                    if (i === 1 && this.values[i].getCount() > 0) {
	                        yesterday = new Range(SearchFacetRange.RANGE_YESTERDAY, this.field, "NOW/DAY-1DAY", "NOW/DAY", this.values[i].getCount());
	                    }
	                    /* istanbul ignore next */
	                    if (i === dayOfWeek - 1) {
	                        countThisWeek = sum;
	                        if (sum > 0) {
	                            thisWeek = new Range(SearchFacetRange.RANGE_THIS_WEEK, this.field, "NOW/DAY-" + dayOfWeek + "DAY", SearchFacetRange.NOW, sum);
	                        }
	                    }
	                    /* istanbul ignore next */
	                    if (i === dayOfLastWeek - 1 && sum - countThisWeek > 0) {
	                        lastWeek = new Range(SearchFacetRange.RANGE_LAST_WEEK, this.field, "NOW/DAY-" + dayOfLastWeek + "DAY", "NOW/DAY-" + dayOfWeek + "DAY", sum - countThisWeek);
	                    }
	                    /* istanbul ignore next */
	                    if (i === dayOfMonth - 1) {
	                        totalThisMonth = sum;
	                        if (sum > 0) {
	                            thisMonth = new Range(SearchFacetRange.RANGE_THIS_MONTH, this.field, "NOW/MONTH", SearchFacetRange.NOW, sum);
	                        }
	                        break;
	                    }
	                }
	                /* istanbul ignore if */
	                if (this.values.length > dayOfMonth && this.numFound - totalThisMonth > 0) {
	                    before = new Range(SearchFacetRange.RANGE_BEFORE, this.field, "*", "NOW/MONTH", this.numFound - totalThisMonth);
	                }
	
	                this.result = [];
	                // have to do this to keep the order, otherwise yesterday could show up after this week if it's Monday
	                // can be done by array.map but keep it as simple as possible to make it easy to understand.
	                if (today != null) {
	                    this.result.push(today);
	                }
	                /* istanbul ignore next */
	                if (yesterday != null) {
	                    this.result.push(yesterday);
	                }
	                /* istanbul ignore next */
	                if (thisWeek != null) {
	                    this.result.push(thisWeek);
	                }
	                /* istanbul ignore next */
	                if (lastWeek != null) {
	                    this.result.push(lastWeek);
	                }
	                /* istanbul ignore next */
	                if (thisMonth != null) {
	                    this.result.push(thisMonth);
	                }
	                /* istanbul ignore next */
	                if (before != null) {
	                    this.result.push(before);
	                }
	            }
	        }
	    }]);
	
	    return SearchFacetRange;
	}();
	
	;
	
	/*
	 * These need to be translated.
	 */
	var RANGE_TODAY = "today";
	var RANGE_YESTERDAY = "yesterday";
	var RANGE_THIS_WEEK = "thisWeek";
	var RANGE_LAST_WEEK = "lastWeek";
	var RANGE_THIS_MONTH = "thisMonth";
	var RANGE_BEFORE = "beforeThisMonth";
	var NOW = "NOW/DAY+1DAY";
	
	/**
	 * Search Range Facet result, like
	 * {
	 *      created: [rangeA, rangeB...]
	 *      modified: [rangeC, rangeD...]
	 * }
	 */
	
	var SearchFacetRanges = function () {
	    function SearchFacetRanges(ranges, numFound) {
	        _classCallCheck(this, SearchFacetRanges);
	
	        this.map = {};
	        this.emptyRangeFacet = new SearchFacetRange("empty", [], 0);
	
	        if (ranges != null) {
	            this.map = this.parseFacetRangeResult(ranges);
	        }
	        this.numFound = numFound;
	    }
	
	    /**
	     * Get the SearchFacetRanage
	     * @param field the facet field
	     * @returns a SearchFacetRange object
	     */
	    /* istanbul ignore next */
	
	
	    _createClass(SearchFacetRanges, [{
	        key: "getRange",
	        value: function getRange(field) {
	            if (field && this.map[field]) {
	                return this.map[field];
	            } else {
	                return this.emptyRangeFacet;
	            }
	        }
	
	        /**
	         * Parse the range facet result from array of key&number to a Array of SearchFacetRange
	         * Also reverse the order to make it easier to calculate the count
	         * @param facets
	         * @returns {{}}
	         */
	
	    }, {
	        key: "parseFacetRangeResult",
	        value: function parseFacetRangeResult(facets) {
	            var result = {};
	            for (var field in facets) {
	                if (facets.hasOwnProperty(field) && facets[field] && facets[field].counts && Array.isArray(facets[field].counts) && facets[field].counts.length > 0) {
	                    var facet = facets[field].counts;
	                    var valueArray = [];
	                    /*
	                     Reverse the order
	                     */
	                    for (var i = facet.length - 1; i > -1; i = i - 2) {
	                        valueArray.push(new FacetValue(facet[i - 1], facet[i]));
	                    }
	                    result[field] = new SearchFacetRange(field, valueArray, this.numFound);
	                }
	            }
	            return result;
	        }
	    }]);
	
	    return SearchFacetRanges;
	}();
	
	;
	
	var SearchTransformerService = function () {
	    function SearchTransformerService() {
	        _classCallCheck(this, SearchTransformerService);
	    }
	
	    _createClass(SearchTransformerService, [{
	        key: "SearchRequest",
	        value: function SearchRequest() {
	            return new _SearchRequest();
	        }
	    }, {
	        key: "SearchResult",
	        value: function SearchResult(data) {
	            return new _SearchResult(data);
	        }
	    }, {
	        key: "SearchFilter",
	        value: function SearchFilter(field, value, fieldLabel, valueLabel) {
	            return new _SearchFilter(field, value, fieldLabel, valueLabel);
	        }
	
	        /**
	         * Facets result is in format like
	         * {
	         *    "name": [
	         *      "article"
	         *    ],
	         *    "creator": [
	         *      "carlos",
	         *      "evan"
	         *    ],
	         *    "status": [
	         *      "draft"
	         *    ]
	         *  }
	         *
	         *  And in order to make it has meaning for typeahead, transform is needed.
	         * @param facets
	         */
	
	    }, {
	        key: "transformFacetsIntoTypeahead",
	        value: function transformFacetsIntoTypeahead(facets) {
	            var result = [];
	            if (facets != null) {
	                for (var key in facets.getFacets()) {
	                    if (facets.getFacets().hasOwnProperty(key)) {
	                        var taObj = void 0;
	                        var facetArray = facets.getFacet(key).getValues();
	                        for (var i = 0; i < facetArray.length; i++) {
	                            taObj = new TypeaheadObject(key, facetArray[i].getValue(), key);
	                            if (i === 0) {
	                                taObj.setSeparator(true);
	                            }
	                            result.push(taObj);
	                        }
	                    }
	                }
	            }
	            return result;
	        }
	    }]);
	
	    return SearchTransformerService;
	}();
	
	;
	
	angular.module('HomepageServices').service('SearchTransformerService', SearchTransformerService);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// An interface to the service placed in Shell UI.
	var tenantRegistryService = function () {
		function tenantRegistryService(tenantService) {
			_classCallCheck(this, tenantRegistryService);
	
			this.tenantService = tenantService;
		}
	
		_createClass(tenantRegistryService, [{
			key: 'getTenantInformation',
			value: function getTenantInformation() {
				return this.tenantService.getTenant();
			}
		}]);
	
		return tenantRegistryService;
	}();
	
	angular.module('HomepageServices').service('tenantRegistryService', ['tenantService', tenantRegistryService]);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// An interface to the service placed in Shell UI.
	var userProfileService = function () {
		function userProfileService(usersService) {
			_classCallCheck(this, userProfileService);
	
			this.usersService = usersService;
		}
	
		_createClass(userProfileService, [{
			key: 'getCurrentUserData',
			value: function getCurrentUserData() {
				return this.usersService.getUser();
			}
		}]);
	
		return userProfileService;
	}();
	
	angular.module('HomepageServices').service('userProfileService', ['usersService', userProfileService]);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('HomepageServices').factory('serviceLookup', __webpack_require__(8)).factory('homepageDataService', __webpack_require__(9)).factory('homepageUtil', __webpack_require__(10)).factory('contentService', __webpack_require__(12)).factory('publishingService', __webpack_require__(13)).factory('publishingErrorService', __webpack_require__(14)).factory('authSearchService', __webpack_require__(15)).factory('downloadInfoService', __webpack_require__(16)).factory('shellDataHomepageService', __webpack_require__(17)).factory('shutterstockService', __webpack_require__(18)).filter('publishingPreferencesFilter', __webpack_require__(19));

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$http', '$q', function ($http, $q) {
	
		var baseUrl = '/lookup/';
		var homepageDataServiceID = 'homepage/prod-authoring-homepage-data';
	
		/**
	 * Returns a promise to the service's URL String 
	 * @param {String} id, a service id (from http://dx-marathon-3-slave6.rtp.raleigh.ibm.com:32001/ui/#/bandd1/services)
	 * @return {Promise}
	 */
		function getServiceUrlById(id) {
			return $http.get(baseUrl + id).then(function (res) {
				return res.data;
			}, function (res) {
				return $q.reject('Error retrieving "' + id + '" service url: ' + res.status + ' :: ' + res.data + '');
			});
		}
	
		/**
	 * Returns a promise to the homepage data service's URL String 
	 * @return {Promise}
	 */
		function getHomepageDataUrl() {
			return this.getServiceUrlById(homepageDataServiceID);
		}
	
		// return public API for the REST factory
		return {
			getServiceUrlById: getServiceUrlById,
			getHomepageDataUrl: getHomepageDataUrl
		};
	}];

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$http', '$q', '$stateParams', function ($http, $q, $stateParams) {
	
	    var layoutURL = '/api/ui-interface/v1/layout';
	    var fileStorageURL = '/api/ui-interface/v1/diskUsage';
	    var dataTransferURL = '/api/ui-interface/v1/dataTransferUsage';
	
	    var userRoles = { editor: "editor", manager: "manager", administrator: "administrator", admin: "admin" };
	
	    var editor_layout = [{ type: "column", colClass: "two-column", children: [{ type: "component", title: "Compose content", subtitle: "What are you going to create today?", component: "create-content", colClass: "comp", id: "create_content" }, { type: "component", title: "Upload assets", subtitle: "uploadAssetsSubtitle", component: "add-assets", colClass: "comp", id: "add_assets" }] }, { type: "column", colClass: "column", children: [{ type: "component", title: "Publishing at a glance", subtitle: "See what has published or is about to publish", component: "publishing-at-a-glance", colClass: "comp rowspan", id: "pub_glance" }] }],
	        editor_layout_shutterstock = [{ type: "column", colClass: "two-column", children: [{ type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Shutterstock Premiere Images", subtitle: "", component: "shutterstock-image", colClass: "comp comp-left", id: "shutterstock_images" }, { type: "component", title: "Shutterstock Premiere Footage/Music", subtitle: "", component: "shutterstock-footage", colClass: "comp comp-right", id: "shutterstock_footage" }] }, { type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Compose content", subtitle: "What are you going to create today?", component: "create-content", colClass: "comp comp-left", id: "create_content" }, { type: "component", title: "Upload assets", subtitle: "uploadAssetsSubtitle", component: "add-assets", colClass: "comp comp-right", id: "add_assets" }] }] }, { type: "column", colClass: "column", children: [{ type: "component", title: "Publishing at a glance", subtitle: "See what has published or is about to publish", component: "publishing-at-a-glance", colClass: "comp rowspan", id: "pub_glance" }] }],
	
	
	    // drop the publishing at a glance widget
	    editor_layout_base = [{
	        type: "column", colClass: "column", children: [{ type: "component", title: "Compose content", subtitle: "What are you going to create today?", component: "create-content", colClass: "comp", id: "create_content" }]
	    }, {
	        type: "column", colClass: "column", children: [{ type: "component", title: "Upload assets", subtitle: "uploadAssetsSubtitle", component: "add-assets", colClass: "comp", id: "add_assets" }]
	    }],
	        editor_layout_base_shutterstock = [{ type: "column", colClass: "two-column", children: [{ type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Shutterstock Premiere Images", subtitle: "", component: "shutterstock-image", colClass: "comp comp-left", id: "shutterstock_images" }, { type: "component", title: "Shutterstock Premiere Footage/Music", subtitle: "", component: "shutterstock-footage", colClass: "comp comp-right", id: "shutterstock_footage" }] }, { type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Compose content", subtitle: "What are you going to create today?", component: "create-content", colClass: "comp comp-left", id: "create_content" }, { type: "component", title: "Upload assets", subtitle: "uploadAssetsSubtitle", component: "add-assets", colClass: "comp comp-right", id: "add_assets" }] }] }, { type: "column", colClass: "column", children: [{ type: "component", title: "Publishing at a glance", subtitle: "See what has published or is about to publish", component: "publishing-at-a-glance", colClass: "comp rowspan", id: "pub_glance" }] }],
	        admin_layout = [{ type: "column", colClass: "two-column", children: [{ type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Hub usage", subtitle: "", component: "hub-usage", colClass: "comp colspan", id: "hub_usage" }] }, { type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp comp-left", id: "add_user" }, { type: "component", title: "Update the sample site", subtitle: "Check your sample's build date to see if updates are needed.  <a href='https://developer.ibm.com/customer-engagement/tutorials/updating-oslo-sample/' target='_blank'> Learn more</a>", component: "download-site", colClass: "comp comp-right", id: "download_assets" }] }, { type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Compose content", subtitle: "What are you going to create today?", component: "create-content", colClass: "comp comp-left", id: "create_content" }, { type: "component", title: "Upload assets", subtitle: "uploadAssetsSubtitle", component: "add-assets", colClass: "comp comp-right", id: "add_assets" }] }] }, { type: "column", colClass: "column", children: [{ type: "component", title: "Publishing at a glance", subtitle: "See what has published or is about to publish", component: "publishing-at-a-glance", colClass: "comp rowspan", id: "pub_glance" }] }],
	        admin_layout_shutterstock = [{ type: "column", colClass: "two-column", children: [{ type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Hub usage", subtitle: "", component: "hub-usage", colClass: "comp colspan", id: "hub_usage" }] }, { type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Shutterstock Premiere Images", subtitle: "", component: "shutterstock-image", colClass: "comp comp-left", id: "shutterstock_images" }, { type: "component", title: "Shutterstock Premiere Footage/Music", subtitle: "", component: "shutterstock-footage", colClass: "comp comp-right", id: "shutterstock_footage" }] }, { type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Update the sample site", subtitle: "Check your sample's build date to see if updates are needed.  <a href='https://developer.ibm.com/customer-engagement/tutorials/updating-oslo-sample/' target='_blank'> Learn more</a>", component: "download-site", colClass: "comp comp-left", id: "download_assets" }, { type: "component", title: "Upload assets", subtitle: "uploadAssetsSubtitle", component: "add-assets", colClass: "comp comp-right", id: "add_assets" }] }, { type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp comp-left", id: "add_user" }, { type: "component", title: "Compose content", subtitle: "What are you going to create today?", component: "create-content", colClass: "comp comp-right desktop-hidden", id: "create_content_tablet" }] }] }, { type: "column", colClass: "column", children: [{ type: "component", title: "Publishing at a glance", subtitle: "See what has published or is about to publish", component: "publishing-at-a-glance", colClass: "comp rowspan", id: "pub_glance" }, { type: "component", title: "Compose content", subtitle: "What are you going to create today?", component: "create-content", colClass: "comp tablet-hidden", id: "create_content" }] }],
	
	
	    // drop the download widget only - this is under toggle for the time being but should eventually
	    admin_layout_base_pub_glance = [{ type: "column", colClass: "two-column", children: [{ type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Hub usage", subtitle: "", component: "hub-usage", colClass: "comp colspan", id: "hub_usage" }] }, { type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Upload assets", subtitle: "uploadAssetsSubtitle", component: "add-assets", colClass: "comp comp-left", id: "add_assets" }, { type: "component", title: "Compose content", subtitle: "What are you going to create today?", component: "create-content", colClass: "comp comp-right", id: "create_content" }] }, { type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp comp-left", id: "add_user" }, { type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp comp-right always-hidden", id: "add_user_hidden" }] }] }, { type: "column", colClass: "column", children: [{ type: "component", title: "Publishing at a glance", subtitle: "See what has published or is about to publish", component: "publishing-at-a-glance", colClass: "comp rowspan", id: "pub_glance" }] }],
	
	
	    // drop the download and publishing at a glance widgets
	    admin_layout_base = [{ type: "column", colClass: "two-column", children: [{ type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Hub usage", subtitle: "", component: "hub-usage", colClass: "comp colspan", id: "hub_usage" }] }, { type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Compose content", subtitle: "What are you going to create today?", component: "create-content", colClass: "comp comp-left", id: "create_content" }, { type: "component", title: "Upload assets", subtitle: "uploadAssetsSubtitle", component: "add-assets", colClass: "comp comp-right", id: "add_assets" }] }] }, { type: "column", colClass: "column", children: [{ type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp", id: "add_user" }] }],
	        admin_layout_base_shutterstock = [{ type: "column", colClass: "two-column", children: [{ type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Hub usage", subtitle: "", component: "hub-usage", colClass: "comp colspan", id: "hub_usage" }] }, { type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Shutterstock Premiere Images", subtitle: "", component: "shutterstock-image", colClass: "comp comp-left", id: "shutterstock_images" }, { type: "component", title: "Shutterstock Premiere Footage/Music", subtitle: "", component: "shutterstock-footage", colClass: "comp comp-right", id: "shutterstock_footage" }] }, { type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Compose content", subtitle: "What are you going to create today?", component: "create-content", colClass: "comp comp-left", id: "create_content" }, { type: "component", title: "Upload assets", subtitle: "uploadAssetsSubtitle", component: "add-assets", colClass: "comp comp-right", id: "add_assets" }] }, { type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp comp-left desktop-hidden", id: "add_user_tablet" }, { type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp comp-right always-hidden", id: "add_user_hidden" }] }] }, { type: "column", colClass: "column", children: [{ type: "component", title: "Publishing at a glance", subtitle: "See what has published or is about to publish", component: "publishing-at-a-glance", colClass: "comp rowspan", id: "pub_glance" }, { type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp tablet-hidden", id: "add_user" }] }],
	
	
	    // non-base tier admin view (Add user has been removed as obsolete, keeping here as always hidden for spacing purposes)
	    about_layout = [{
	        type: "column", colClass: "two-column", children: [{
	            type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Hub usage", subtitle: "", component: "hub-usage", colClass: "comp colspan", id: "hub_usage" }]
	        }, {
	            type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Update the sample site", subtitle: "Check your sample's build date to see if updates are needed.  <a href='https://developer.ibm.com/customer-engagement/tutorials/updating-oslo-sample/' target='_blank'> Learn more</a>", component: "download-site", colClass: "comp comp-left desktop-hidden", id: "download_assets_tablet" }, { type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp comp-left always-hidden", id: "add_user" }]
	        }]
	    }, {
	        type: "column", colClass: "column", children: [{ type: "component", title: "Update the sample site", subtitle: "Check your sample's build date to see if updates are needed.  <a href='https://developer.ibm.com/customer-engagement/tutorials/updating-oslo-sample/' target='_blank'> Learn more</a>", component: "download-site", colClass: "comp tablet-hidden", id: "download_assets" }]
	    }],
	
	
	    // drop hub usage widget (always hidden here to keep spacing)
	    about_layout_non_admin = [
	        /*
	        {
	            type: "column", colClass: "column", children: [
	                { type: "component", title: "Update the sample site", subtitle: "Check your sample's build date to see if updates are needed.  <a href='https://developer.ibm.com/customer-engagement/tutorials/updating-oslo-sample/' target='_blank'> Learn more</a>", component: "download-site", colClass: "comp", id: "download_assets" }
	            ]
	        },
	        {
	            type: "column", colClass: "two-column", children: [
	                {
	                    type: "row", rowClass: "two-column-row", children: [
	                        { type: "component", title: "Hub usage", subtitle: "", component: "hub-usage", colClass: "comp colspan always-hidden", id: "hub_usage" }
	                    ]
	                }
	            ]
	        },
	        */
	    ],
	
	
	    // drop the download widget
	    about_layout_base = [{
	        type: "column", colClass: "two-column", children: [{
	            type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Hub usage", subtitle: "", component: "hub-usage", colClass: "comp colspan", id: "hub_usage" }]
	        }]
	    }, {
	        type: "column", colClass: "column", children: [{ type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp always-hidden", id: "add_user" }]
	    }],
	
	
	    // drop the download widget and hub usage widget, so nothing left
	    about_layout_base_non_admin = [{}],
	
	
	    // add the SS widgets
	    about_layout_shutterstock = [{
	        type: "column", colClass: "two-column", children: [{
	            type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Hub usage", subtitle: "", component: "hub-usage", colClass: "comp colspan", id: "hub_usage" }]
	        }, {
	            type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Shutterstock Premiere Images", subtitle: "", component: "shutterstock-image", colClass: "comp comp-left", id: "shutterstock_images" }, { type: "component", title: "Shutterstock Premiere Footage/Music", subtitle: "", component: "shutterstock-footage", colClass: "comp comp-right", id: "shutterstock_footage" }]
	        }, {
	            type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Update the sample site", subtitle: "Check your sample's build date to see if updates are needed.  <a href='https://developer.ibm.com/customer-engagement/tutorials/updating-oslo-sample/' target='_blank'> Learn more</a>", component: "download-site", colClass: "comp comp-left desktop-hidden", id: "download_assets" }, { type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp comp-right always-hidden", id: "add_user_tablet" }]
	        }]
	    }, {
	        type: "column", colClass: "column", children: [{ type: "component", title: "Update the sample site", subtitle: "Check your sample's build date to see if updates are needed.  <a href='https://developer.ibm.com/customer-engagement/tutorials/updating-oslo-sample/' target='_blank'> Learn more</a>", component: "download-site", colClass: "comp tablet-hidden", id: "download_assets" }]
	    }],
	
	
	    // add the SS widgets, drop hub usage widget
	    about_layout_shutterstock_non_admin = [{
	        type: "column", colClass: "column", children: [{ type: "component", title: "Shutterstock Premiere Images", subtitle: "", component: "shutterstock-image", colClass: "comp comp-left", id: "shutterstock_images" }]
	    }, {
	        type: "column", colClass: "column", children: [{ type: "component", title: "Shutterstock Premiere Footage/Music", subtitle: "", component: "shutterstock-footage", colClass: "comp comp-right", id: "shutterstock_footage" }]
	        /*
	        {
	            type: "column", colClass: "two-column", children: [
	                {
	                    type: "row", rowClass: "two-column-row", children: [
	                        { type: "component", title: "Shutterstock Premiere Images", subtitle: "", component: "shutterstock-image", colClass: "comp comp-left", id: "shutterstock_images" },
	                        { type: "component", title: "Shutterstock Premiere Footage/Music", subtitle: "", component: "shutterstock-footage", colClass: "comp comp-right", id: "shutterstock_footage" }
	                    ]
	                },
	                {
	                    type: "row", rowClass: "two-column-row", children: [
	                        { type: "component", title: "Update the sample site", subtitle: "Check your sample's build date to see if updates are needed.  <a href='https://developer.ibm.com/customer-engagement/tutorials/updating-oslo-sample/' target='_blank'> Learn more</a>", component: "download-site", colClass: "comp comp-left desktop-hidden", id: "download_assets" },
	                        { type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp comp-right always-hidden", id: "add_user_tablet" }
	                    ]
	                }
	            ]
	        },
	        {
	            type: "column", colClass: "column", children: [
	                { type: "component", title: "Update the sample site", subtitle: "Check your sample's build date to see if updates are needed.  <a href='https://developer.ibm.com/customer-engagement/tutorials/updating-oslo-sample/' target='_blank'> Learn more</a>", component: "download-site", colClass: "comp tablet-hidden", id: "download_assets" }
	            ]
	        }
	        */
	    }],
	
	
	    // drop the download widget and add SS widgets (Add User is used as a spacer and never seen)
	    about_layout_base_shutterstock = [{
	        type: "column", colClass: "two-column", children: [{
	            type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Hub usage", subtitle: "", component: "hub-usage", colClass: "comp colspan", id: "hub_usage" }]
	        }, {
	            type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Shutterstock Premiere Images", subtitle: "", component: "shutterstock-image", colClass: "comp comp-left", id: "shutterstock_images" }, { type: "component", title: "Shutterstock Premiere Footage/Music", subtitle: "", component: "shutterstock-footage", colClass: "comp comp-right", id: "shutterstock_footage" }]
	        }]
	    }, {
	        type: "column", colClass: "column", children: [{ type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp always-hidden", id: "add_user" }]
	    }],
	
	
	    // drop the download widget, hub usage, and add SS widgets (Add User is used as a spacer and never seen)
	    about_layout_base_shutterstock_non_admin = [{
	        type: "column", colClass: "two-column", children: [{
	            type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Shutterstock Premiere Images", subtitle: "", component: "shutterstock-image", colClass: "comp comp-left", id: "shutterstock_images" }, { type: "component", title: "Shutterstock Premiere Footage/Music", subtitle: "", component: "shutterstock-footage", colClass: "comp comp-right", id: "shutterstock_footage" }]
	        }]
	    }, {
	        type: "column", colClass: "column", children: [{ type: "component", title: "Add user", subtitle: "", component: "add-user", colClass: "comp always-hidden", id: "add_user" }]
	    }],
	        manager_layout = [{ type: "column", colClass: "two-column", children: [{ type: "component", title: "Compose content", subtitle: "What are you going to create today?", component: "create-content", colClass: "comp", id: "create_content" }, { type: "component", title: "Upload assets", subtitle: "uploadAssetsSubtitle", component: "add-assets", colClass: "comp", id: "add_assets" }] }, { type: "column", colClass: "column", children: [{ type: "component", title: "Publishing at a glance", subtitle: "See what has published or is about to publish", component: "publishing-at-a-glance", colClass: "comp rowspan", id: "pub_glance" }] }],
	        manager_layout_shutterstock = [{ type: "column", colClass: "two-column", children: [{ type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Shutterstock Premiere Images", subtitle: "", component: "shutterstock-image", colClass: "comp comp-left", id: "shutterstock_images" }, { type: "component", title: "Shutterstock Premiere Footage/Music", subtitle: "", component: "shutterstock-footage", colClass: "comp comp-right", id: "shutterstock_footage" }] }, { type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Compose content", subtitle: "What are you going to create today?", component: "create-content", colClass: "comp comp-left", id: "create_content" }, { type: "component", title: "Upload assets", subtitle: "uploadAssetsSubtitle", component: "add-assets", colClass: "comp comp-right", id: "add_assets" }] }] }, { type: "column", colClass: "column", children: [{ type: "component", title: "Publishing at a glance", subtitle: "See what has published or is about to publish", component: "publishing-at-a-glance", colClass: "comp rowspan", id: "pub_glance" }] }],
	
	
	    // drop the publishing at a glance widget
	    manager_layout_base = [{ type: "column", colClass: "two-column-row", children: [{ type: "component", title: "Compose content", subtitle: "What are you going to create today?", component: "create-content", colClass: "comp comp-left", id: "create_content" }, { type: "component", title: "Upload assets", subtitle: "uploadAssetsSubtitle", component: "add-assets", colClass: "comp comp-right", id: "add_assets" }] }],
	        manager_layout_base_shutterstock = [{ type: "column", colClass: "two-column", children: [{ type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Shutterstock Premiere Images", subtitle: "", component: "shutterstock-image", colClass: "comp comp-left", id: "shutterstock_images" }, { type: "component", title: "Shutterstock Premiere Footage/Music", subtitle: "", component: "shutterstock-footage", colClass: "comp comp-right", id: "shutterstock_footage" }] }, { type: "row", rowClass: "two-column-row", children: [{ type: "component", title: "Upload assets", subtitle: "uploadAssetsSubtitle", component: "add-assets", colClass: "comp comp-left", id: "add_assets" }, { type: "component", title: "Compose content", subtitle: "What are you going to create today?", component: "create-content", colClass: "comp comp-right desktop-hidden", id: "create_content_tablet" }] }] }, { type: "column", colClass: "column", children: [{ type: "component", title: "Compose content", subtitle: "What are you going to create today?", component: "create-content", colClass: "comp tablet-hidden", id: "create_content" }] }];
	
	    /**
	     * Returns a promise to the JSON for the homepage layout for the current tenant user
	     * @return {Promise}
	     */
	    function getTenantUserLayout(tenantUser) {
	        return $http({ method: 'GET', url: layoutURL }).then(function (res) {
	            return res.data;
	        }, function (res) {
	            return $q.reject(res.status + ' :: ' + res.statusText);
	        });
	    }
	
	    /**
	     * Returns a promise to the JSON for the current tenant's total disk usage
	     * @return {Promise}
	     */
	    function getTenantDiskUsage() {
	        return $http({ method: 'GET', url: fileStorageURL }).then(function (res) {
	            return res.data.usageData;
	        }, function (res) {
	            return $q.reject(res.status + ' :: ' + res.statusText);
	        });
	    }
	
	    /**
	     * Returns a promise to the JSON for the current tenant's total data transfer usage
	     * @return {Promise}
	     */
	    function getTenantDataTransferUsage() {
	        return $http.get(dataTransferURL).then(function (res) {
	            return res.data.usageData;
	        }, function (res) {
	            return $q.reject(res.status + ' :: ' + res.statusText);
	        });
	    }
	
	    /**
	     * Returns the layout based on the user's role and WCH tier
	     * @return {Object}
	     */
	    function getUserLayout(role, tier, showPubGlance, showShutterstockImages, image_level, footage_level, isAboutPageToggleEnabled) {
	        var layout = '{}';
	
	        setShutterstockTitles(image_level, footage_level);
	
	        // are we using the new Homepage / About page feature
	        if (isAboutPageToggleEnabled === true) {
	            // provide the new layouts depending on which page we have navigated to
	            var isAboutPage = !!$stateParams.about;
	            layout = isAboutPage === true ? getAboutPageLayout(role, tier, showShutterstockImages) : getHomepageLayout();
	        }
	        // no, we are still on the old homepage format
	        else {
	                switch (role) {
	                    case userRoles.editor:
	                        if (tier !== "base" && showShutterstockImages === true) {
	                            layout = editor_layout_shutterstock;
	                        } else if (tier !== "base" && showShutterstockImages === false) {
	                            layout = editor_layout;
	                        } else {
	                            if (showPubGlance === true && showShutterstockImages === false) {
	                                layout = editor_layout;
	                            } else if (showShutterstockImages === true) {
	                                layout = editor_layout_base_shutterstock;
	                            } else {
	                                layout = editor_layout_base;
	                            }
	                        }
	                        break;
	                    case userRoles.manager:
	                        if (tier !== "base" && showShutterstockImages === true) {
	                            layout = manager_layout_shutterstock;
	                        } else if (tier !== "base" && showShutterstockImages === false) {
	                            layout = manager_layout;
	                        } else {
	                            if (showPubGlance === true && showShutterstockImages === false) {
	                                layout = manager_layout;
	                            } else if (showShutterstockImages === true) {
	                                layout = manager_layout_base_shutterstock;
	                            } else {
	                                layout = manager_layout_base;
	                            }
	                        }
	                        break;
	                    case userRoles.admin:
	                    case userRoles.administrator:
	                        if (tier !== "base" && showShutterstockImages === true) {
	                            layout = admin_layout_shutterstock;
	                        } else if (tier !== "base" && showShutterstockImages === false) {
	                            layout = admin_layout;
	                        } else {
	                            if (showPubGlance === true && showShutterstockImages === false) {
	                                layout = admin_layout_base_pub_glance;
	                            } else if (showShutterstockImages === true) {
	                                layout = admin_layout_base_shutterstock;
	                            } else {
	                                layout = admin_layout_base;
	                            }
	                        }
	                        break;
	                    default:
	                        break;
	                }
	            }
	
	        return layout;
	    }
	
	    // assume this applies to all roles
	    function getHomepageLayout() {
	        return editor_layout;
	    }
	
	    // assume only Admins can navigate to this page
	    function getAboutPageLayout(role, tier, showShutterstockImages) {
	        var layout = void 0;
	
	        if (tier !== 'base') {
	            if (role === 'admin') {
	                layout = showShutterstockImages === true ? about_layout_shutterstock : about_layout;
	            } else {
	                layout = showShutterstockImages === true ? about_layout_shutterstock_non_admin : about_layout_non_admin;
	            }
	        }
	        // base tier
	        else {
	                if (role === 'admin') {
	                    layout = showShutterstockImages === true ? about_layout_base_shutterstock : about_layout_base;
	                } else {
	                    layout = showShutterstockImages === true ? about_layout_base_shutterstock_non_admin : about_layout_base_non_admin;
	                }
	            }
	
	        return layout;
	    }
	
	    // Determine the title of Shutterstock widget depending on Shutterstock's user level
	    function setShutterstockTitles(image_level, footage_level) {
	        var shutterstock_image_level = image_level === 'premier' ? 'Premiere' : 'Media';
	        var shutterstock_footage_level = footage_level === 'premier' ? 'Premiere' : 'Media';
	
	        var shtterstock_image_title = 'Shutterstock ' + shutterstock_image_level + ' Images';
	        var shtterstock_footage_title = 'Shutterstock ' + shutterstock_footage_level + ' Footage/Music';
	        editor_layout_shutterstock[0].children[0].children[0].title = shtterstock_image_title;
	        editor_layout_shutterstock[0].children[0].children[1].title = shtterstock_footage_title;
	
	        editor_layout_base_shutterstock[0].children[0].children[0].title = shtterstock_image_title;
	        editor_layout_base_shutterstock[0].children[0].children[1].title = shtterstock_footage_title;
	
	        admin_layout_shutterstock[0].children[1].children[0].title = shtterstock_image_title;
	        admin_layout_shutterstock[0].children[1].children[1].title = shtterstock_footage_title;
	
	        admin_layout_base_shutterstock[0].children[1].children[0].title = shtterstock_image_title;
	        admin_layout_base_shutterstock[0].children[1].children[1].title = shtterstock_footage_title;
	
	        manager_layout_shutterstock[0].children[0].children[0].title = shtterstock_image_title;
	        manager_layout_shutterstock[0].children[0].children[1].title = shtterstock_footage_title;
	
	        manager_layout_base_shutterstock[0].children[0].children[0].title = shtterstock_image_title;
	        manager_layout_base_shutterstock[0].children[0].children[1].title = shtterstock_footage_title;
	
	        about_layout_shutterstock[0].children[1].children[0].title = shtterstock_image_title;
	        about_layout_shutterstock[0].children[1].children[1].title = shtterstock_footage_title;
	
	        about_layout_base_shutterstock[0].children[1].children[0].title = shtterstock_image_title;
	        about_layout_base_shutterstock[0].children[1].children[1].title = shtterstock_footage_title;
	    }
	
	    // return public API for the REST factory
	    return {
	        getTenantUserLayout: getTenantUserLayout,
	        getTenantDiskUsage: getTenantDiskUsage,
	        getTenantDataTransferUsage: getTenantDataTransferUsage,
	        getUserLayout: getUserLayout
	    };
	}];

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _logging = __webpack_require__(11);
	
	var logger = (0, _logging.createLogger)('homepage-util');
	
	module.exports = ['shellDataHomepageService', 'shellUtil', function (shellDataHomepageService, shellUtil) {
	
		var userPrefsPubAtGlancePromise = null;
	
		var getPublishingAtAGlancePreferences = function getPublishingAtAGlancePreferences() {
			/*
	   * Returns the JSON promise with only the user preferences for Publishing at a Glance component 
	   */
			if (!userPrefsPubAtGlancePromise) {
				var p1 = new Promise(function (resolve, reject) {
					shellDataHomepageService.getUserPreferences().then(function (data) {
						if (data.items && data.items.length > 0) {
							data.items.forEach(function (item) {
								if (item.widgetPreferences) {
									item.widgetPreferences.forEach(function (value) {
										if (value.wcomponent === 'publishing-at-a-glance') {
											var userPreferences = value.preferences;
											logger.info("read user preferences: " + JSON.stringify(userPreferences));
											userPrefsPubAtGlancePromise = p1;
											resolve(userPreferences);
										}
									});
								}
								// possibly old tenant that doesn't have widgetPrefs
								else {
										logger.info("No widget preferences stored for this user");
										resolve({});
									}
							});
						}
						// doesn't look like there is any whats new data for this user at all
						else {
								logger.info("No data or widget preferences stored for this user");
								resolve({});
							}
					}, function (error) {
						logger.error('Error retrieving current user preference data from server: ' + error);
						userPrefsPubAtGlancePromise = null;
						reject(error);
					});
				});
	
				return p1;
			} else {
				return userPrefsPubAtGlancePromise;
			}
		};
	
		var setPublishingAtAGlancePreferences = function setPublishingAtAGlancePreferences(newPrefs) {
			return new Promise(function (resolve, reject) {
				var update = null;
				if (newPrefs) {
					userPrefsPubAtGlancePromise = null;
	
					// get all of the current user prefs and update the values for publishing at a glance
					shellDataHomepageService.getUserPreferences().then(function (data) {
						if (data.items && data.items.length > 0) {
							data.items.forEach(function (item) {
								if (item.widgetPreferences) {
									item.widgetPreferences.forEach(function (value) {
										if (value.wcomponent === 'publishing-at-a-glance') {
											value.preferences = newPrefs;
											logger.info("set user preferences: " + JSON.stringify(item.widgetPreferences));
											update = item.widgetPreferences;
										}
									});
								}
								// possibly old tenant that does not have setting so store new user prefs
								else {
										logger.info("no current widget prefs, will set user preferences to: " + JSON.stringify(newPrefs));
										update = [{ wcomponent: 'publishing-at-a-glance', preferences: newPrefs }];
									}
							});
						}
						// doesn't look like there is any whats new data for this user at all
						else {
								logger.info("no data or current widget prefs, will set user preferences to: " + JSON.stringify(newPrefs));
								update = [{ wcomponent: 'publishing-at-a-glance', preferences: newPrefs }];
							}
	
						return update;
					}).then(function (newUserPrefs) {
						if (newUserPrefs !== null) {
							shellDataHomepageService.setUserPreferences({ 'widgetPreferences': newUserPrefs }).then(function (rv) {
								resolve(rv);
							});
						}
						// something went terribly wrong above if we are here
						else {
								logger.error("Error setting user preferences");
								reject(false);
							}
					});
				} else {
					reject(false);
				}
			});
		};
	
		var getCurrentLocale = function getCurrentLocale() {
			return shellUtil.getCurrentLocale();
		};
	
		var getKeyCode = function getKeyCode(event) {
			// make sure this is a keyboard event, if not return undefined
			var key = event.keyCode;
			if (typeof key !== 'undefined') {
				// some browsers (ex. FF Quantum) put the real keycode in which property 
				key = event.which || event.keyCode || 0;
			}
			return key;
		};
	
		// return public API for the util factory
		return {
			getPublishingAtAGlancePreferences: getPublishingAtAGlancePreferences,
			setPublishingAtAGlancePreferences: setPublishingAtAGlancePreferences,
			getCurrentLocale: getCurrentLocale,
			getKeyCode: getKeyCode
		};
	}];

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	var factory = loggingClient.getLoggerFactory({
		name: 'authoring-homepage-ui',
		version: '1.2'
	}, {
		logToConsole: true,
		testMode: false,
		enablePolling: false,
		consoleLevel: loggingClient.Level.INFO,
		ajaxLevel: loggingClient.Level.WARN
	});
	
	module.exports = factory('general');
	module.exports.createLogger = function (name) {
		return factory(name);
	};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$http', '$q', function ($http, $q) {
	
		var authoringTypeURL = '/api/authoring/v1/types';
		var authoringCountURL = '/api/authoring/v1/content/count';
	
		/**
	 * Returns a promise to the JSON for the current content types
	 * @return {Promise}
	 */
		function getCurrentContentTypes() {
			return $http.get(authoringTypeURL + '?classification=content-type&fields=id,name,description,kind&limit=500').then(function (res) {
				return res.data;
			}, function (res) {
				return $q.reject(res.status + ' :: ' + res.data);
			});
		}
	
		/**
	 * Returns a promise to the JSON for the current content item usage
	 * @return {Promise}
	 */
		function getCurrentContentItemUsage() {
			return $http.get(authoringCountURL).then(function (res) {
				return res.data.count;
			}, function (res) {
				return $q.reject(res.status + ' :: ' + res.statusText);
			});
		}
	
		// return public API for the REST factory
		return {
			getCurrentContentTypes: getCurrentContentTypes,
			getCurrentContentItemUsage: getCurrentContentItemUsage
		};
	}];

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _logging = __webpack_require__(11);
	
	var logger = (0, _logging.createLogger)('publishing-service');
	
	module.exports = ['$http', '$q', '$filter', 'homepageUtil', 'shellUtil', 'userProfileService', function ($http, $q, $filter, homepageUtil, shellUtil, userProfileService) {
	
		//const publishingQuery = '?q=*:*&defType=edismax&indent=on&qf=*&wt=json&fq=classification:(project)&sort=lastModified%20desc&rows=32&start=0&fl=id,name,classification,created,creator,lastModified,lastModifier,document:%5Bjson%5D';
		var options = { year: 'numeric', month: 'short', day: 'numeric' };
		var timeOptions = { hour: 'numeric', minute: 'numeric' };
	
		/**
	 * Returns a promise to the JSON for the currently pending publishing jobs
	 * @return {Promise}
	 */
		function getCurrentPending() {
			var entriesPending = [];
	
			return new Promise(function (resolve, reject) {
				// assume that the pub error service was called first and fetched the latest data
				shellUtil.getProjects(false).then(function (res) {
					return res;
				}, function (error) {
					logger.error('Error retrieving current search publishing data from server: ' + JSON.stringify(error));
					reject(error);
				}).then(function (data) {
					if (typeof data === 'undefined') {
						// looks like we hit an error
						logger.error('Error retrieving current project data from server: data was undefined');
						reject(new Error('No data from search for projects'));
					}
					if (data && data.numFound > 0) {
						var _iteratorNormalCompletion = true;
						var _didIteratorError = false;
						var _iteratorError = undefined;
	
						try {
							for (var _iterator = data.documents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
								var doc = _step.value;
	
								var document = doc.document;
								if (document.status === "pending" || document.status === "in-progress") {
									logger.info(" got document pending date: " + document.targetDate);
									// if the content gets deleted after a publishing job is set, there is no target date
									if (document.targetDate) {
										(function () {
											var targetDate = new Date(document.targetDate);
											var timeString = targetDate.toLocaleTimeString(homepageUtil.getCurrentLocale().replace('_', '-'), timeOptions);
											// store with each body entry the detailed time for sorting
											//let bodyDateString = "" + targetDate.getTime();
											// now normalize all target dates to same
											//targetDate.setHours(0,0,0,0);
											var dateString = "" + targetDate.getTime();
											var titleString = targetDate.toLocaleDateString(homepageUtil.getCurrentLocale().replace('_', '-'), options);
											var displayName = document.creator || document.creatorId;
											var bodyEntry = { bodyTitle: document.name, bodyEntryName: displayName, bodyEntryCreatorId: document.creatorId, bodyEntryCount: document.itemCount, time: dateString, bodyId: document.id, bodyKind: document.kind };
											var match = entriesPending.find(function (element) {
												return element.date === dateString;
											});
											if (!match) {
												var bodyArray = [];
												bodyArray.push(bodyEntry);
												entriesPending.push({ date: dateString, title: titleString, time: timeString, body: bodyArray });
											} else {
												var _bodyArray = match.body;
												_bodyArray.push(bodyEntry);
											}
										})();
									}
								}
							}
						} catch (err) {
							_didIteratorError = true;
							_iteratorError = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion && _iterator.return) {
									_iterator.return();
								}
							} finally {
								if (_didIteratorError) {
									throw _iteratorError;
								}
							}
						}
					}
	
					// lookup the id of the current user
					userProfileService.getCurrentUserData().then(function (data) {
						return data.id;
					}).then(function (userId) {
						homepageUtil.getPublishingAtAGlancePreferences().then(function (userPrefs) {
							var filteredContent = $filter('publishingPreferencesFilter')(entriesPending, userPrefs, userId);
							resolve(filteredContent);
						});
					});
				});
			});
		}
	
		/**
	 * Returns a promise to the JSON for the currently on hold publishing jobs
	 * @return {Promise}
	 */
		function getCurrentOnHold() {
			var entriesOnHold = [];
	
			return new Promise(function (resolve, reject) {
				// assume that the pub error service was called first and fetched the latest data
				shellUtil.getProjects(false).then(function (res) {
					return res;
				}, function (error) {
					logger.error('Error retrieving current search publishing data from server: ' + JSON.stringify(error));
					reject(error);
				}).then(function (data) {
					if (typeof data === 'undefined') {
						// looks like we hit an error
						logger.error('Error retrieving current project data from server: data was undefined');
						reject(new Error('No data from search for projects'));
					}
					if (data && data.numFound > 0) {
						var _iteratorNormalCompletion2 = true;
						var _didIteratorError2 = false;
						var _iteratorError2 = undefined;
	
						try {
							for (var _iterator2 = data.documents[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
								var doc = _step2.value;
	
								var document = doc.document;
								// check for on hold pending item
								if (document.status === "in-progress" && typeof document.targetDate === 'undefined' && document.kind.includes('publishing-job')) {
									(function () {
										logger.info(" fetched on-hold document name: " + document.name);
										var titleString = 'Open the publishing job to schedule it.';
										var displayName = document.creator || document.creatorId;
										var bodyEntry = { bodyTitle: document.name, bodyEntryName: displayName, bodyEntryCreatorId: document.creatorId, /*bodyEntryCount: document.itemCount, time:bodyDateString,*/bodyId: document.id, bodyKind: document.kind };
										var match = entriesOnHold.find(function (element) {
											return element.title === titleString;
										});
										if (!match) {
											var bodyArray = [];
											bodyArray.push(bodyEntry);
											entriesOnHold.push({ title: titleString, body: bodyArray });
										} else {
											var _bodyArray2 = match.body;
											_bodyArray2.push(bodyEntry);
										}
									})();
								}
							}
						} catch (err) {
							_didIteratorError2 = true;
							_iteratorError2 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion2 && _iterator2.return) {
									_iterator2.return();
								}
							} finally {
								if (_didIteratorError2) {
									throw _iteratorError2;
								}
							}
						}
					}
	
					// lookup the id of the current user
					userProfileService.getCurrentUserData().then(function (data) {
						return data.id;
					}).then(function (userId) {
						homepageUtil.getPublishingAtAGlancePreferences().then(function (userPrefs) {
							var filteredContent = $filter('publishingPreferencesFilter')(entriesOnHold, userPrefs, userId);
							resolve(filteredContent);
						});
					});
				});
			});
		}
	
		/**
	 * Returns a promise to the JSON for the successfully completed publishing jobs
	 * @return {Promise}
	 */
		function getCurrentPublished() {
	
			var entriesPublished = [];
	
			return new Promise(function (resolve, reject) {
				shellUtil.getProjects(false).then(
				//authSearchService.getSearchResults(publishingQuery).then(
				function (res) {
					return res;
				}, function (error) {
					logger.error('Error retrieving current search publishing data from server: ' + JSON.stringify(error));
					reject(error);
				}).then(function (data) {
					if (typeof data === 'undefined') {
						// looks like we hit an error
						logger.error('Error retrieving current project data from server: data was undefined');
						reject(new Error('No data from search for projects'));
					}
					if (data && data.numFound > 0) {
						var _iteratorNormalCompletion3 = true;
						var _didIteratorError3 = false;
						var _iteratorError3 = undefined;
	
						try {
							for (var _iterator3 = data.documents[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
								var doc = _step3.value;
	
								var document = doc.document;
								if (document.status === "complete" || document.status === "published") {
									(function () {
										var completed = document.completed || document.published || document.created;
										logger.info(" got document completed date: " + completed);
										var completedDate = new Date(completed);
										var timeString = completedDate.toLocaleTimeString(homepageUtil.getCurrentLocale().replace('_', '-'), timeOptions);
										// store with each body entry the detailed time for sorting
										//let bodyDateString = "" + completedDate.getTime();
										// now normalize all completed dates to same
										//completedDate.setHours(0,0,0,0);
										var dateString = "" + completedDate.getTime();
										var titleString = completedDate.toLocaleDateString(homepageUtil.getCurrentLocale().replace('_', '-'), options);
										var displayName = document.creator || document.creatorId;
										var bodyEntry = { bodyTitle: document.name, bodyEntryName: displayName, bodyEntryCreatorId: document.creatorId, bodyEntryCount: document.itemCount, time: dateString, bodyId: document.id, bodyKind: document.kind };
										var match = entriesPublished.find(function (element) {
											return element.date === dateString;
										});
										if (!match) {
											var bodyArray = [];
											bodyArray.push(bodyEntry);
											entriesPublished.push({ date: dateString, title: titleString, time: timeString, body: bodyArray });
										} else {
											var _bodyArray3 = match.body;
											_bodyArray3.push(bodyEntry);
										}
									})();
								}
							}
						} catch (err) {
							_didIteratorError3 = true;
							_iteratorError3 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion3 && _iterator3.return) {
									_iterator3.return();
								}
							} finally {
								if (_didIteratorError3) {
									throw _iteratorError3;
								}
							}
						}
					}
	
					// lookup the id of the current user
					userProfileService.getCurrentUserData().then(function (data) {
						return data.id;
					}).then(function (userId) {
						homepageUtil.getPublishingAtAGlancePreferences().then(function (userPrefs) {
							var filteredContent = $filter('publishingPreferencesFilter')(entriesPublished, userPrefs, userId);
							resolve(filteredContent);
						});
					});
				});
			});
		}
	
		// return public API for the REST factory
		return {
			getCurrentPending: getCurrentPending,
			getCurrentOnHold: getCurrentOnHold,
			getCurrentPublished: getCurrentPublished
		};
	}];

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _logging = __webpack_require__(11);
	
	var logger = (0, _logging.createLogger)('publishing-error-service');
	
	module.exports = ['$http', '$q', '$filter', 'homepageUtil', 'shellUtil', 'userProfileService', function ($http, $q, $filter, homepageUtil, shellUtil, userProfileService) {
	
		/**
	 * Returns a promise to the JSON for the current publishing errors
	 * @return {Promise}
	 */
		function getCurrentErrors() {
			var entriesError = [];
	
			return new Promise(function (resolve, reject) {
				shellUtil.getProjects(true).then(function (res) {
					return res;
				}, function (error) {
					logger.error('Error retrieving current search publishing data from server: ' + JSON.stringify(error));
					reject(error);
				}).then(function (data) {
					if (typeof data === 'undefined') {
						logger.error('Error retrieving current project data from server: data was undefined');
						reject(new Error('No data from search for projects'));
					}
					if (data && data.numFound > 0) {
						var _iteratorNormalCompletion = true;
						var _didIteratorError = false;
						var _iteratorError = undefined;
	
						try {
							for (var _iterator = data.documents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
								var doc = _step.value;
	
								var document = doc.document;
								if (document.status === "failed") {
									logger.info(" got document name: " + document.name);
									if (document.name) {
										(function () {
											//let targetDate = new Date(document.targetDate);
											//let timeString = targetDate.toLocaleTimeString(homepageUtil.getCurrentLocale().replace('_', '-'), timeOptions);
											// store with each body entry the detailed time for sorting
											//let bodyDateString = "" + targetDate.getTime();
											// now normalize all target dates to same
											//targetDate.setHours(0,0,0,0);
											//let dateString = "" + targetDate.getTime();
											//let titleString = targetDate.toLocaleDateString(homepageUtil.getCurrentLocale().replace('_', '-'), options);
											var titleString = 'Publishing failed';
											var displayName = document.creator || document.creatorId;
											var bodyEntry = { bodyTitle: document.name, bodyEntryName: displayName, bodyEntryCreatorId: document.creatorId, /*bodyEntryCount: document.itemCount, time:bodyDateString,*/bodyId: document.id, bodyKind: document.kind };
											var match = entriesError.find(function (element) {
												return element.title === titleString;
											});
											if (!match) {
												var bodyArray = [];
												bodyArray.push(bodyEntry);
												entriesError.push({ /*date:dateString,*/title: titleString, /*time:timeString,*/body: bodyArray });
											} else {
												var _bodyArray = match.body;
												_bodyArray.push(bodyEntry);
											}
										})();
									}
								}
							}
						} catch (err) {
							_didIteratorError = true;
							_iteratorError = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion && _iterator.return) {
									_iterator.return();
								}
							} finally {
								if (_didIteratorError) {
									throw _iteratorError;
								}
							}
						}
					}
	
					// lookup the id of the current user
					userProfileService.getCurrentUserData().then(function (data) {
						return data.id;
					}).then(function (userId) {
						homepageUtil.getPublishingAtAGlancePreferences().then(function (userPrefs) {
							var filteredContent = $filter('publishingPreferencesFilter')(entriesError, userPrefs, userId);
							resolve(filteredContent);
						});
					});
				});
			});
		}
	
		/**
	 * Returns a promise to the JSON for the current error count
	 * @return {Promise}
	 */
		function getCurrentErrorCount() {
			return new Promise(function (resolve, reject) {
				getCurrentErrors().then(function (data) {
					var ctr = 0;
					if (data.length > 0) {
						data.forEach(function (entry) {
							ctr += entry.body.length;
						});
					}
					resolve({ count: ctr });
				}, function (error) {
					logger.error('Error: ' + JSON.stringify(error));
					resolve({ count: 0 });
				});
			});
		}
	
		// return public API for the REST factory
		return {
			getCurrentErrors: getCurrentErrors,
			getCurrentErrorCount: getCurrentErrorCount
		};
	}];

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = ['$http', '$q', function ($http, $q) {
	
		var searchURL = '/api/authoring/v1/search';
	
		/**
	 * Returns a promise to the JSON for the search results
	 * @param {String} query
	 * @return {Promise}
	 */
		function getSearchResults(query) {
			return $http.get(searchURL + query).then(function (res) {
				return res.data;
			}, function (res) {
				return $q.reject(res);
			});
		}
	
		/**
	 * Returns a promise to the JSON for the typeahead search results
	 * @param {String} query
	 * @return {Promise}
	 */
		function getTypeaheadSearchResults(query) {
			return $http.get(searchURL + query).then(function (res) {
				return res.data;
			}, function (res) {
				return $q.reject(res);
			});
		}
	
		// return public API for the REST factory
		return {
			getSearchResults: getSearchResults,
			getTypeaheadSearchResults: getTypeaheadSearchResults
		};
	}];

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _logging = __webpack_require__(11);
	
	var logger = (0, _logging.createLogger)('downloadInfo-service');
	
	module.exports = ['$http', '$q', function ($http, $q) {
	
	    var SPA_info_Url = '/api/infra/v1/info';
	    var Oslo_info_Url = '/api/infra/v1/info/sample-oslo';
	    var Stockholm_info_Url = '/api/infra/v1/info/sample-stockholm';
	    var SPA_deploy_Url = '/api/infra/v1/deploy';
	    var Oslo_deploy_Url = '/api/infra/v1/deploy/sample-oslo';
	    var Stockholm_deploy_Url = '/api/infra/v1/deploy/sample-stockholm';
	
	    /**
	    * Returns a promise to the JSON for the info of the newest Oslo/Stockholm template package that is available for download
	    * @param template_name name. e.g.Oslo, Stockholm. If template_name is null, the backend API will decide the sample to show based on your tenant
	    * @return {Promise}
	    */
	    // return the date of latest available sample (stockholm and oslo, or others based on tenant)
	    function getDownloadInfo(template_name) {
	        var infoUrl = !template_name ? SPA_info_Url : template_name === 'stockholm' ? Stockholm_info_Url : Oslo_info_Url;
	        return $http.get(infoUrl).then(function (res) {
	            return res.data;
	        }, function (res) {
	            return $q.reject(res.status + ' :: ' + res.statusText);
	        }
	        // todo - should use res.data.errors[0].message here for more details on missing collection?
	        );
	    }
	
	    /**
	     * Returns a promise to the JSON for the SPA build date and its sample name, e.g. Oslo, Stockholm
	     * @param domain_name, tenantID
	     * @return {Promise}
	     */
	    // return build date of installed sample (Oslo and Stockholm)
	    function getSiteBuildDate(domain_name, tenantID) {
	        var dateURL = 'https://' + domain_name + '/api/' + tenantID + '/delivery/v1/resources?path=/buildDate.json';
	        return $http.get(dateURL).then(function (res) {
	            return res.data;
	        }, function (res) {
	            return $q.reject(res.status + ' :: ' + res.statusText);
	        });
	    }
	
	    /**
	     * Kicks off Deploy API to delete all your content and deploy the newest sample(Stockholm, Oslo) to your tenant 
	    * @param template_name name. e.g.Oslo, Stockholm. If template_name is null, the backend API will decide the sample to show based on your tenant
	     * @return {Promise}
	     */
	    function getDeploySite(template_name) {
	        var deployUrl = !template_name ? SPA_deploy_Url : template_name === 'stockholm' ? Stockholm_deploy_Url : Oslo_deploy_Url;
	        return $http.get(deployUrl).then(function (res) {
	            return res.data;
	        }, function (res) {
	            return $q.reject(res.status + ' :: ' + res.statusText);
	        }
	        // todo - should use res.data.errors[0].message here for more details on missing collection?
	        );
	    }
	
	    // return public API for the REST factory
	    return {
	        getDownloadInfo: getDownloadInfo,
	        getSiteBuildDate: getSiteBuildDate,
	        getDeploySite: getDeploySite
	    };
	}];

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _logging = __webpack_require__(11);
	
	var logger = (0, _logging.createLogger)('shell-data-homepage-service');
	
	module.exports = ['$http', '$q', function ($http, $q) {
		// NOSONAR
	
		var whatsNewURL = '/api/ui-interface/v1/whats-new';
	
		// This module will be used rather than going directly with shellDataService as we want to
		// only track preference data and keep this cached promise independent of the other data used
		// with shell-ui functionality
		//
		// We were forced to use the shell-data whats-new endpoint as new databases aren't allowed in 
		// WCH and homepage data was left out like a second-class passenger that missed the boat
		var whatsNewPromise = null;
	
		/**
	  * Retrieve widget preference data for the current user.
	  *
	  * @returns {*}
	  */
		function getWhatsNewData() {
			if (!whatsNewPromise) {
				whatsNewPromise = $http.get(whatsNewURL).then(function (res) {
					logger.info('Received whats new data for the current user:' + JSON.stringify(res.data));
					return res.data;
				}, function (res) {
					return $q.reject(res.status + ': ' + res.statusText);
				});
			}
			return whatsNewPromise;
		}
	
		/**
	  * Set widget preference data for the current user.
	  * This is now a generic function to store the whats-new data.
	  * @param {Object} settings, this object stores the user preferences.
	  * @returns {*}
	  */
		function setWhatsNewData() {
			var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
			whatsNewPromise = null;
			// do not post without settings as this will update the whats-new timestamp
			if (settings !== {}) {
				return $http.post(whatsNewURL, settings).then(function (res) {
					return $q.resolve(res);
				}, function (res) {
					return $q.reject(res.status + ': ' + res.statusText);
				});
			} else {
				Promise.reject(new Error('settings was empty, need to supply widget preference data'));
			}
		}
	
		// return public API for the REST factory
		return {
			getUserPreferences: getWhatsNewData,
			setUserPreferences: setWhatsNewData
		};
	}];

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _logging = __webpack_require__(11);
	
	var logger = (0, _logging.createLogger)('shutterstock-service');
	
	module.exports = ['$http', '$q', function ($http, $q) {
	
		var enabledURL = '/api/shutterstock/v1/enabled?detail=entitlement';
	
		/**
	 * Returns a promise to the JSON if Shutterstock service is available for current tenant. If it is enabled, it will return the license and usage of shutterstock account
	 * @param null
	 * @return {Promise}
	 */
		// return the license and usage of shutterstock
		function getShutterstockEnabled() {
			return $http.get(enabledURL).then(function (res) {
				return res.data;
			}, function (res) {
				return $q.reject(res.status + ' :: ' + res.statusText);
			}, function (err) {
				logger.error(err);
			});
		}
	
		// return public API for the REST factory
		return {
			getShutterstockEnabled: getShutterstockEnabled
		};
	}];

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _logging = __webpack_require__(11);
	
	var logger = (0, _logging.createLogger)('publishing-preferences-filter');
	
	module.exports = [function () {
	
	    // Filter the publishing job entries based on the current preferences setting
	    return function (entries, preferences, userId) {
	        // only use this filter for my publishing events versus all publishing events
	        var userPreferences = { onlyMyEvents: true, maxDaysToShow: 99999, maxEventsToShow: 99999 };
	        //let userPreferences = {onlyMyEvents: true, maxDaysToShow: 5, maxEventsToShow: 8};
	        if (preferences && Object.keys(preferences).length > 0) {
	            userPreferences.onlyMyEvents = preferences.onlyMyEvents;
	            //userPreferences = preferences;
	        }
	        var filteredEntries = []; // NOSONAR, not constant
	
	        entries.forEach(function (entry) {
	            // test if only showing entries for this user
	            var shouldSkip = false;
	            if (userId && userPreferences.onlyMyEvents === true) {
	                // remove all body entries not created by this user 
	                for (var index = entry.body.length - 1; index >= 0; index--) {
	                    if (userId !== entry.body[index].bodyEntryCreatorId) {
	                        entry.body.splice(index, 1);
	                    }
	                }
	                // if we removed all body entries, then skip this entry altogether
	                if (entry.body.length === 0) {
	                    shouldSkip = true;
	                }
	            }
	            if (shouldSkip === false) {
	                // each entry corresponds to one day
	                if (filteredEntries.length < userPreferences.maxDaysToShow) {
	
	                    // ensure the body array with the events is below the pref setting
	                    entry.body = entry.body.slice(0, userPreferences.maxEventsToShow);
	
	                    filteredEntries.push(entry);
	                }
	            }
	        });
	
	        return filteredEntries;
	    };
	}];

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(21);
	__webpack_require__(22);
	__webpack_require__(23);
	
	var MODULE_NAME = 'homepage.contentUI.tabs';
	
	angular.module(MODULE_NAME, ['authoring.bootstrap.tabs', 'authoring/template/tabs/tab.html', 'authoring/template/tabs/tabset.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("authoring/template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("authoring/template/tabs/tab.html", "<li role=\"presentation\" ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"authoring-tab nav-item\">\n" + "  <a role=\"tab\" id=\"link-{{index}}\" href ng-click=\"select($event)\" ng-keydown=\"keydown($event)\" class=\"nav-link\" tabindex=\"{{ active ? 0 : -1 }}\" authoring-tab-heading-transclude>{{heading}}</a>\n" + "</li>\n" + "");
	}]);

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("authoring/template/tabs/tabset.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("authoring/template/tabs/tabset.html", "<div>\n" + "  <div class=\"tab-nav\">\n" + "    <button type=\"button\" class=\"nav-dir\" ng-style=\"tabset.arrayStyle\" ng-disabled=\"!tabset.hasPrev\" ng-click=\"tabset.selectPrev($event)\" aria-hidden=\"true\" aria-labelledby=\"previous-tab-label\">\n" + "      <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n" + "        <title id=\"previous-tab-label\">{{ \"Previous tab\" | translate }}</title>\n" + "        <path d=\"M9.5 4l-4 4l4 4\"/>\n" + "        <path d=\"M1 8a7 7 0 1 0 14 0a7 7 0 1 0 -14 0\"/>\n" + "      </svg>\n" + "    </button>\n" + "    <div class=\"tab-nav-slider\" ng-class=\"{'left-fade': tabset.hasPrev, 'right-fade': tabset.hasNext}\">\n" + "      <ul role=\"tablist\" class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" style=\"transform: translateX({{tabset.offset}}px);\" ng-transclude></ul>\n" + "    </div>\n" + "    <button type=\"button\" class=\"nav-dir\" ng-style=\"tabset.arrayStyle\" ng-disabled=\"!tabset.hasNext\" ng-click=\"tabset.selectNext($event)\" aria-hidden=\"true\" aria-labelledby=\"next-tab-label\">\n" + "      <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n" + "        <title id=\"next-tab-label\">>{{ \"Next tab\" | translate }}</title>\n" + "        <path d=\"M6.5 4l4 4l-4 4\"/>\n" + "        <path d=\"M1 8a7 7 0 1 0 14 0a7 7 0 1 0 -14 0\"/>\n" + "      </svg>\n" + "    </button>\n" + "  </div>\n" + "  <div class=\"tab-content\">\n" + "    <div class=\"tab-pane\"\n" + "         ng-repeat=\"tab in tabset.tabs\"\n" + "         ng-class=\"{active: tabset.active === tab.index}\"\n" + "         authoring-tab-content-transclude=\"tab\">\n" + "    </div>\n" + "  </div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('authoring.bootstrap.tabs', []).controller('AuthoringTabsetController', ['$scope', '$interval', function ($scope, $interval) {
	  var ctrl = this,
	      oldIndex;
	  ctrl.tabs = [];
	  ctrl.arrayStyle = { visibility: "hidden" };
	  ctrl.totalWidth = 0;
	  ctrl.arrayVPromise = null;
	  ctrl.resizeListener = function (event) {
	    ctrl.updateArrowsVisibility();
	    $scope.$digest();
	  };
	
	  // iVeBeenDismissed
	  $scope.$on('$destroy', function () {
	    window.removeEventListener("resize", ctrl.resizeListener);
	    $interval.cancel(ctrl.arrayVPromise);
	  });
	
	  // readyToTrick
	  $scope.$on('$includeContentLoaded', function () {
	    window.addEventListener("resize", ctrl.resizeListener);
	  });
	
	  ctrl.select = function (index, evt) {
	    if (!destroyed) {
	      var previousIndex = findTabIndex(oldIndex);
	      var previousSelected = ctrl.tabs[previousIndex];
	      if (previousSelected) {
	        previousSelected.tab.onDeselect({
	          $event: evt,
	          $selectedIndex: index
	        });
	        if (evt && evt.isDefaultPrevented()) {
	          return;
	        }
	        previousSelected.tab.active = false;
	      }
	
	      var selected = ctrl.tabs[index];
	      if (selected) {
	        selected.tab.onSelect({
	          $event: evt
	        });
	        selected.tab.active = true;
	        ctrl.active = selected.index;
	        oldIndex = selected.index;
	        ctrl.updateOffset(index);
	        ctrl.updateArrows();
	        ctrl.updateArrowsVisibility();
	      } else if (!selected && angular.isDefined(oldIndex)) {
	        ctrl.active = null;
	        oldIndex = null;
	      }
	    }
	  };
	
	  // contentUI: added method
	  ctrl.selectPrev = function (evt) {
	    var index = ctrl.findPrevEnabled();
	    if (index === undefined) {
	      // Try loop around
	      index = ctrl.findLastEnabled();
	    }
	    if (index !== undefined) {
	      setTimeout(function () {
	        ctrl.tabs[index].tab.focus(evt);
	      }, 500);
	      ctrl.select(index, evt);
	    }
	  };
	
	  // contentUI: added method
	  ctrl.selectNext = function (evt) {
	    var index = ctrl.findNextEnabled();
	    if (index === undefined) {
	      // Try loop around
	      index = ctrl.findFirstEnabled();
	    }
	    if (index !== undefined) {
	      setTimeout(function () {
	        ctrl.tabs[index].tab.focus(evt);
	      }, 500);
	      ctrl.select(index, evt);
	    }
	  };
	
	  // contentUI: added method
	  ctrl.findFirstEnabled = function () {
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (!ctrl.tabs[i].tab.disabled) {
	        return i;
	      }
	    }
	    return undefined;
	  };
	
	  // contentUI: added method
	  ctrl.findLastEnabled = function () {
	    for (var i = ctrl.tabs.length - 1; i >= 0; i--) {
	      if (!ctrl.tabs[i].tab.disabled) {
	        return i;
	      }
	    }
	    return undefined;
	  };
	
	  // contentUI: added method
	  ctrl.findPrevEnabled = function () {
	    var enabled = undefined;
	    for (var i = 0; i < ctrl.tabs.length && ctrl.tabs[i].index !== ctrl.active; i++) {
	      if (!ctrl.tabs[i].tab.disabled) {
	        enabled = i;
	      }
	    }
	    return i < ctrl.tabs.length ? enabled : undefined;
	  };
	
	  // contentUI: added method
	  ctrl.findNextEnabled = function () {
	    var enabled = undefined;
	    for (var i = ctrl.tabs.length - 1; i >= 0 && ctrl.tabs[i].index !== ctrl.active; i--) {
	      if (!ctrl.tabs[i].tab.disabled) {
	        enabled = i;
	      }
	    }
	    return i >= 0 ? enabled : undefined;
	  };
	
	  // contentUI: added method
	  ctrl.updateArrows = function () {
	    ctrl.hasPrev = ctrl.findPrevEnabled() !== undefined;
	    ctrl.hasNext = ctrl.findNextEnabled() !== undefined;
	  };
	
	  /**
	   *  Authoring UI: added method,
	   *  Update the visibility of the arrows
	   *  when all tabs are visible, hide both arrows
	   */
	  ctrl.updateArrowsVisibility = function () {
	    if (ctrl.tabs.length > 0) {
	      if (ctrl.tabs[0] && ctrl.tabs[0].tab && ctrl.tabs[0].tab.parentWidth) {
	        var containerWidth = ctrl.tabs[0].tab.parentWidth();
	        if (containerWidth === 0) {
	          ctrl.arrayVPromise = $interval(ctrl.updateArrowsVisibility, 500, 1);
	        } else {
	          if (ctrl.totalWidth < containerWidth) {
	            ctrl.arrayStyle.visibility = "hidden";
	          } else {
	            ctrl.arrayStyle.visibility = "visible";
	          }
	        }
	      }
	    }
	  };
	
	  /**
	   *  Authoring UI: added method,
	   *  Updatet the offset of the tabs, and calculate the totalWidth of all tabs
	   *  Note: Must be called before 'updateArrowsVisibility'
	   */
	  ctrl.updateOffset = function (index) {
	    if (!ctrl.tabs[index]) {
	      return;
	    }
	    ctrl.totalWidth = 0;
	    var baseOffset = 0;
	    var margins = [0];
	    var widths = [];
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      var tab = ctrl.tabs[i].tab;
	      margins[i] += tab.elementMarginLeft();
	      widths[i] = tab.elementWidth();
	      margins[i + 1] = tab.elementMarginRight();
	
	      ctrl.totalWidth += margins[i] + widths[i];
	      if (i <= index) {
	        baseOffset += margins[i] + widths[i];
	      }
	    }
	    baseOffset -= widths[index] / 2;
	    ctrl.totalWidth += margins[ctrl.tabs.length];
	    var containerWidth = ctrl.tabs[index].tab.parentWidth();
	
	    if (ctrl.totalWidth < containerWidth || baseOffset < containerWidth / 2) {
	      ctrl.offset = 0;
	    } else if (ctrl.totalWidth - baseOffset < containerWidth / 2) {
	      ctrl.offset = containerWidth - ctrl.totalWidth;
	    } else {
	      ctrl.offset = containerWidth / 2 - baseOffset;
	    }
	  };
	
	  ctrl.addTab = function (tab) {
	    ctrl.tabs.push({
	      tab: tab,
	      index: tab.index
	    });
	
	    // contentUI: removed sort
	
	    if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {
	      var newActiveIndex = findTabIndex(tab.index);
	      ctrl.select(newActiveIndex);
	    }
	
	    // contentUI: added offset check
	    var index = findTabIndex(ctrl.active);
	    if (index !== undefined) {
	      setTimeout(function () {
	        ctrl.updateOffset(index);
	      }, 250);
	    }
	
	    // contentUI: added arrow check
	    ctrl.updateArrows();
	  };
	
	  ctrl.removeTab = function (tab) {
	    var index;
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].tab === tab) {
	        index = i;
	        break;
	      }
	    }
	
	    if (ctrl.tabs[index].index === ctrl.active) {
	      var newActiveTabIndex = index === ctrl.tabs.length - 1 ? index - 1 : index + 1 % ctrl.tabs.length;
	      ctrl.select(newActiveTabIndex);
	    }
	
	    ctrl.tabs.splice(index, 1);
	  };
	
	  $scope.$watch('tabset.active', function (val) {
	    if (angular.isDefined(val) && val !== oldIndex) {
	      ctrl.select(findTabIndex(val));
	    }
	  });
	
	  var destroyed;
	  $scope.$on('$destroy', function () {
	    destroyed = true;
	  });
	
	  function findTabIndex(index) {
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].index === index) {
	        return i;
	      }
	    }
	  }
	}]).directive('authoringTabset', function () {
	  return {
	    transclude: true,
	    replace: true,
	    scope: {},
	    bindToController: {
	      active: '=?',
	      type: '@'
	    },
	    controller: 'AuthoringTabsetController',
	    controllerAs: 'tabset',
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'authoring/template/tabs/tabset.html';
	    },
	    link: function link(scope, element, attrs) {
	      scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
	      scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
	    }
	  };
	}).directive('authoringTab', ['$parse', function ($parse) {
	  return {
	    require: '^authoringTabset',
	    replace: true,
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'authoring/template/tabs/tab.html';
	    },
	    transclude: true,
	    scope: {
	      heading: '@',
	      index: '=?',
	      classes: '@?',
	      onSelect: '&select', //This callback is called in contentHeadingTransclude
	      //once it inserts the tab's content into the dom
	      onDeselect: '&deselect'
	    },
	    controller: function controller() {
	      //Empty controller so other directives can require being 'under' a tab
	    },
	    controllerAs: 'tab',
	    link: function link(scope, elm, attrs, tabsetCtrl, transclude) {
	      scope.disabled = false;
	      if (attrs.disable) {
	        scope.$parent.$watch($parse(attrs.disable), function (value) {
	          scope.disabled = !!value;
	        });
	      }
	
	      if (angular.isUndefined(attrs.index)) {
	        if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
	          scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function (t) {
	            return t.index;
	          })) + 1;
	        } else {
	          scope.index = 0;
	        }
	      }
	
	      if (angular.isUndefined(attrs.classes)) {
	        scope.classes = '';
	      }
	
	      scope.select = function (evt) {
	        if (!scope.disabled) {
	          var index;
	          for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
	            if (tabsetCtrl.tabs[i].tab === scope) {
	              index = i;
	              break;
	            }
	          }
	
	          tabsetCtrl.select(index, evt);
	        }
	      };
	
	      // contentUI: added method
	      scope.focus = function (evt) {
	        elm.children()[0].focus();
	      };
	
	      // contentUI: added method
	      scope.keydown = function (evt) {
	        if (evt.which === 39 || evt.which === 40) {
	          tabsetCtrl.selectNext();
	        } else if (evt.which === 37 || evt.which === 38) {
	          tabsetCtrl.selectPrev();
	        }
	      };
	
	      // contentUI: added method
	      scope.elementWidth = function () {
	        return elm[0].offsetWidth;
	      };
	
	      // contentUI: added method
	      scope.elementMarginLeft = function () {
	        var style = getComputedStyle(elm[0]);
	        return style.display === "none" ? 0 : parseInt(style.marginLeft);
	      };
	
	      // contentUI: added method
	      scope.elementMarginRight = function () {
	        var style = getComputedStyle(elm[0]);
	        return style.display === "none" ? 0 : parseInt(style.marginRight);
	      };
	
	      // contentUI: added method
	      scope.parentWidth = function () {
	        return elm[0].parentElement.parentElement.clientWidth;
	      };
	
	      tabsetCtrl.addTab(scope);
	      scope.$on('$destroy', function () {
	        tabsetCtrl.removeTab(scope);
	      });
	
	      //We need to transclude later, once the content container is ready.
	      //when this link happens, we're inside a tab heading.
	      scope.$transcludeFn = transclude;
	    }
	  };
	}]).directive('authoringTabHeadingTransclude', function () {
	  return {
	    restrict: 'A',
	    require: '^authoringTab',
	    link: function link(scope, elm) {
	      scope.$watch('headingElement', function (heading) {
	        if (heading) {
	          elm.html('');
	          elm.append(heading);
	        }
	      });
	    }
	  };
	}).directive('authoringTabContentTransclude', function () {
	  return {
	    restrict: 'A',
	    require: '^authoringTabset',
	    link: function link(scope, elm, attrs) {
	      var tab = scope.$eval(attrs.authoringTabContentTransclude).tab;
	
	      //Now our tab is ready to be transcluded: both the tab heading area
	      //and the tab content area are loaded.  Transclude 'em both.
	      tab.$transcludeFn(tab.$parent, function (contents) {
	        angular.forEach(contents, function (node) {
	          if (isTabHeading(node)) {
	            //Let tabHeadingTransclude know.
	            tab.headingElement = node;
	          } else {
	            elm.append(node);
	          }
	        });
	      });
	    }
	  };
	
	  function isTabHeading(node) {
	    return node.tagName && (node.hasAttribute('authoring-tab-heading') || node.hasAttribute('data-authoring-tab-heading') || node.hasAttribute('x-authoring-tab-heading') || node.tagName.toLowerCase() === 'authoring-tab-heading' || node.tagName.toLowerCase() === 'data-authoring-tab-heading' || node.tagName.toLowerCase() === 'x-authoring-tab-heading' || node.tagName.toLowerCase() === 'authoring:tab-heading');
	  }
	});

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('HomepageServices').component('homepageMainContainer', __webpack_require__(25)).config(__webpack_require__(31));

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var template = __webpack_require__(26);
	__webpack_require__(27);
	var logger = __webpack_require__(11);
	
	var MainContainerController = function () {
		function MainContainerController($scope, $stateParams, userProfileService, homepageDataService, tenantRegistryService, shellUtil, shutterstockService) {
			var _this = this;
	
			_classCallCheck(this, MainContainerController);
	
			this.homepageDataService = homepageDataService;
			this.shutterstockService = shutterstockService;
			this.shellUtil = shellUtil;
			this.$scope = $scope;
	
			this.readMoreLink = 'https://www.ibm.com/blogs/watson-customer-engagement/2018/05/17/ibm-shutterstock-ai-building-engaging-digital-experiences-just-got-easier/';
			this.isLayoutFetched = false;
	
			this.isAboutPage = $stateParams.about;
	
			// lookup the id of the current user
			userProfileService.getCurrentUserData().then(function (data) {
				//const userId = data.id;
				var userRole = data.roles[0];
	
				// get the WCH tier we are running
				tenantRegistryService.getTenantInformation().then(function (tenantData) {
	
					_this.fetchLayout(userRole, tenantData.tier);
				}, function (error) {
					logger.error('Error retrieving tenant tier info from server: ' + error.Error);
				});
			}, function (error) {
				logger.error('Error retrieving current user id data from server: ' + error);
			});
	
			// temporarily default to no layout until promise is delivered
			$scope.layout = [];
		}
	
		_createClass(MainContainerController, [{
			key: 'fetchLayout',
			value: function fetchLayout(userRole, tier) {
				var _this2 = this;
	
				var showPubGlance = true;
				var showShutterstockWidgets = true;
				var isAboutPageToggleEnabled = this.shellUtil.isToggleOn('aboutPage');
	
				//Check if shutterstock license is available for this tenant
				return this.shutterstockService.getShutterstockEnabled().then(function (data) {
					// Bootstrap shutterstock widgets if you have shutterstock license and not in Trial tenant
					if (tier !== 'Trial' && data && data.licenses && data.enabled === true && data.licenses.length === 2) {
						var image_level = data.licenses[0].level;
						var footage_level = data.licenses[1].level;
						_this2.$scope.layout = _this2.homepageDataService.getUserLayout(userRole, tier.toLowerCase(), showPubGlance, showShutterstockWidgets, image_level, footage_level, isAboutPageToggleEnabled);
						_this2.isLayoutFetched = true;
						return true;
					}
					// Don't load shutterstock widgets if you don't have license or in Trial
					else {
							_this2.$scope.layout = _this2.homepageDataService.getUserLayout(userRole, tier.toLowerCase(), showPubGlance, false, null, null, isAboutPageToggleEnabled);
							_this2.isLayoutFetched = true;
							return false;
						}
				}, function (error) {
					logger.error('Error retrieving shutterstock info: ' + error);
					// get the layout for that user
					_this2.$scope.layout = _this2.homepageDataService.getUserLayout(userRole, tier.toLowerCase(), showPubGlance, false, null, null, isAboutPageToggleEnabled);
					_this2.isLayoutFetched = true;
					return false;
				});
			}
		}]);
	
		return MainContainerController;
	}();
	
	;
	
	module.exports = {
		templateUrl: template,
		controller: ["$scope", "$stateParams", "userProfileService", "homepageDataService", "tenantRegistryService", "shellUtil", "shutterstockService", MainContainerController]
	};

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	var path = '/authoring-homepage-ui/mainContainer/mainContainer.html';
	var html = "<div id=topHomepageContainer> <div ng-if=!$ctrl.isAboutPage class=top-search-wrapper> <homepage-widget id=search_ad_2 wtype=component class=one-col wtitle=\"\" wsubtitle=\"\" wcomponent=search /> </div> <div class=top-wrapper ng-if=\"layout.length > 0\"> <div ng-repeat=\"x in layout\" class=repeat-layout ng-class=\"{'one-third':$ctrl.isAboutPage && x.type==='column' && x.colClass==='column'}\"> <div ng-if=\"x.type==='column'\" class={{x.colClass}}> <div ng-if=\"y.type==='row'\" class={{y.rowClass}} ng-repeat=\"y in x.children\"> <homepage-widget ng-if=\"z.type==='component'\" ng-repeat=\"z in y.children\" id={{z.id}} wtype={{z.type}} class={{z.colClass}} wtitle={{z.title}} wsubtitle={{z.subtitle}} wcomponent={{z.component}} /> </div> <homepage-widget ng-if=\"y.type==='component'\" ng-repeat=\"y in x.children\" id={{y.id}} wtype={{y.type}} class={{y.colClass}} wtitle={{y.title}} wsubtitle={{y.subtitle}} wcomponent={{y.component}} /> </div> </div> </div> <div class=\"top-wrapper empty-page\" ng-if=\"$ctrl.isAboutPage && $ctrl.isLayoutFetched && layout.length === 0\"> <div class=empty-page-text> <div> <span>{{\"Monitor usage details on your Shutterstock add-on. If Shutterstock is disabled, this page will be empty\" | translate}}</span> <div> <a href={{$ctrl.readMoreLink}} target=_blank>{{\"Read more\" | translate}}</a> </div> </div> </div> </div> </div> <svg xmlns=http://www.w3.org/2000/svg style=position:absolute;width:0;height:0;visibility:hidden> <defs> <symbol id=hubInfoIcon viewBox=\"0 0 17 17\"> <path d=\"M5.793 5.447a.345.345 0 0 0-.24.594l5.406 5.406a.345.345 0 1 0 .488-.488L6.041 5.553a.345.345 0 0 0-.248-.106z\" overflow=visible /> <path d=\"M4.639 8.154a.346.346 0 1 0 0 .692h7.722a.346.346 0 1 0 0-.692z\" overflow=visible /> <path d=\"M8.494 4.29a.345.345 0 0 0-.34.349v7.722a.346.346 0 1 0 .692 0V4.64a.345.345 0 0 0-.352-.35z\" overflow=visible /> <path d=\"M11.197 5.45a.345.345 0 0 0-.238.103l-5.406 5.406a.345.345 0 1 0 .488.488l5.406-5.406a.345.345 0 0 0-.25-.592zM8.5.154a1.724 1.724 0 1 0-.001 3.448A1.724 1.724 0 0 0 8.5.154zm0 .692c.592 0 1.035.441 1.035 1.033A1.01 1.01 0 0 1 8.5 2.914 1.01 1.01 0 0 1 7.465 1.88c0-.592.443-1.033 1.035-1.033zM3.813 2.06a1.6 1.6 0 0 0-1.186.522c-.674.68-.682 1.782.012 2.414.68.671 1.78.678 2.412-.014.633-.642.626-1.711.01-2.396a.345.345 0 0 0-.014-.012c-.341-.34-.791-.514-1.234-.513zm.007.686c.256 0 .52.106.729.31.368.417.362 1.098.012 1.448a.345.345 0 0 0-.014.014c-.36.4-1.008.408-1.43-.014a.345.345 0 0 0-.013-.012c-.401-.36-.408-1.01.013-1.431a.345.345 0 0 0 .012-.012.92.92 0 0 1 .691-.303zM1.879 6.775a1.724 1.724 0 1 0-.002 3.448 1.724 1.724 0 0 0 .002-3.448zm0 .69A1.01 1.01 0 0 1 2.914 8.5 1.01 1.01 0 0 1 1.88 9.535 1.009 1.009 0 0 1 .846 8.5c0-.592.441-1.035 1.033-1.035zM3.807 11.475c-.436 0-.877.155-1.221.464a.345.345 0 0 0-.012.014c-.678.679-.685 1.786.008 2.42.68.674 1.782.682 2.414-.012.671-.68.678-1.78-.014-2.412a1.667 1.667 0 0 0-1.175-.474zm-.006.699a.99.99 0 0 1 .703.265.345.345 0 0 0 .014.014c.4.36.408 1.008-.014 1.43a.345.345 0 0 0-.012.013c-.36.401-1.01.408-1.431-.013a.345.345 0 0 0-.012-.012c-.398-.358-.404-.998.008-1.42.207-.183.478-.277.744-.277zM8.5 13.396a1.724 1.724 0 1 0-.001 3.448 1.724 1.724 0 0 0 .001-3.448zm0 .69a1.01 1.01 0 0 1 1.035 1.035c0 .592-.443 1.033-1.035 1.033a1.009 1.009 0 0 1-1.035-1.033A1.01 1.01 0 0 1 8.5 14.086zM13.137 11.496a1.6 1.6 0 0 0-1.188.522c-.633.642-.626 1.711-.01 2.396a.345.345 0 0 0 .014.012c.679.678 1.786.685 2.42-.008.673-.68.682-1.782-.012-2.414a1.744 1.744 0 0 0-1.224-.508zm.008.684c.26 0 .527.105.738.316a.345.345 0 0 0 .013.012c.401.36.408 1.01-.013 1.431a.345.345 0 0 0-.012.012c-.358.398-.998.404-1.42-.008-.368-.416-.362-1.097-.012-1.447a.345.345 0 0 0 .014-.014.92.92 0 0 1 .692-.302zM15.121 6.775a1.724 1.724 0 1 0-.001 3.448 1.724 1.724 0 0 0 .001-3.448zm0 .69c.592 0 1.033.443 1.033 1.035 0 .592-.441 1.035-1.033 1.035A1.01 1.01 0 0 1 14.086 8.5a1.01 1.01 0 0 1 1.035-1.035zM13.193 2.115c-.44 0-.873.177-1.19.524-.67.68-.677 1.78.015 2.412.642.633 1.711.626 2.396.01a.345.345 0 0 0 .012-.014c.678-.679.685-1.786-.008-2.42a1.741 1.741 0 0 0-1.225-.512zm.008.686c.26 0 .528.105.738.316a.345.345 0 0 0 .012.012c.398.358.404.998-.008 1.42-.416.368-1.097.362-1.447.012a.345.345 0 0 0-.014-.014c-.4-.36-.408-1.008.014-1.43a.345.345 0 0 0 .012-.013c.18-.2.433-.304.693-.303z\" overflow=visible /> </symbol> <symbol id=privacyNoticeIcon viewBox=\"0 0 17 17\"> <path d=\"M1.162.1C.585.1.1.585.1 1.162v14.014c0 .943.781 1.724 1.724 1.724.01 0 .015-.01.024-.01a.4.4 0 0 0 .086.01h13.408c.422 0 .798-.215 1.08-.523.282-.308.478-.73.478-1.201v-1.932c0-.288-.118-.584-.347-.78-.23-.194-.539-.28-.881-.28H14.14V1.162C14.14.585 13.657.1 13.08.1zm0 .8H13.08c.196 0 .262.066.262.262v11.022H3.756c-.277 0-.486.144-.64.332a1.14 1.14 0 0 0-.257.728v1.877c0 .45-.564.979-1.035.979a.949.949 0 0 1-.924-.924V1.162C.9.966.966.9 1.162.9zm2.594 12.082h9.912a.4.4 0 0 0 .139 0h1.865c.21 0 .315.053.361.092.047.04.067.072.067.17v1.932c0 .246-.109.488-.268.662-.16.174-.361.262-.49.262H3.227c.217-.29.431-.596.431-.979v-1.877c0-.098.036-.174.074-.22.039-.047.08-.042.024-.042z\" overflow=visible /> <path d=\"M7.121 2.86A1.51 1.51 0 0 0 5.617 4.36v1.33c-.632.478-1.103 1.134-1.103 1.98A2.618 2.618 0 0 0 7.12 10.28 2.618 2.618 0 0 0 9.73 7.672c0-.847-.472-1.503-1.104-1.98v-1.33a1.51 1.51 0 0 0-1.504-1.503zm0 .798c.389 0 .703.315.703.703v.98h-.04c-.236-.07-.405-.275-.663-.275-.257 0-.427.205-.662.276h-.041v-.98c0-.39.314-.704.703-.704zM6.46 6.141h1.324c.636.28 1.145.793 1.145 1.53A1.81 1.81 0 0 1 7.12 9.48a1.81 1.81 0 0 1-1.807-1.807c0-.738.51-1.251 1.145-1.531z\" overflow=visible /> </symbol> </defs> </svg> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(28);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./mainContainer.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./mainContainer.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)(false);
	// Module
	exports.push([module.id, ".screen-reader-text{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}homepage-main-container{display:flex;flex:1 1 auto;background-color:#F7F7F7}#topHomepageContainer{flex:1 1 auto;width:100%;flex-wrap:wrap;padding:10px}#topHomepageContainer .top-search-wrapper{padding:5px 10px}#topHomepageContainer .top-wrapper{display:flex;background-color:#F7F7F7}#topHomepageContainer .top-wrapper>*{padding:5px 10px}#topHomepageContainer .repeat-layout{display:flex;flex-grow:1;max-width:66%}#topHomepageContainer .one-third{max-width:33%}#topHomepageContainer .column{flex:1;display:flex;flex-direction:column}#topHomepageContainer .two-column{flex:2;display:flex;flex-direction:column}#topHomepageContainer .two-column-row{flex:1;display:flex;flex-direction:row}#topHomepageContainer .comp{display:flex;flex:1;margin-bottom:20px;height:283px;max-height:283px}#topHomepageContainer .comp-left{padding-right:10px}#topHomepageContainer .comp-right{padding-left:10px}#topHomepageContainer .comp.rowspan{flex:2;height:585px;max-height:585px}#topHomepageContainer .comp.colspan{flex:2}#topHomepageContainer .desktop-hidden{visibility:hidden}#topHomepageContainer .tablet-hidden{visibility:visible}#topHomepageContainer .always-hidden{visibility:hidden}#topHomepageContainer .empty-page{height:100%;justify-content:center}#topHomepageContainer .empty-page-text{display:flex;flex-direction:column;justify-content:center;align-items:center;font-size:24px;line-height:26px;margin:30px}#topHomepageContainer .empty-page-text>div{display:flex;flex-grow:2;flex-direction:column;align-items:center;justify-content:center}#topHomepageContainer .empty-page-text span{width:60%;text-align:center;margin-bottom:20px}#topHomepageContainer .empty-page-text a{font-size:14px}@media only screen and (max-width: 978px){#topHomepageContainer .top-wrapper{flex-direction:column}#topHomepageContainer .repeat-layout{max-width:100%}#topHomepageContainer .desktop-hidden{visibility:visible}#topHomepageContainer .tablet-hidden{visibility:hidden}}\n", ""]);
	


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	"use strict";
	
	/*
	  MIT License http://www.opensource.org/licenses/mit-license.php
	  Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function (useSourceMap) {
	  var list = []; // return the list of modules as css string
	
	  list.toString = function toString() {
	    return this.map(function (item) {
	      var content = cssWithMappingToString(item, useSourceMap);
	
	      if (item[2]) {
	        return '@media ' + item[2] + '{' + content + '}';
	      } else {
	        return content;
	      }
	    }).join('');
	  }; // import a list of modules into the list
	
	
	  list.i = function (modules, mediaQuery) {
	    if (typeof modules === 'string') {
	      modules = [[null, modules, '']];
	    }
	
	    var alreadyImportedModules = {};
	
	    for (var i = 0; i < this.length; i++) {
	      var id = this[i][0];
	
	      if (id != null) {
	        alreadyImportedModules[id] = true;
	      }
	    }
	
	    for (i = 0; i < modules.length; i++) {
	      var item = modules[i]; // skip already imported module
	      // this implementation is not 100% perfect for weird media query combinations
	      // when a module is imported multiple times with different media queries.
	      // I hope this will never occur (Hey this way we have smaller bundles)
	
	      if (item[0] == null || !alreadyImportedModules[item[0]]) {
	        if (mediaQuery && !item[2]) {
	          item[2] = mediaQuery;
	        } else if (mediaQuery) {
	          item[2] = '(' + item[2] + ') and (' + mediaQuery + ')';
	        }
	
	        list.push(item);
	      }
	    }
	  };
	
	  return list;
	};
	
	function cssWithMappingToString(item, useSourceMap) {
	  var content = item[1] || '';
	  var cssMapping = item[3];
	
	  if (!cssMapping) {
	    return content;
	  }
	
	  if (useSourceMap && typeof btoa === 'function') {
	    var sourceMapping = toComment(cssMapping);
	    var sourceURLs = cssMapping.sources.map(function (source) {
	      return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
	    });
	    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	  }
	
	  return [content].join('\n');
	} // Adapted from convert-source-map (MIT)
	
	
	function toComment(sourceMap) {
	  // eslint-disable-next-line no-undef
	  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	  var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
	  return '/*# ' + data + ' */';
	}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	'use strict';
	
	// Shell integration: define the child states under the 'prod-authoring-settings-ui' state from the shell
	//					  all states should use dot notation to become children of the parent shell state
	
	module.exports = ['$stateProvider', function ($stateProvider) {
	
		$stateProvider.
		// Default
		state('prod-authoring-homepage-ui.root', {
			url: '',
			template: '<homepage-main-container></homepage-main-container>',
			data: {
				helpPage: {
					editor: 'SS3UMF/dch/admin/manager/editor/home_editor.html',
					manager: 'SS3UMF/dch/admin/manager/home_manager.html',
					admin: 'SS3UMF/dch/admin/home_admin.html'
				},
				actionbar: { actions: [{
						id: 'hubInfo',
						title: 'Hub info',
						icon: '#hubInfoIcon',
						type: 'button',
						handleClick: function handleClick() {
							angular.element(window).trigger('WCH_HUB_INFO');
						}
					}] }
			},
			params: {
				paagTab: null,
				about: false
			}
		}).state('prod-authoring-about-ui.root', {
			url: '',
			template: '<homepage-main-container></homepage-main-container>',
			data: {
				helpPage: {
					editor: 'SS3UMF/dch/admin/manager/editor/home_editor.html',
					manager: 'SS3UMF/dch/admin/manager/home_manager.html',
					admin: 'SS3UMF/dch/admin/home_admin.html'
				},
				actionbar: { actions: [{
						id: 'hubInfo',
						title: 'Hub info',
						icon: '#hubInfoIcon',
						type: 'button',
						handleClick: function handleClick() {
							angular.element(window).trigger('WCH_HUB_INFO');
						}
					}, {
						id: 'privacyNotice',
						title: 'Privacy notice',
						icon: '#privacyNoticeIcon',
						type: 'button',
						handleClick: function handleClick() {
							angular.element(window).trigger('WCH_USER_PREFS');
						}
					}] }
			},
			params: {
				paagTab: null,
				about: true
			}
		});
	}];

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('HomepageServices').component('homepageWidget', __webpack_require__(33));
	//.config(require('./homepage.config.js'));

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var template = __webpack_require__(34);
	__webpack_require__(35);
	var logger = __webpack_require__(11);
	
	// used to create unique id
	var index = 0;
	
	var WidgetController = function () {
		function WidgetController($rootScope, $scope, $compile, $element, $translate, tenantRegistryService, $templateCache, $timeout, homepageUtil, x1UiPopoverConstants) {
			var _this = this;
	
			_classCallCheck(this, WidgetController);
	
			this.$rootScope = $rootScope;
			this.$templateCache = $templateCache;
			this.$translate = $translate;
			this.$timeout = $timeout;
			this.homepageUtil = homepageUtil;
			this.x1UiPopoverConstants = x1UiPopoverConstants;
			this.popoverTitle = 'Preferences';
	
			this.$onInit = function () {
				if (typeof _this.wcomponent !== 'undefined' && _this.wcomponent.trim().length > 0) {
					// create new specified angular component and append it to the widget body element
					var newElement = $compile("<" + _this.wcomponent + "></" + _this.wcomponent + ">")($scope);
					angular.element($element[0].querySelector('.widget-body')).append(newElement);
				}
	
				_this.hasPreferences = false;
				_this.hasTitle = false;
				_this.wTitle = _this.wtitle;
				if (typeof _this.wtitle !== 'undefined') {
					_this.hasTitle = _this.wtitle.length > 0;
					_this.hasSubtitle = _this.wsubtitle.length > 0;
					_this.hubName = "";
					// lookup hub tenant name for widget that needs it in title
					if (_this.wcomponent === 'hub-usage') {
						/*
	     // comment this out until next release when displayable tenant name will be provided
	     // 
	     if (isHubTenantNameSupported) {
	     	tenantRegistryService.getTenantInformation().then(
	     		(data) => {
	     			this.hubName = data.name;
	     		},
	     		(error) => {
	     			logger.error('Error retrieving tenant name from server: ' + error);
	     		}
	     	);
	     }
	     else { */
						_this.wTitle = "Content hub usage";
						//}
					} else if (_this.wcomponent === 'search') {
						// set screen reader label for non-titled Search widget
						_this.wTitle = "ariaSearchBox";
					} else if (_this.wcomponent === 'publishing-at-a-glance') {
						// construct preferences popover
						_this.$templateCache.put('publishingAtAGlancePreferences', '<publishing-at-a-glance-preferences></publishing-at-a-glance-preferences>');
						_this.popover = {
							"title": _this.popoverTitle,
							"placement": "bottom-left",
							"contentTemplate": "publishingAtAGlancePreferences"
						};
						// add preferences icon to widget title
						_this.hasPreferences = true;
					}
				}
	
				_this.isCollapsed = false;
				_this.index = index++;
				_this.ExpandOrCollapse = _this.$translate.instant("Collapse");
	
				// set the translated title on the prefs popover if we have one
				if (_this.hasPreferences) {
					_this.$translate([_this.popoverTitle]).then(function (nls) {
						_this.popover.title = nls[_this.popoverTitle];
					});
				}
			};
	
			// listen for x1 popover close event to restore focus to the prefs button
			$scope.$on(this.x1UiPopoverConstants.CLOSED_POPOVER, function () {
				$scope.$evalAsync(function () {
					var prefsButton = document.querySelector("#" + _this.wcomponent + "-prefs");
					if (prefsButton) {
						prefsButton.focus();
					}
				});
			});
	
			// listen for preferences open event to add a11y label (workaround for x1-popover shortcomings)
			var handler = $rootScope.$on('preferences-open', function (event, payload) {
				var popoverDialog = angular.element(document.querySelector("div.widget-buttons>div.x1-ui-popover"));
				if (popoverDialog) {
					popoverDialog.attr('aria-labelledby', 'x1PopoverTitle');
	
					var popoverInclude = angular.element(document.querySelector("div.widget-buttons>div.x1-ui-popover>ng-include"));
					if (popoverInclude) {
						popoverInclude.attr('aria-labelledby', 'x1PopoverTitle');
					}
				}
			});
			$scope.$on('$destroy', handler);
		}
	
		_createClass(WidgetController, [{
			key: 'resize',
			value: function resize(event) {
				// this routine is called for both keypress and mouse events
				var keycode = this.homepageUtil.getKeyCode(event);
				if (typeof keycode !== 'undefined') {
					// a key was pressed, only accept enter or space 
					if (keycode === 13 || keycode === 32) {
						event.preventDefault();
					} else {
						return;
					}
				}
	
				this.isCollapsed = !this.isCollapsed;
				this.ExpandOrCollapse = this.isCollapsed ? this.$translate.instant("Expand") : this.$translate.instant("Collapse");
			}
		}, {
			key: 'openPreferences',
			value: function openPreferences(event) {
				// only called for keypress events
				// on keypress event, only accept enter or space
				var keycode = this.homepageUtil.getKeyCode(event);
				if (typeof keycode !== 'undefined' && (keycode === 13 || keycode === 32)) {
					var target = event.target;
					event.preventDefault();
					// wait until after current digest cycle
					this.$timeout(function () {
						target.click();
					}, 200);
				}
			}
		}]);
	
		return WidgetController;
	}();
	
	;
	
	module.exports = {
		templateUrl: template,
		bindings: {
			wtitle: "@",
			wsubtitle: "@",
			wcomponent: "@"
		},
		transclude: true,
		controller: ['$rootScope', '$scope', '$compile', '$element', '$translate', "tenantRegistryService", "$templateCache", "$timeout", "homepageUtil", "x1.ui.popover.events", WidgetController]
	};

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	var path = '/authoring-homepage-ui/widget/widget.html';
	var html = "<div class=widget ng-class=\"{'widget-no-title':!$ctrl.hasTitle,'widget-collapsed':$ctrl.isCollapsed}\" role=region aria-labelledby=widget-title-{{$ctrl.index}}> <div ng-class=\"{'titlebar':$ctrl.hasTitle, 'title-no-border':$ctrl.isCollapsed}\"> <div ng-if=$ctrl.hasTitle class=title> <h4 id=widget-title-{{$ctrl.index}} translate={{$ctrl.wTitle}} translate-values={HUBNAME:$ctrl.hubName}></h4> <p class=subtitle ng-class=\"{'subtitle-text':$ctrl.hasSubtitle}\" translate={{$ctrl.wsubtitle}}></p> </div> <div ng-if=!$ctrl.hasTitle class=screen-reader-text> <h4 id=widget-title-{{$ctrl.index}} translate={{$ctrl.wTitle}}></h4> </div> <div class=widget-buttons> <span ng-if=$ctrl.hasPreferences id={{$ctrl.wcomponent}}-prefs role=button class=\"widget-icons glyphicon-gear\" translate ng-class=\"{'glyphicon':$ctrl.hasPreferences, 'hide':!$ctrl.hasPreferences}\" ng-keypress=$ctrl.openPreferences($event) aria-label=\"{{::'Preferences'|translate}}\" tabindex=0 x1-popover=$ctrl.popover outside-click=true content=\"\" scrollable-container=shell-main title=\"{{::'Preferences'|translate}}\" keyboard=true></span> <span class=\"widget-icons widget-spacer\" ng-class=\"{'glyphicon':$ctrl.hasTitle, 'hide':!$ctrl.hasTitle}\"></span> </div> </div> <div id=widget-body-{{$ctrl.index}} class=widget-body> <ng-transclude></ng-transclude> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(36);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./widget.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./widget.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)(false);
	// Module
	exports.push([module.id, ".screen-reader-text{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}#topHomepageContainer a{font-family:'IBM Plex Sans';font-size:14px;color:#1F57A4;text-decoration:none;border-bottom:1px solid}#topHomepageContainer li>a,#topHomepageContainer li>a:hover,#topHomepageContainer li>a:focus{color:black;border-bottom:0}#topHomepageContainer a:hover,#topHomepageContainer a:focus{border-bottom:3px solid}#topHomepageContainer .widget{box-shadow:0px 0px 2px rgba(0,0,0,0.1);background-color:#fff;flex-grow:1;padding-left:10px;padding-right:10px}#topHomepageContainer .widget .titlebar{border-bottom:1px solid #d8d8d8;font-weight:bold;display:flex;justify-content:space-between;padding-top:5px;padding-bottom:5px;background-color:#fff}#topHomepageContainer .widget .titlebar .title{display:flex;flex-flow:column}#topHomepageContainer .widget .titlebar h4{margin-top:0px;margin-bottom:0px}#topHomepageContainer .widget .subtitle{font-size:13px;font-weight:normal;padding:0px;margin-bottom:5px}#topHomepageContainer .widget .subtitle-text{margin-top:10px}#topHomepageContainer .widget .title-no-border{border-bottom:2px solid transparent;margin-bottom:0px;padding-bottom:0px;max-height:30px}#topHomepageContainer .widget .widget-icons{cursor:pointer;border:1px dotted transparent;padding-left:2px;padding-right:2px;padding-top:1px;height:20px}#topHomepageContainer .widget .widget-icons:focus{border:1px dotted black}#topHomepageContainer .widget>*{margin:5px}#topHomepageContainer .widget .widget-buttons{display:flex}#topHomepageContainer .widget .popover-content{max-height:none;padding-top:20px}#topHomepageContainer .widget .widget-spacer{width:16px}#topHomepageContainer .widget-no-title{box-shadow:0px 0px 5px rgba(0,0,0,0.1);padding-left:0;padding-right:0}#topHomepageContainer .widget-collapsed{background-color:#F7F7F7;box-shadow:none}#topHomepageContainer .widget-collapsed .widget-body,#topHomepageContainer .widget-collapsed .subtitle{visibility:hidden}#topHomepageContainer .widget-collapsed #publishing-at-a-glance{display:none}\n", ""]);
	


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('HomepageServices').component('addAssets', __webpack_require__(38));

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var template = __webpack_require__(39);
	__webpack_require__(40);
	__webpack_require__(42);
	var logger = __webpack_require__(11);
	
	// ng-file-upload $error tokens
	var $ERROR_PATTERN = "pattern";
	var $ERROR_MAX_SIZE = "maxSize";
	var $ERROR_MAX_FILES = "maxFiles";
	
	var AddAssetsController = function () {
		function AddAssetsController($scope, $state, assetUploadService, tenantRegistryService, shellUtil) {
			_classCallCheck(this, AddAssetsController);
	
			this.hasError = false;
			this.errorMessages = [];
			this.tenantRegistryService = tenantRegistryService;
			this.shellUtil = shellUtil;
	
			this.state = $state;
			this.assetUploadService = assetUploadService;
	
			// upload icon used for tablet view button
			this.img = __webpack_require__(44);
	
			// Examine the userAgent to tell if we are on a mobile device (no drop zone for that case)
			var isMobile = /android|webos|iphone|ipad|ipod|blackberry|windows phone/.test(navigator.userAgent.toLowerCase());
			$scope.isDesktop = !isMobile;
	
			// Default File restrictions
			this.acceptType = assetUploadService.getFileAcceptType(); // Set accepted or excluded files
			this.maxSize = assetUploadService.getDefaultFileMaxSize(); // Default max size of one file
			//this.getTenantInformation();    // content team no longer wants widget to perform this check
			this.maxFiles = assetUploadService.getMaxFilesPerUpload(); // Max number of files that can be dropped into the widget
			this.maxUploadInstances = assetUploadService.getMaxUploadInstances(); // Max number of asset upload instances that can be active at once
		}
	
		// get the true max size of a file for this tenant
	
	
		_createClass(AddAssetsController, [{
			key: 'getTenantInformation',
			value: function getTenantInformation() {
				var _this = this;
	
				this.assetUploadService.getFileMaxSize().then(function (data) {
					_this.maxSize = data;
					logger.info("addAssets setting max upload size: " + _this.maxSize);
				}, function (error) {
					logger.error('addAssets: Error retrieving tenant max file size information from server: ' + error);
				});
			}
		}, {
			key: 'fileUpload',
			value: function fileUpload(validFiles, invalidFiles) {
				var _this2 = this;
	
				logger.info("AddAssetsController fileUpload entry");
				this.shellUtil.bindAnalytics("e", "WCH Widget Upload Asset", "WCH Widgets");
	
				this.hasError = false;
				this.errorMessages = [];
	
				// Get the number of valid and invalid files reported by the angular upload code
				var numOfValidFiles = 0;
				var numOfInvalidFiles = 0;
	
				if (validFiles && validFiles.length >= 1) {
					logger.info("Valid files found, number of files = " + validFiles.length);
					numOfValidFiles = validFiles.length;
				}
	
				if (invalidFiles && invalidFiles.length >= 1) {
					logger.info("Invalid files found, number of files = " + invalidFiles.length);
					numOfInvalidFiles = invalidFiles.length;
				}
	
				// check for invalid files first
				var maxFilesError = false;
				if (numOfInvalidFiles >= 1) {
					this.hasError = true;
	
					// Only show one error for selecting more than max number of files to upload at once
					invalidFiles.forEach(function (file) {
						if (file.$error === "maxFiles") {
							if (!maxFilesError) {
								// only push one error message for too many files
								maxFilesError = true;
								_this2.errorMessages.push(_this2.getErrorMessage(file));
							}
						}
						// let all the other error message types through
						else {
								_this2.errorMessages.push(_this2.getErrorMessage(file));
							}
					});
	
					// finally check to see if the number of invalid + valid files exceeds the max
					// this is necessary as the upload code in some situations does not report the user 
					// selected too many files (11 files were selected, 2 of them were too big - only reports
					// the error that 2 files were too large)
					if (!maxFilesError && numOfValidFiles + numOfInvalidFiles > this.maxFiles) {
						var errorMessage = {};
						errorMessage.key = "invalidNumberOfFiles";
						errorMessage.fileName = "";
						this.errorMessages.push(errorMessage);
					}
				}
				// nothing invalid so far, so handle valid files
				else if (numOfValidFiles >= 1) {
						// sanity check - don't think the ng file upload code will ever do this
						// seems to always report 1 file as invalid once we exceed max but just in case
						if (numOfValidFiles > this.maxFiles) {
							var errorMessage2 = {};
							errorMessage2.key = "invalidNumberOfFiles";
							errorMessage2.fileName = "";
							this.errorMessages.push(errorMessage2);
						} else {
							// perform last check
							this.verifyUpload(validFiles);
	
							if (!this.hasError) {
								var fileListId = this.assetUploadService.addFileList(validFiles);
								if (fileListId !== null) {
									logger.info("fileListId = " + fileListId);
									this.state.go('authoring.assets.wizard', { "fileListId": fileListId });
								} else {
									logger.error("AddAssetsController.fileUpload: File list id was not created from files ", validFiles);
								}
							}
						}
					}
			}
	
			// the angular file upload code can't validate certain things, so final checks here
	
		}, {
			key: 'verifyUpload',
			value: function verifyUpload(validFiles) {
				var _this3 = this;
	
				// Don't allow files without a file extension (not caught from ng-file-upload)
				validFiles.forEach(function (file) {
					var index = file.name.indexOf(".");
					if (index === -1 || index >= file.name.length - 1) {
						var errorMessage = {};
						errorMessage.key = "invalidFileType";
						errorMessage.fileName = file.name;
						_this3.errorMessages.push(errorMessage);
						_this3.hasError = true;
						logger.info("AddAssetsController.verifyUpload: Invalid file without an extension detected: ", file.name);
					}
				});
	
				// Check for max number of bulk upload instances reached
				var numberOfFileLists = this.assetUploadService.getNumberOfFileLists();
				if (numberOfFileLists >= this.maxUploadInstances) {
					var errorMessageUpload = {};
					errorMessageUpload.key = "You can not upload more assets since there are too many existing asset uploads in process. Please wait until the uploads have finished or cancel them.";
					this.errorMessages.push(errorMessageUpload);
					this.hasError = true;
					logger.info("AddAssetsController.verifyUpload: Too many file uploads currently in process.");
				}
			}
	
			// Examine the file error recorded by ng file upload and return a corresponding error message key
	
		}, {
			key: 'getErrorMessage',
			value: function getErrorMessage(file) {
				var errorMessage = {};
				switch (file.$error) {
					case $ERROR_PATTERN:
						errorMessage.key = "invalidFileType";
						break;
					case $ERROR_MAX_SIZE:
						errorMessage.key = "invalidFileSize";
						break;
					case $ERROR_MAX_FILES:
						errorMessage.key = "invalidNumberOfFiles";
						break;
					default:
						errorMessage.key = "invalidFileDefault";
				}
				// set the filename even though it may not be needed for this particular error message
				errorMessage.fileName = file.name;
				return errorMessage;
			}
	
			// remove the error message specified by the index
	
		}, {
			key: 'clearErrorMessage',
			value: function clearErrorMessage(index) {
				if (this.errorMessages && index < this.errorMessages.length) {
					this.errorMessages.splice(index, 1);
				}
			}
		}]);
	
		return AddAssetsController;
	}();
	
	;
	
	module.exports = {
		templateUrl: template,
		controller: ["$scope", "$state", "assetUploadService", "tenantRegistryService", "shellUtil", AddAssetsController]
	};

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	var path = '/authoring-homepage-ui/addAssets/addAssets.html';
	var html = "<div class=add-assets-wrapper> <div role=alert ng-show=$ctrl.errorMessages ng-repeat=\"message in $ctrl.errorMessages\"> <div class=\"alert alert-danger\"> <span translate={{message.key}} translate-values=\"{FILENAME: message.fileName, MAXSIZE: $ctrl.maxSize, MAXFILES: $ctrl.maxFiles}\"></span> <a href=# class=close data-dismiss=alert aria-label=close ng-click=$ctrl.clearErrorMessage($index);>&times;</a> </div> </div> <div ng-if=isDesktop class=upload-container ngf-drop=\"$ctrl.fileUpload(validFiles, $invalidFiles)\" ng-model=validFiles ngf-model-invalid=$invalidFiles ngf-multiple=true type=file ngf-accept=$ctrl.acceptType ngf-pattern=$ctrl.acceptType ngf-max-files=$ctrl.maxFiles ngf-drag-over-class=\"{pattern: '{{$ctrl.acceptType}}', accept:'acceptClass', reject:'rejectClass', delay:100}\" ng-class=\"{'has-error border-danger': ($ctrl.hasError)}\" name=file> <h2 class=dropMessage translate=\"{{'Drop digital assets'}}\"></h2> <a class=\"link upload-link\" href=# ngf-select=\"$ctrl.fileUpload(validFiles, $invalidFiles)\" ng-model=validFiles ngf-model-invalid=$invalidFiles ngf-multiple=true type=file ngf-accept=$ctrl.acceptType ngf-pattern=$ctrl.acceptType ngf-max-files=$ctrl.maxFiles name=file> <span translate>{{'Upload assets'}}</span> </a> </div> <div ng-if=!isDesktop class=upload-container> <button id=upload-assets-btn class=\"btn btn-primary\" ngf-drop=\"$ctrl.fileUpload(validFiles, $invalidFiles)\" ngf-select=\"$ctrl.fileUpload(validFiles, $invalidFiles)\" ng-model=validFiles ngf-model-invalid=$invalidFiles ngf-multiple=true type=file ngf-accept=$ctrl.acceptType ngf-pattern=$ctrl.acceptType ngf-max-files=$ctrl.maxFiles name=file> <span> <svg width=16 height=100%> <style>.st0{fill:#fff}</style> <use xlink:href={{::$ctrl.img}} /> </svg> <span translate>{{'Upload assets'}}</span> </span> </button> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(41);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./addAssets.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./addAssets.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)(false);
	// Module
	exports.push([module.id, ".screen-reader-text{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}#topHomepageContainer .add-assets-wrapper{display:-webkit-flex;display:flex;-webkit-flex-flow:row wrap;flex-flow:row wrap;text-align:start;background-color:#fff;align-items:flex-end}#topHomepageContainer .add-assets-wrapper>*{padding:10px;flex:1 100%;margin-top:5px;margin-bottom:5px}#topHomepageContainer .add-assets-wrapper>* .alert{white-space:normal;word-break:break-word;word-wrap:break-word;line-height:22px;padding-top:5px;padding-bottom:5px;display:flex}#topHomepageContainer .add-assets-wrapper>* .alert span{padding-left:5px;padding-right:5px;flex-grow:3;width:0}#topHomepageContainer .add-assets-wrapper>* .alert .close{font-size:x-large}#topHomepageContainer .add-assets-wrapper>* .alert .close:focus{border:1px dashed}#topHomepageContainer .add-assets-wrapper>* .alert:before{font-size:20px}#topHomepageContainer .dropMessage{margin-bottom:10px}#topHomepageContainer .upload-container{display:flex;flex-flow:column;justify-content:center;align-items:center;background-color:#EFEFEF;text-align:center;height:13.2rem;padding:1rem;border-style:dashed;border-width:2px;border-color:#EFEFEF}#topHomepageContainer .upload-container .upload-button{width:15rem}#topHomepageContainer .upload-container .upload-link{height:20px}#topHomepageContainer .rejectClass{border:3px solid #e71d32;box-shadow:0 0 0 1px #ffffff, 0 0 0 2px #e71d32}#topHomepageContainer .acceptClass{background-color:#d8d8d8;border:none}#topHomepageContainer button.link{text-align:left;color:#1f57a4;background:none;margin:0;padding:0;border:none;cursor:pointer}#topHomepageContainer button.link:hover span,#topHomepageContainer button.link:focus span{text-decoration:underline}#topHomepageContainer #upload-assets-btn svg{vertical-align:middle}\n", ""]);
	


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(43);
	module.exports = 'ngFileUpload';

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	/**!
	 * AngularJS file upload directives and services. Supports: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * FileAPI Flash shim for old browsers not supporting FormData
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 12.2.13
	 */
	
	(function () {
	  /** @namespace FileAPI.noContentTimeout */
	
	  function patchXHR(fnName, newFn) {
	    window.XMLHttpRequest.prototype[fnName] = newFn(window.XMLHttpRequest.prototype[fnName]);
	  }
	
	  function redefineProp(xhr, prop, fn) {
	    try {
	      Object.defineProperty(xhr, prop, {get: fn});
	    } catch (e) {/*ignore*/
	    }
	  }
	
	  if (!window.FileAPI) {
	    window.FileAPI = {};
	  }
	
	  if (!window.XMLHttpRequest) {
	    throw 'AJAX is not supported. XMLHttpRequest is not defined.';
	  }
	
	  FileAPI.shouldLoad = !window.FormData || FileAPI.forceLoad;
	  if (FileAPI.shouldLoad) {
	    var initializeUploadListener = function (xhr) {
	      if (!xhr.__listeners) {
	        if (!xhr.upload) xhr.upload = {};
	        xhr.__listeners = [];
	        var origAddEventListener = xhr.upload.addEventListener;
	        xhr.upload.addEventListener = function (t, fn) {
	          xhr.__listeners[t] = fn;
	          if (origAddEventListener) origAddEventListener.apply(this, arguments);
	        };
	      }
	    };
	
	    patchXHR('open', function (orig) {
	      return function (m, url, b) {
	        initializeUploadListener(this);
	        this.__url = url;
	        try {
	          orig.apply(this, [m, url, b]);
	        } catch (e) {
	          if (e.message.indexOf('Access is denied') > -1) {
	            this.__origError = e;
	            orig.apply(this, [m, '_fix_for_ie_crossdomain__', b]);
	          }
	        }
	      };
	    });
	
	    patchXHR('getResponseHeader', function (orig) {
	      return function (h) {
	        return this.__fileApiXHR && this.__fileApiXHR.getResponseHeader ? this.__fileApiXHR.getResponseHeader(h) : (orig == null ? null : orig.apply(this, [h]));
	      };
	    });
	
	    patchXHR('getAllResponseHeaders', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.getAllResponseHeaders ? this.__fileApiXHR.getAllResponseHeaders() : (orig == null ? null : orig.apply(this));
	      };
	    });
	
	    patchXHR('abort', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.abort ? this.__fileApiXHR.abort() : (orig == null ? null : orig.apply(this));
	      };
	    });
	
	    patchXHR('setRequestHeader', function (orig) {
	      return function (header, value) {
	        if (header === '__setXHR_') {
	          initializeUploadListener(this);
	          var val = value(this);
	          // fix for angular < 1.2.0
	          if (val instanceof Function) {
	            val(this);
	          }
	        } else {
	          this.__requestHeaders = this.__requestHeaders || {};
	          this.__requestHeaders[header] = value;
	          orig.apply(this, arguments);
	        }
	      };
	    });
	
	    patchXHR('send', function (orig) {
	      return function () {
	        var xhr = this;
	        if (arguments[0] && arguments[0].__isFileAPIShim) {
	          var formData = arguments[0];
	          var config = {
	            url: xhr.__url,
	            jsonp: false, //removes the callback form param
	            cache: true, //removes the ?fileapiXXX in the url
	            complete: function (err, fileApiXHR) {
	              if (err && angular.isString(err) && err.indexOf('#2174') !== -1) {
	                // this error seems to be fine the file is being uploaded properly.
	                err = null;
	              }
	              xhr.__completed = true;
	              if (!err && xhr.__listeners.load)
	                xhr.__listeners.load({
	                  type: 'load',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (!err && xhr.__listeners.loadend)
	                xhr.__listeners.loadend({
	                  type: 'loadend',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (err === 'abort' && xhr.__listeners.abort)
	                xhr.__listeners.abort({
	                  type: 'abort',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (fileApiXHR.status !== undefined) redefineProp(xhr, 'status', function () {
	                return (fileApiXHR.status === 0 && err && err !== 'abort') ? 500 : fileApiXHR.status;
	              });
	              if (fileApiXHR.statusText !== undefined) redefineProp(xhr, 'statusText', function () {
	                return fileApiXHR.statusText;
	              });
	              redefineProp(xhr, 'readyState', function () {
	                return 4;
	              });
	              if (fileApiXHR.response !== undefined) redefineProp(xhr, 'response', function () {
	                return fileApiXHR.response;
	              });
	              var resp = fileApiXHR.responseText || (err && fileApiXHR.status === 0 && err !== 'abort' ? err : undefined);
	              redefineProp(xhr, 'responseText', function () {
	                return resp;
	              });
	              redefineProp(xhr, 'response', function () {
	                return resp;
	              });
	              if (err) redefineProp(xhr, 'err', function () {
	                return err;
	              });
	              xhr.__fileApiXHR = fileApiXHR;
	              if (xhr.onreadystatechange) xhr.onreadystatechange();
	              if (xhr.onload) xhr.onload();
	            },
	            progress: function (e) {
	              e.target = xhr;
	              if (xhr.__listeners.progress) xhr.__listeners.progress(e);
	              xhr.__total = e.total;
	              xhr.__loaded = e.loaded;
	              if (e.total === e.loaded) {
	                // fix flash issue that doesn't call complete if there is no response text from the server
	                var _this = this;
	                setTimeout(function () {
	                  if (!xhr.__completed) {
	                    xhr.getAllResponseHeaders = function () {
	                    };
	                    _this.complete(null, {status: 204, statusText: 'No Content'});
	                  }
	                }, FileAPI.noContentTimeout || 10000);
	              }
	            },
	            headers: xhr.__requestHeaders
	          };
	          config.data = {};
	          config.files = {};
	          for (var i = 0; i < formData.data.length; i++) {
	            var item = formData.data[i];
	            if (item.val != null && item.val.name != null && item.val.size != null && item.val.type != null) {
	              config.files[item.key] = item.val;
	            } else {
	              config.data[item.key] = item.val;
	            }
	          }
	
	          setTimeout(function () {
	            if (!FileAPI.hasFlash) {
	              throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	            }
	            xhr.__fileApiXHR = FileAPI.upload(config);
	          }, 1);
	        } else {
	          if (this.__origError) {
	            throw this.__origError;
	          }
	          orig.apply(xhr, arguments);
	        }
	      };
	    });
	    window.XMLHttpRequest.__isFileAPIShim = true;
	    window.FormData = FormData = function () {
	      return {
	        append: function (key, val, name) {
	          if (val.__isFileAPIBlobShim) {
	            val = val.data[0];
	          }
	          this.data.push({
	            key: key,
	            val: val,
	            name: name
	          });
	        },
	        data: [],
	        __isFileAPIShim: true
	      };
	    };
	
	    window.Blob = Blob = function (b) {
	      return {
	        data: b,
	        __isFileAPIBlobShim: true
	      };
	    };
	  }
	
	})();
	
	(function () {
	  /** @namespace FileAPI.forceLoad */
	  /** @namespace window.FileAPI.jsUrl */
	  /** @namespace window.FileAPI.jsPath */
	
	  function isInputTypeFile(elem) {
	    return elem[0].tagName.toLowerCase() === 'input' && elem.attr('type') && elem.attr('type').toLowerCase() === 'file';
	  }
	
	  function hasFlash() {
	    try {
	      var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
	      if (fo) return true;
	    } catch (e) {
	      if (navigator.mimeTypes['application/x-shockwave-flash'] !== undefined) return true;
	    }
	    return false;
	  }
	
	  function getOffset(obj) {
	    var left = 0, top = 0;
	
	    if (window.jQuery) {
	      return jQuery(obj).offset();
	    }
	
	    if (obj.offsetParent) {
	      do {
	        left += (obj.offsetLeft - obj.scrollLeft);
	        top += (obj.offsetTop - obj.scrollTop);
	        obj = obj.offsetParent;
	      } while (obj);
	    }
	    return {
	      left: left,
	      top: top
	    };
	  }
	
	  if (FileAPI.shouldLoad) {
	    FileAPI.hasFlash = hasFlash();
	
	    //load FileAPI
	    if (FileAPI.forceLoad) {
	      FileAPI.html5 = false;
	    }
	
	    if (!FileAPI.upload) {
	      var jsUrl, basePath, script = document.createElement('script'), allScripts = document.getElementsByTagName('script'), i, index, src;
	      if (window.FileAPI.jsUrl) {
	        jsUrl = window.FileAPI.jsUrl;
	      } else if (window.FileAPI.jsPath) {
	        basePath = window.FileAPI.jsPath;
	      } else {
	        for (i = 0; i < allScripts.length; i++) {
	          src = allScripts[i].src;
	          index = src.search(/\/ng\-file\-upload[\-a-zA-z0-9\.]*\.js/);
	          if (index > -1) {
	            basePath = src.substring(0, index + 1);
	            break;
	          }
	        }
	      }
	
	      if (FileAPI.staticPath == null) FileAPI.staticPath = basePath;
	      script.setAttribute('src', jsUrl || basePath + 'FileAPI.min.js');
	      document.getElementsByTagName('head')[0].appendChild(script);
	    }
	
	    FileAPI.ngfFixIE = function (elem, fileElem, changeFn) {
	      if (!hasFlash()) {
	        throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	      }
	      var fixInputStyle = function () {
	        var label = fileElem.parent();
	        if (elem.attr('disabled')) {
	          if (label) label.removeClass('js-fileapi-wrapper');
	        } else {
	          if (!fileElem.attr('__ngf_flash_')) {
	            fileElem.unbind('change');
	            fileElem.unbind('click');
	            fileElem.bind('change', function (evt) {
	              fileApiChangeFn.apply(this, [evt]);
	              changeFn.apply(this, [evt]);
	            });
	            fileElem.attr('__ngf_flash_', 'true');
	          }
	          label.addClass('js-fileapi-wrapper');
	          if (!isInputTypeFile(elem)) {
	            label.css('position', 'absolute')
	              .css('top', getOffset(elem[0]).top + 'px').css('left', getOffset(elem[0]).left + 'px')
	              .css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px')
	              .css('filter', 'alpha(opacity=0)').css('display', elem.css('display'))
	              .css('overflow', 'hidden').css('z-index', '900000')
	              .css('visibility', 'visible');
	            fileElem.css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px')
	              .css('position', 'absolute').css('top', '0px').css('left', '0px');
	          }
	        }
	      };
	
	      elem.bind('mouseenter', fixInputStyle);
	
	      var fileApiChangeFn = function (evt) {
	        var files = FileAPI.getFiles(evt);
	        //just a double check for #233
	        for (var i = 0; i < files.length; i++) {
	          if (files[i].size === undefined) files[i].size = 0;
	          if (files[i].name === undefined) files[i].name = 'file';
	          if (files[i].type === undefined) files[i].type = 'undefined';
	        }
	        if (!evt.target) {
	          evt.target = {};
	        }
	        evt.target.files = files;
	        // if evt.target.files is not writable use helper field
	        if (evt.target.files !== files) {
	          evt.__files_ = files;
	        }
	        (evt.__files_ || evt.target.files).item = function (i) {
	          return (evt.__files_ || evt.target.files)[i] || null;
	        };
	      };
	    };
	
	    FileAPI.disableFileInput = function (elem, disable) {
	      if (disable) {
	        elem.removeClass('js-fileapi-wrapper');
	      } else {
	        elem.addClass('js-fileapi-wrapper');
	      }
	    };
	  }
	})();
	
	if (!window.FileReader) {
	  window.FileReader = function () {
	    var _this = this, loadStarted = false;
	    this.listeners = {};
	    this.addEventListener = function (type, fn) {
	      _this.listeners[type] = _this.listeners[type] || [];
	      _this.listeners[type].push(fn);
	    };
	    this.removeEventListener = function (type, fn) {
	      if (_this.listeners[type]) _this.listeners[type].splice(_this.listeners[type].indexOf(fn), 1);
	    };
	    this.dispatchEvent = function (evt) {
	      var list = _this.listeners[evt.type];
	      if (list) {
	        for (var i = 0; i < list.length; i++) {
	          list[i].call(_this, evt);
	        }
	      }
	    };
	    this.onabort = this.onerror = this.onload = this.onloadstart = this.onloadend = this.onprogress = null;
	
	    var constructEvent = function (type, evt) {
	      var e = {type: type, target: _this, loaded: evt.loaded, total: evt.total, error: evt.error};
	      if (evt.result != null) e.target.result = evt.result;
	      return e;
	    };
	    var listener = function (evt) {
	      if (!loadStarted) {
	        loadStarted = true;
	        if (_this.onloadstart) _this.onloadstart(constructEvent('loadstart', evt));
	      }
	      var e;
	      if (evt.type === 'load') {
	        if (_this.onloadend) _this.onloadend(constructEvent('loadend', evt));
	        e = constructEvent('load', evt);
	        if (_this.onload) _this.onload(e);
	        _this.dispatchEvent(e);
	      } else if (evt.type === 'progress') {
	        e = constructEvent('progress', evt);
	        if (_this.onprogress) _this.onprogress(e);
	        _this.dispatchEvent(e);
	      } else {
	        e = constructEvent('error', evt);
	        if (_this.onerror) _this.onerror(e);
	        _this.dispatchEvent(e);
	      }
	    };
	    this.readAsDataURL = function (file) {
	      FileAPI.readAsDataURL(file, listener);
	    };
	    this.readAsText = function (file) {
	      FileAPI.readAsText(file, listener);
	    };
	  };
	}
	
	/**!
	 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 12.2.13
	 */
	
	if (window.XMLHttpRequest && !(window.FileAPI && FileAPI.shouldLoad)) {
	  window.XMLHttpRequest.prototype.setRequestHeader = (function (orig) {
	    return function (header, value) {
	      if (header === '__setXHR_') {
	        var val = value(this);
	        // fix for angular < 1.2.0
	        if (val instanceof Function) {
	          val(this);
	        }
	      } else {
	        orig.apply(this, arguments);
	      }
	    };
	  })(window.XMLHttpRequest.prototype.setRequestHeader);
	}
	
	var ngFileUpload = angular.module('ngFileUpload', []);
	
	ngFileUpload.version = '12.2.13';
	
	ngFileUpload.service('UploadBase', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
	  var upload = this;
	  upload.promisesCount = 0;
	
	  this.isResumeSupported = function () {
	    return window.Blob && window.Blob.prototype.slice;
	  };
	
	  var resumeSupported = this.isResumeSupported();
	
	  function sendHttp(config) {
	    config.method = config.method || 'POST';
	    config.headers = config.headers || {};
	
	    var deferred = config._deferred = config._deferred || $q.defer();
	    var promise = deferred.promise;
	
	    function notifyProgress(e) {
	      if (deferred.notify) {
	        deferred.notify(e);
	      }
	      if (promise.progressFunc) {
	        $timeout(function () {
	          promise.progressFunc(e);
	        });
	      }
	    }
	
	    function getNotifyEvent(n) {
	      if (config._start != null && resumeSupported) {
	        return {
	          loaded: n.loaded + config._start,
	          total: (config._file && config._file.size) || n.total,
	          type: n.type, config: config,
	          lengthComputable: true, target: n.target
	        };
	      } else {
	        return n;
	      }
	    }
	
	    if (!config.disableProgress) {
	      config.headers.__setXHR_ = function () {
	        return function (xhr) {
	          if (!xhr || !xhr.upload || !xhr.upload.addEventListener) return;
	          config.__XHR = xhr;
	          if (config.xhrFn) config.xhrFn(xhr);
	          xhr.upload.addEventListener('progress', function (e) {
	            e.config = config;
	            notifyProgress(getNotifyEvent(e));
	          }, false);
	          //fix for firefox not firing upload progress end, also IE8-9
	          xhr.upload.addEventListener('load', function (e) {
	            if (e.lengthComputable) {
	              e.config = config;
	              notifyProgress(getNotifyEvent(e));
	            }
	          }, false);
	        };
	      };
	    }
	
	    function uploadWithAngular() {
	      $http(config).then(function (r) {
	          if (resumeSupported && config._chunkSize && !config._finished && config._file) {
	            var fileSize = config._file && config._file.size || 0;
	            notifyProgress({
	                loaded: Math.min(config._end, fileSize),
	                total: fileSize,
	                config: config,
	                type: 'progress'
	              }
	            );
	            upload.upload(config, true);
	          } else {
	            if (config._finished) delete config._finished;
	            deferred.resolve(r);
	          }
	        }, function (e) {
	          deferred.reject(e);
	        }, function (n) {
	          deferred.notify(n);
	        }
	      );
	    }
	
	    if (!resumeSupported) {
	      uploadWithAngular();
	    } else if (config._chunkSize && config._end && !config._finished) {
	      config._start = config._end;
	      config._end += config._chunkSize;
	      uploadWithAngular();
	    } else if (config.resumeSizeUrl) {
	      $http.get(config.resumeSizeUrl).then(function (resp) {
	        if (config.resumeSizeResponseReader) {
	          config._start = config.resumeSizeResponseReader(resp.data);
	        } else {
	          config._start = parseInt((resp.data.size == null ? resp.data : resp.data.size).toString());
	        }
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else if (config.resumeSize) {
	      config.resumeSize().then(function (size) {
	        config._start = size;
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else {
	      if (config._chunkSize) {
	        config._start = 0;
	        config._end = config._start + config._chunkSize;
	      }
	      uploadWithAngular();
	    }
	
	
	    promise.success = function (fn) {
	      promise.then(function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.error = function (fn) {
	      promise.then(null, function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.progress = function (fn) {
	      promise.progressFunc = fn;
	      promise.then(null, null, function (n) {
	        fn(n);
	      });
	      return promise;
	    };
	    promise.abort = promise.pause = function () {
	      if (config.__XHR) {
	        $timeout(function () {
	          config.__XHR.abort();
	        });
	      }
	      return promise;
	    };
	    promise.xhr = function (fn) {
	      config.xhrFn = (function (origXhrFn) {
	        return function () {
	          if (origXhrFn) origXhrFn.apply(promise, arguments);
	          fn.apply(promise, arguments);
	        };
	      })(config.xhrFn);
	      return promise;
	    };
	
	    upload.promisesCount++;
	    if (promise['finally'] && promise['finally'] instanceof Function) {
	      promise['finally'](function () {
	        upload.promisesCount--;
	      });
	    }
	    return promise;
	  }
	
	  this.isUploadInProgress = function () {
	    return upload.promisesCount > 0;
	  };
	
	  this.rename = function (file, name) {
	    file.ngfName = name;
	    return file;
	  };
	
	  this.jsonBlob = function (val) {
	    if (val != null && !angular.isString(val)) {
	      val = JSON.stringify(val);
	    }
	    var blob = new window.Blob([val], {type: 'application/json'});
	    blob._ngfBlob = true;
	    return blob;
	  };
	
	  this.json = function (val) {
	    return angular.toJson(val);
	  };
	
	  function copy(obj) {
	    var clone = {};
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        clone[key] = obj[key];
	      }
	    }
	    return clone;
	  }
	
	  this.isFile = function (file) {
	    return file != null && (file instanceof window.Blob || (file.flashId && file.name && file.size));
	  };
	
	  this.upload = function (config, internal) {
	    function toResumeFile(file, formData) {
	      if (file._ngfBlob) return file;
	      config._file = config._file || file;
	      if (config._start != null && resumeSupported) {
	        if (config._end && config._end >= file.size) {
	          config._finished = true;
	          config._end = file.size;
	        }
	        var slice = file.slice(config._start, config._end || file.size);
	        slice.name = file.name;
	        slice.ngfName = file.ngfName;
	        if (config._chunkSize) {
	          formData.append('_chunkSize', config._chunkSize);
	          formData.append('_currentChunkSize', config._end - config._start);
	          formData.append('_chunkNumber', Math.floor(config._start / config._chunkSize));
	          formData.append('_totalSize', config._file.size);
	        }
	        return slice;
	      }
	      return file;
	    }
	
	    function addFieldToFormData(formData, val, key) {
	      if (val !== undefined) {
	        if (angular.isDate(val)) {
	          val = val.toISOString();
	        }
	        if (angular.isString(val)) {
	          formData.append(key, val);
	        } else if (upload.isFile(val)) {
	          var file = toResumeFile(val, formData);
	          var split = key.split(',');
	          if (split[1]) {
	            file.ngfName = split[1].replace(/^\s+|\s+$/g, '');
	            key = split[0];
	          }
	          config._fileKey = config._fileKey || key;
	          formData.append(key, file, file.ngfName || file.name);
	        } else {
	          if (angular.isObject(val)) {
	            if (val.$$ngfCircularDetection) throw 'ngFileUpload: Circular reference in config.data. Make sure specified data for Upload.upload() has no circular reference: ' + key;
	
	            val.$$ngfCircularDetection = true;
	            try {
	              for (var k in val) {
	                if (val.hasOwnProperty(k) && k !== '$$ngfCircularDetection') {
	                  var objectKey = config.objectKey == null ? '[i]' : config.objectKey;
	                  if (val.length && parseInt(k) > -1) {
	                    objectKey = config.arrayKey == null ? objectKey : config.arrayKey;
	                  }
	                  addFieldToFormData(formData, val[k], key + objectKey.replace(/[ik]/g, k));
	                }
	              }
	            } finally {
	              delete val.$$ngfCircularDetection;
	            }
	          } else {
	            formData.append(key, val);
	          }
	        }
	      }
	    }
	
	    function digestConfig() {
	      config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	      config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	      config.headers = config.headers || {};
	      config.headers['Content-Type'] = undefined;
	      config.transformRequest = config.transformRequest ?
	        (angular.isArray(config.transformRequest) ?
	          config.transformRequest : [config.transformRequest]) : [];
	      config.transformRequest.push(function (data) {
	        var formData = new window.FormData(), key;
	        data = data || config.fields || {};
	        if (config.file) {
	          data.file = config.file;
	        }
	        for (key in data) {
	          if (data.hasOwnProperty(key)) {
	            var val = data[key];
	            if (config.formDataAppender) {
	              config.formDataAppender(formData, key, val);
	            } else {
	              addFieldToFormData(formData, val, key);
	            }
	          }
	        }
	
	        return formData;
	      });
	    }
	
	    if (!internal) config = copy(config);
	    if (!config._isDigested) {
	      config._isDigested = true;
	      digestConfig();
	    }
	
	    return sendHttp(config);
	  };
	
	  this.http = function (config) {
	    config = copy(config);
	    config.transformRequest = config.transformRequest || function (data) {
	        if ((window.ArrayBuffer && data instanceof window.ArrayBuffer) || data instanceof window.Blob) {
	          return data;
	        }
	        return $http.defaults.transformRequest[0].apply(this, arguments);
	      };
	    config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	    config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	    return sendHttp(config);
	  };
	
	  this.translateScalars = function (str) {
	    if (angular.isString(str)) {
	      if (str.search(/kb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1024);
	      } else if (str.search(/mb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1048576);
	      } else if (str.search(/gb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1073741824);
	      } else if (str.search(/b/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/s/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/m/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 60);
	      } else if (str.search(/h/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 3600);
	      }
	    }
	    return str;
	  };
	
	  this.urlToBlob = function(url) {
	    var defer = $q.defer();
	    $http({url: url, method: 'get', responseType: 'arraybuffer'}).then(function (resp) {
	      var arrayBufferView = new Uint8Array(resp.data);
	      var type = resp.headers('content-type') || 'image/WebP';
	      var blob = new window.Blob([arrayBufferView], {type: type});
	      var matches = url.match(/.*\/(.+?)(\?.*)?$/);
	      if (matches.length > 1) {
	        blob.name = matches[1];
	      }
	      defer.resolve(blob);
	    }, function (e) {
	      defer.reject(e);
	    });
	    return defer.promise;
	  };
	
	  this.setDefaults = function (defaults) {
	    this.defaults = defaults || {};
	  };
	
	  this.defaults = {};
	  this.version = ngFileUpload.version;
	}
	
	]);
	
	ngFileUpload.service('Upload', ['$parse', '$timeout', '$compile', '$q', 'UploadExif', function ($parse, $timeout, $compile, $q, UploadExif) {
	  var upload = UploadExif;
	  upload.getAttrWithDefaults = function (attr, name) {
	    if (attr[name] != null) return attr[name];
	    var def = upload.defaults[name];
	    return (def == null ? def : (angular.isString(def) ? def : JSON.stringify(def)));
	  };
	
	  upload.attrGetter = function (name, attr, scope, params) {
	    var attrVal = this.getAttrWithDefaults(attr, name);
	    if (scope) {
	      try {
	        if (params) {
	          return $parse(attrVal)(scope, params);
	        } else {
	          return $parse(attrVal)(scope);
	        }
	      } catch (e) {
	        // hangle string value without single qoute
	        if (name.search(/min|max|pattern/i)) {
	          return attrVal;
	        } else {
	          throw e;
	        }
	      }
	    } else {
	      return attrVal;
	    }
	  };
	
	  upload.shouldUpdateOn = function (type, attr, scope) {
	    var modelOptions = upload.attrGetter('ngfModelOptions', attr, scope);
	    if (modelOptions && modelOptions.updateOn) {
	      return modelOptions.updateOn.split(' ').indexOf(type) > -1;
	    }
	    return true;
	  };
	
	  upload.emptyPromise = function () {
	    var d = $q.defer();
	    var args = arguments;
	    $timeout(function () {
	      d.resolve.apply(d, args);
	    });
	    return d.promise;
	  };
	
	  upload.rejectPromise = function () {
	    var d = $q.defer();
	    var args = arguments;
	    $timeout(function () {
	      d.reject.apply(d, args);
	    });
	    return d.promise;
	  };
	
	  upload.happyPromise = function (promise, data) {
	    var d = $q.defer();
	    promise.then(function (result) {
	      d.resolve(result);
	    }, function (error) {
	      $timeout(function () {
	        throw error;
	      });
	      d.resolve(data);
	    });
	    return d.promise;
	  };
	
	  function applyExifRotations(files, attr, scope) {
	    var promises = [upload.emptyPromise()];
	    angular.forEach(files, function (f, i) {
	      if (f.type.indexOf('image/jpeg') === 0 && upload.attrGetter('ngfFixOrientation', attr, scope, {$file: f})) {
	        promises.push(upload.happyPromise(upload.applyExifRotation(f), f).then(function (fixedFile) {
	          files.splice(i, 1, fixedFile);
	        }));
	      }
	    });
	    return $q.all(promises);
	  }
	
	  function resizeFile(files, attr, scope, ngModel) {
	    var resizeVal = upload.attrGetter('ngfResize', attr, scope);
	    if (!resizeVal || !upload.isResizeSupported() || !files.length) return upload.emptyPromise();
	    if (resizeVal instanceof Function) {
	      var defer = $q.defer();
	      return resizeVal(files).then(function (p) {
	        resizeWithParams(p, files, attr, scope, ngModel).then(function (r) {
	          defer.resolve(r);
	        }, function (e) {
	          defer.reject(e);
	        });
	      }, function (e) {
	        defer.reject(e);
	      });
	    } else {
	      return resizeWithParams(resizeVal, files, attr, scope, ngModel);
	    }
	  }
	
	  function resizeWithParams(params, files, attr, scope, ngModel) {
	    var promises = [upload.emptyPromise()];
	
	    function handleFile(f, i) {
	      if (f.type.indexOf('image') === 0) {
	        if (params.pattern && !upload.validatePattern(f, params.pattern)) return;
	        params.resizeIf = function (width, height) {
	          return upload.attrGetter('ngfResizeIf', attr, scope,
	            {$width: width, $height: height, $file: f});
	        };
	        var promise = upload.resize(f, params);
	        promises.push(promise);
	        promise.then(function (resizedFile) {
	          files.splice(i, 1, resizedFile);
	        }, function (e) {
	          f.$error = 'resize';
	          (f.$errorMessages = (f.$errorMessages || {})).resize = true;
	          f.$errorParam = (e ? (e.message ? e.message : e) + ': ' : '') + (f && f.name);
	          ngModel.$ngfValidations.push({name: 'resize', valid: false});
	          upload.applyModelValidation(ngModel, files);
	        });
	      }
	    }
	
	    for (var i = 0; i < files.length; i++) {
	      handleFile(files[i], i);
	    }
	    return $q.all(promises);
	  }
	
	  upload.updateModel = function (ngModel, attr, scope, fileChange, files, evt, noDelay) {
	    function update(files, invalidFiles, newFiles, dupFiles, isSingleModel) {
	      attr.$$ngfPrevValidFiles = files;
	      attr.$$ngfPrevInvalidFiles = invalidFiles;
	      var file = files && files.length ? files[0] : null;
	      var invalidFile = invalidFiles && invalidFiles.length ? invalidFiles[0] : null;
	
	      if (ngModel) {
	        upload.applyModelValidation(ngModel, files);
	        ngModel.$setViewValue(isSingleModel ? file : files);
	      }
	
	      if (fileChange) {
	        $parse(fileChange)(scope, {
	          $files: files,
	          $file: file,
	          $newFiles: newFiles,
	          $duplicateFiles: dupFiles,
	          $invalidFiles: invalidFiles,
	          $invalidFile: invalidFile,
	          $event: evt
	        });
	      }
	
	      var invalidModel = upload.attrGetter('ngfModelInvalid', attr);
	      if (invalidModel) {
	        $timeout(function () {
	          $parse(invalidModel).assign(scope, isSingleModel ? invalidFile : invalidFiles);
	        });
	      }
	      $timeout(function () {
	        // scope apply changes
	      });
	    }
	
	    var allNewFiles, dupFiles = [], prevValidFiles, prevInvalidFiles,
	      invalids = [], valids = [];
	
	    function removeDuplicates() {
	      function equals(f1, f2) {
	        return f1.name === f2.name && (f1.$ngfOrigSize || f1.size) === (f2.$ngfOrigSize || f2.size) &&
	          f1.type === f2.type;
	      }
	
	      function isInPrevFiles(f) {
	        var j;
	        for (j = 0; j < prevValidFiles.length; j++) {
	          if (equals(f, prevValidFiles[j])) {
	            return true;
	          }
	        }
	        for (j = 0; j < prevInvalidFiles.length; j++) {
	          if (equals(f, prevInvalidFiles[j])) {
	            return true;
	          }
	        }
	        return false;
	      }
	
	      if (files) {
	        allNewFiles = [];
	        dupFiles = [];
	        for (var i = 0; i < files.length; i++) {
	          if (isInPrevFiles(files[i])) {
	            dupFiles.push(files[i]);
	          } else {
	            allNewFiles.push(files[i]);
	          }
	        }
	      }
	    }
	
	    function toArray(v) {
	      return angular.isArray(v) ? v : [v];
	    }
	
	    function resizeAndUpdate() {
	      function updateModel() {
	        $timeout(function () {
	          update(keep ? prevValidFiles.concat(valids) : valids,
	            keep ? prevInvalidFiles.concat(invalids) : invalids,
	            files, dupFiles, isSingleModel);
	        }, options && options.debounce ? options.debounce.change || options.debounce : 0);
	      }
	
	      var resizingFiles = validateAfterResize ? allNewFiles : valids;
	      resizeFile(resizingFiles, attr, scope, ngModel).then(function () {
	        if (validateAfterResize) {
	          upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
	            .then(function (validationResult) {
	              valids = validationResult.validsFiles;
	              invalids = validationResult.invalidsFiles;
	              updateModel();
	            });
	        } else {
	          updateModel();
	        }
	      }, function () {
	        for (var i = 0; i < resizingFiles.length; i++) {
	          var f = resizingFiles[i];
	          if (f.$error === 'resize') {
	            var index = valids.indexOf(f);
	            if (index > -1) {
	              valids.splice(index, 1);
	              invalids.push(f);
	            }
	            updateModel();
	          }
	        }
	      });
	    }
	
	    prevValidFiles = attr.$$ngfPrevValidFiles || [];
	    prevInvalidFiles = attr.$$ngfPrevInvalidFiles || [];
	    if (ngModel && ngModel.$modelValue) {
	      prevValidFiles = toArray(ngModel.$modelValue);
	    }
	
	    var keep = upload.attrGetter('ngfKeep', attr, scope);
	    allNewFiles = (files || []).slice(0);
	    if (keep === 'distinct' || upload.attrGetter('ngfKeepDistinct', attr, scope) === true) {
	      removeDuplicates(attr, scope);
	    }
	
	    var isSingleModel = !keep && !upload.attrGetter('ngfMultiple', attr, scope) && !upload.attrGetter('multiple', attr);
	
	    if (keep && !allNewFiles.length) return;
	
	    upload.attrGetter('ngfBeforeModelChange', attr, scope, {
	      $files: files,
	      $file: files && files.length ? files[0] : null,
	      $newFiles: allNewFiles,
	      $duplicateFiles: dupFiles,
	      $event: evt
	    });
	
	    var validateAfterResize = upload.attrGetter('ngfValidateAfterResize', attr, scope);
	
	    var options = upload.attrGetter('ngfModelOptions', attr, scope);
	    upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
	      .then(function (validationResult) {
	      if (noDelay) {
	        update(allNewFiles, [], files, dupFiles, isSingleModel);
	      } else {
	        if ((!options || !options.allowInvalid) && !validateAfterResize) {
	          valids = validationResult.validFiles;
	          invalids = validationResult.invalidFiles;
	        } else {
	          valids = allNewFiles;
	        }
	        if (upload.attrGetter('ngfFixOrientation', attr, scope) && upload.isExifSupported()) {
	          applyExifRotations(valids, attr, scope).then(function () {
	            resizeAndUpdate();
	          });
	        } else {
	          resizeAndUpdate();
	        }
	      }
	    });
	  };
	
	  return upload;
	}]);
	
	ngFileUpload.directive('ngfSelect', ['$parse', '$timeout', '$compile', 'Upload', function ($parse, $timeout, $compile, Upload) {
	  var generatedElems = [];
	
	  function isDelayedClickSupported(ua) {
	    // fix for android native browser < 4.4 and safari windows
	    var m = ua.match(/Android[^\d]*(\d+)\.(\d+)/);
	    if (m && m.length > 2) {
	      var v = Upload.defaults.androidFixMinorVersion || 4;
	      return parseInt(m[1]) < 4 || (parseInt(m[1]) === v && parseInt(m[2]) < v);
	    }
	
	    // safari on windows
	    return ua.indexOf('Chrome') === -1 && /.*Windows.*Safari.*/.test(ua);
	  }
	
	  function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, upload) {
	    /** @namespace attr.ngfSelect */
	    /** @namespace attr.ngfChange */
	    /** @namespace attr.ngModel */
	    /** @namespace attr.ngfModelOptions */
	    /** @namespace attr.ngfMultiple */
	    /** @namespace attr.ngfCapture */
	    /** @namespace attr.ngfValidate */
	    /** @namespace attr.ngfKeep */
	    var attrGetter = function (name, scope) {
	      return upload.attrGetter(name, attr, scope);
	    };
	
	    function isInputTypeFile() {
	      return elem[0].tagName.toLowerCase() === 'input' && attr.type && attr.type.toLowerCase() === 'file';
	    }
	
	    function fileChangeAttr() {
	      return attrGetter('ngfChange') || attrGetter('ngfSelect');
	    }
	
	    function changeFn(evt) {
	      if (upload.shouldUpdateOn('change', attr, scope)) {
	        var fileList = evt.__files_ || (evt.target && evt.target.files), files = [];
	        /* Handle duplicate call in  IE11 */
	        if (!fileList) return;
	        for (var i = 0; i < fileList.length; i++) {
	          files.push(fileList[i]);
	        }
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(),
	          files.length ? files : null, evt);
	      }
	    }
	
	    upload.registerModelChangeValidator(ngModel, attr, scope);
	
	    var unwatches = [];
	    if (attrGetter('ngfMultiple')) {
	      unwatches.push(scope.$watch(attrGetter('ngfMultiple'), function () {
	        fileElem.attr('multiple', attrGetter('ngfMultiple', scope));
	      }));
	    }
	    if (attrGetter('ngfCapture')) {
	      unwatches.push(scope.$watch(attrGetter('ngfCapture'), function () {
	        fileElem.attr('capture', attrGetter('ngfCapture', scope));
	      }));
	    }
	    if (attrGetter('ngfAccept')) {
	      unwatches.push(scope.$watch(attrGetter('ngfAccept'), function () {
	        fileElem.attr('accept', attrGetter('ngfAccept', scope));
	      }));
	    }
	    unwatches.push(attr.$observe('accept', function () {
	      fileElem.attr('accept', attrGetter('accept'));
	    }));
	    function bindAttrToFileInput(fileElem, label) {
	      function updateId(val) {
	        fileElem.attr('id', 'ngf-' + val);
	        label.attr('id', 'ngf-label-' + val);
	      }
	
	      for (var i = 0; i < elem[0].attributes.length; i++) {
	        var attribute = elem[0].attributes[i];
	        if (attribute.name !== 'type' && attribute.name !== 'class' && attribute.name !== 'style') {
	          if (attribute.name === 'id') {
	            updateId(attribute.value);
	            unwatches.push(attr.$observe('id', updateId));
	          } else {
	            fileElem.attr(attribute.name, (!attribute.value && (attribute.name === 'required' ||
	            attribute.name === 'multiple')) ? attribute.name : attribute.value);
	          }
	        }
	      }
	    }
	
	    function createFileInput() {
	      if (isInputTypeFile()) {
	        return elem;
	      }
	
	      var fileElem = angular.element('<input type="file">');
	
	      var label = angular.element('<label>upload</label>');
	      label.css('visibility', 'hidden').css('position', 'absolute').css('overflow', 'hidden')
	        .css('width', '0px').css('height', '0px').css('border', 'none')
	        .css('margin', '0px').css('padding', '0px').attr('tabindex', '-1');
	      bindAttrToFileInput(fileElem, label);
	
	      generatedElems.push({el: elem, ref: label});
	
	      document.body.appendChild(label.append(fileElem)[0]);
	
	      return fileElem;
	    }
	
	    function clickHandler(evt) {
	      if (elem.attr('disabled')) return false;
	      if (attrGetter('ngfSelectDisabled', scope)) return;
	
	      var r = detectSwipe(evt);
	      // prevent the click if it is a swipe
	      if (r != null) return r;
	
	      resetModel(evt);
	
	      // fix for md when the element is removed from the DOM and added back #460
	      try {
	        if (!isInputTypeFile() && !document.body.contains(fileElem[0])) {
	          generatedElems.push({el: elem, ref: fileElem.parent()});
	          document.body.appendChild(fileElem.parent()[0]);
	          fileElem.bind('change', changeFn);
	        }
	      } catch (e) {/*ignore*/
	      }
	
	      if (isDelayedClickSupported(navigator.userAgent)) {
	        setTimeout(function () {
	          fileElem[0].click();
	        }, 0);
	      } else {
	        fileElem[0].click();
	      }
	
	      return false;
	    }
	
	
	    var initialTouchStartY = 0;
	    var initialTouchStartX = 0;
	
	    function detectSwipe(evt) {
	      var touches = evt.changedTouches || (evt.originalEvent && evt.originalEvent.changedTouches);
	      if (touches) {
	        if (evt.type === 'touchstart') {
	          initialTouchStartX = touches[0].clientX;
	          initialTouchStartY = touches[0].clientY;
	          return true; // don't block event default
	        } else {
	          // prevent scroll from triggering event
	          if (evt.type === 'touchend') {
	            var currentX = touches[0].clientX;
	            var currentY = touches[0].clientY;
	            if ((Math.abs(currentX - initialTouchStartX) > 20) ||
	              (Math.abs(currentY - initialTouchStartY) > 20)) {
	              evt.stopPropagation();
	              evt.preventDefault();
	              return false;
	            }
	          }
	          return true;
	        }
	      }
	    }
	
	    var fileElem = elem;
	
	    function resetModel(evt) {
	      if (upload.shouldUpdateOn('click', attr, scope) && fileElem.val()) {
	        fileElem.val(null);
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(), null, evt, true);
	      }
	    }
	
	    if (!isInputTypeFile()) {
	      fileElem = createFileInput();
	    }
	    fileElem.bind('change', changeFn);
	
	    if (!isInputTypeFile()) {
	      elem.bind('click touchstart touchend', clickHandler);
	    } else {
	      elem.bind('click', resetModel);
	    }
	
	    function ie10SameFileSelectFix(evt) {
	      if (fileElem && !fileElem.attr('__ngf_ie10_Fix_')) {
	        if (!fileElem[0].parentNode) {
	          fileElem = null;
	          return;
	        }
	        evt.preventDefault();
	        evt.stopPropagation();
	        fileElem.unbind('click');
	        var clone = fileElem.clone();
	        fileElem.replaceWith(clone);
	        fileElem = clone;
	        fileElem.attr('__ngf_ie10_Fix_', 'true');
	        fileElem.bind('change', changeFn);
	        fileElem.bind('click', ie10SameFileSelectFix);
	        fileElem[0].click();
	        return false;
	      } else {
	        fileElem.removeAttr('__ngf_ie10_Fix_');
	      }
	    }
	
	    if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
	      fileElem.bind('click', ie10SameFileSelectFix);
	    }
	
	    if (ngModel) ngModel.$formatters.push(function (val) {
	      if (val == null || val.length === 0) {
	        if (fileElem.val()) {
	          fileElem.val(null);
	        }
	      }
	      return val;
	    });
	
	    scope.$on('$destroy', function () {
	      if (!isInputTypeFile()) fileElem.parent().remove();
	      angular.forEach(unwatches, function (unwatch) {
	        unwatch();
	      });
	    });
	
	    $timeout(function () {
	      for (var i = 0; i < generatedElems.length; i++) {
	        var g = generatedElems[i];
	        if (!document.body.contains(g.el[0])) {
	          generatedElems.splice(i, 1);
	          g.ref.remove();
	        }
	      }
	    });
	
	    if (window.FileAPI && window.FileAPI.ngfFixIE) {
	      window.FileAPI.ngfFixIE(elem, fileElem, changeFn);
	    }
	  }
	
	  return {
	    restrict: 'AEC',
	    require: '?ngModel',
	    link: function (scope, elem, attr, ngModel) {
	      linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, Upload);
	    }
	  };
	}]);
	
	(function () {
	
	  ngFileUpload.service('UploadDataUrl', ['UploadBase', '$timeout', '$q', function (UploadBase, $timeout, $q) {
	    var upload = UploadBase;
	    upload.base64DataUrl = function (file) {
	      if (angular.isArray(file)) {
	        var d = $q.defer(), count = 0;
	        angular.forEach(file, function (f) {
	          upload.dataUrl(f, true)['finally'](function () {
	            count++;
	            if (count === file.length) {
	              var urls = [];
	              angular.forEach(file, function (ff) {
	                urls.push(ff.$ngfDataUrl);
	              });
	              d.resolve(urls, file);
	            }
	          });
	        });
	        return d.promise;
	      } else {
	        return upload.dataUrl(file, true);
	      }
	    };
	    upload.dataUrl = function (file, disallowObjectUrl) {
	      if (!file) return upload.emptyPromise(file, file);
	      if ((disallowObjectUrl && file.$ngfDataUrl != null) || (!disallowObjectUrl && file.$ngfBlobUrl != null)) {
	        return upload.emptyPromise(disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl, file);
	      }
	      var p = disallowObjectUrl ? file.$$ngfDataUrlPromise : file.$$ngfBlobUrlPromise;
	      if (p) return p;
	
	      var deferred = $q.defer();
	      $timeout(function () {
	        if (window.FileReader && file &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 8') === -1 || file.size < 20000) &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 9') === -1 || file.size < 4000000)) {
	          //prefer URL.createObjectURL for handling refrences to files of all sizes
	          //since it doesn´t build a large string in memory
	          var URL = window.URL || window.webkitURL;
	          if (URL && URL.createObjectURL && !disallowObjectUrl) {
	            var url;
	            try {
	              url = URL.createObjectURL(file);
	            } catch (e) {
	              $timeout(function () {
	                file.$ngfBlobUrl = '';
	                deferred.reject();
	              });
	              return;
	            }
	            $timeout(function () {
	              file.$ngfBlobUrl = url;
	              if (url) {
	                deferred.resolve(url, file);
	                upload.blobUrls = upload.blobUrls || [];
	                upload.blobUrlsTotalSize = upload.blobUrlsTotalSize || 0;
	                upload.blobUrls.push({url: url, size: file.size});
	                upload.blobUrlsTotalSize += file.size || 0;
	                var maxMemory = upload.defaults.blobUrlsMaxMemory || 268435456;
	                var maxLength = upload.defaults.blobUrlsMaxQueueSize || 200;
	                while ((upload.blobUrlsTotalSize > maxMemory || upload.blobUrls.length > maxLength) && upload.blobUrls.length > 1) {
	                  var obj = upload.blobUrls.splice(0, 1)[0];
	                  URL.revokeObjectURL(obj.url);
	                  upload.blobUrlsTotalSize -= obj.size;
	                }
	              }
	            });
	          } else {
	            var fileReader = new FileReader();
	            fileReader.onload = function (e) {
	              $timeout(function () {
	                file.$ngfDataUrl = e.target.result;
	                deferred.resolve(e.target.result, file);
	                $timeout(function () {
	                  delete file.$ngfDataUrl;
	                }, 1000);
	              });
	            };
	            fileReader.onerror = function () {
	              $timeout(function () {
	                file.$ngfDataUrl = '';
	                deferred.reject();
	              });
	            };
	            fileReader.readAsDataURL(file);
	          }
	        } else {
	          $timeout(function () {
	            file[disallowObjectUrl ? '$ngfDataUrl' : '$ngfBlobUrl'] = '';
	            deferred.reject();
	          });
	        }
	      });
	
	      if (disallowObjectUrl) {
	        p = file.$$ngfDataUrlPromise = deferred.promise;
	      } else {
	        p = file.$$ngfBlobUrlPromise = deferred.promise;
	      }
	      p['finally'](function () {
	        delete file[disallowObjectUrl ? '$$ngfDataUrlPromise' : '$$ngfBlobUrlPromise'];
	      });
	      return p;
	    };
	    return upload;
	  }]);
	
	  function getTagType(el) {
	    if (el.tagName.toLowerCase() === 'img') return 'image';
	    if (el.tagName.toLowerCase() === 'audio') return 'audio';
	    if (el.tagName.toLowerCase() === 'video') return 'video';
	    return /./;
	  }
	
	  function linkFileDirective(Upload, $timeout, scope, elem, attr, directiveName, resizeParams, isBackground) {
	    function constructDataUrl(file) {
	      var disallowObjectUrl = Upload.attrGetter('ngfNoObjectUrl', attr, scope);
	      Upload.dataUrl(file, disallowObjectUrl)['finally'](function () {
	        $timeout(function () {
	          var src = (disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl;
	          if (isBackground) {
	            elem.css('background-image', 'url(\'' + (src || '') + '\')');
	          } else {
	            elem.attr('src', src);
	          }
	          if (src) {
	            elem.removeClass('ng-hide');
	          } else {
	            elem.addClass('ng-hide');
	          }
	        });
	      });
	    }
	
	    $timeout(function () {
	      var unwatch = scope.$watch(attr[directiveName], function (file) {
	        var size = resizeParams;
	        if (directiveName === 'ngfThumbnail') {
	          if (!size) {
	            size = {
	              width: elem[0].naturalWidth || elem[0].clientWidth,
	              height: elem[0].naturalHeight || elem[0].clientHeight
	            };
	          }
	          if (size.width === 0 && window.getComputedStyle) {
	            var style = getComputedStyle(elem[0]);
	            if (style.width && style.width.indexOf('px') > -1 && style.height && style.height.indexOf('px') > -1) {
	              size = {
	                width: parseInt(style.width.slice(0, -2)),
	                height: parseInt(style.height.slice(0, -2))
	              };
	            }
	          }
	        }
	
	        if (angular.isString(file)) {
	          elem.removeClass('ng-hide');
	          if (isBackground) {
	            return elem.css('background-image', 'url(\'' + file + '\')');
	          } else {
	            return elem.attr('src', file);
	          }
	        }
	        if (file && file.type && file.type.search(getTagType(elem[0])) === 0 &&
	          (!isBackground || file.type.indexOf('image') === 0)) {
	          if (size && Upload.isResizeSupported()) {
	            size.resizeIf = function (width, height) {
	              return Upload.attrGetter('ngfResizeIf', attr, scope,
	                {$width: width, $height: height, $file: file});
	            };
	            Upload.resize(file, size).then(
	              function (f) {
	                constructDataUrl(f);
	              }, function (e) {
	                throw e;
	              }
	            );
	          } else {
	            constructDataUrl(file);
	          }
	        } else {
	          elem.addClass('ng-hide');
	        }
	      });
	
	      scope.$on('$destroy', function () {
	        unwatch();
	      });
	    });
	  }
	
	
	  /** @namespace attr.ngfSrc */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfSrc', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfSrc',
	          Upload.attrGetter('ngfResize', attr, scope), false);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfBackground */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfBackground', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfBackground',
	          Upload.attrGetter('ngfResize', attr, scope), true);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfThumbnail */
	  /** @namespace attr.ngfAsBackground */
	  /** @namespace attr.ngfSize */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfThumbnail', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        var size = Upload.attrGetter('ngfSize', attr, scope);
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfThumbnail', size,
	          Upload.attrGetter('ngfAsBackground', attr, scope));
	      }
	    };
	  }]);
	
	  ngFileUpload.config(['$compileProvider', function ($compileProvider) {
	    if ($compileProvider.imgSrcSanitizationWhitelist) $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
	    if ($compileProvider.aHrefSanitizationWhitelist) $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
	  }]);
	
	  ngFileUpload.filter('ngfDataUrl', ['UploadDataUrl', '$sce', function (UploadDataUrl, $sce) {
	    return function (file, disallowObjectUrl, trustedUrl) {
	      if (angular.isString(file)) {
	        return $sce.trustAsResourceUrl(file);
	      }
	      var src = file && ((disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl);
	      if (file && !src) {
	        if (!file.$ngfDataUrlFilterInProgress && angular.isObject(file)) {
	          file.$ngfDataUrlFilterInProgress = true;
	          UploadDataUrl.dataUrl(file, disallowObjectUrl);
	        }
	        return '';
	      }
	      if (file) delete file.$ngfDataUrlFilterInProgress;
	      return (file && src ? (trustedUrl ? $sce.trustAsResourceUrl(src) : src) : file) || '';
	    };
	  }]);
	
	})();
	
	ngFileUpload.service('UploadValidate', ['UploadDataUrl', '$q', '$timeout', function (UploadDataUrl, $q, $timeout) {
	  var upload = UploadDataUrl;
	
	  function globStringToRegex(str) {
	    var regexp = '', excludes = [];
	    if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
	      regexp = str.substring(1, str.length - 1);
	    } else {
	      var split = str.split(',');
	      if (split.length > 1) {
	        for (var i = 0; i < split.length; i++) {
	          var r = globStringToRegex(split[i]);
	          if (r.regexp) {
	            regexp += '(' + r.regexp + ')';
	            if (i < split.length - 1) {
	              regexp += '|';
	            }
	          } else {
	            excludes = excludes.concat(r.excludes);
	          }
	        }
	      } else {
	        if (str.indexOf('!') === 0) {
	          excludes.push('^((?!' + globStringToRegex(str.substring(1)).regexp + ').)*$');
	        } else {
	          if (str.indexOf('.') === 0) {
	            str = '*' + str;
	          }
	          regexp = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'), '\\$&') + '$';
	          regexp = regexp.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
	        }
	      }
	    }
	    return {regexp: regexp, excludes: excludes};
	  }
	
	  upload.validatePattern = function (file, val) {
	    if (!val) {
	      return true;
	    }
	    var pattern = globStringToRegex(val), valid = true;
	    if (pattern.regexp && pattern.regexp.length) {
	      var regexp = new RegExp(pattern.regexp, 'i');
	      valid = (file.type != null && regexp.test(file.type)) ||
	        (file.name != null && regexp.test(file.name));
	    }
	    var len = pattern.excludes.length;
	    while (len--) {
	      var exclude = new RegExp(pattern.excludes[len], 'i');
	      valid = valid && (file.type == null || exclude.test(file.type)) &&
	        (file.name == null || exclude.test(file.name));
	    }
	    return valid;
	  };
	
	  upload.ratioToFloat = function (val) {
	    var r = val.toString(), xIndex = r.search(/[x:]/i);
	    if (xIndex > -1) {
	      r = parseFloat(r.substring(0, xIndex)) / parseFloat(r.substring(xIndex + 1));
	    } else {
	      r = parseFloat(r);
	    }
	    return r;
	  };
	
	  upload.registerModelChangeValidator = function (ngModel, attr, scope) {
	    if (ngModel) {
	      ngModel.$formatters.push(function (files) {
	        if (ngModel.$dirty) {
	          var filesArray = files;
	          if (files && !angular.isArray(files)) {
	            filesArray = [files];
	          }
	          upload.validate(filesArray, 0, ngModel, attr, scope).then(function () {
	            upload.applyModelValidation(ngModel, filesArray);
	          });
	        }
	        return files;
	      });
	    }
	  };
	
	  function markModelAsDirty(ngModel, files) {
	    if (files != null && !ngModel.$dirty) {
	      if (ngModel.$setDirty) {
	        ngModel.$setDirty();
	      } else {
	        ngModel.$dirty = true;
	      }
	    }
	  }
	
	  upload.applyModelValidation = function (ngModel, files) {
	    markModelAsDirty(ngModel, files);
	    angular.forEach(ngModel.$ngfValidations, function (validation) {
	      ngModel.$setValidity(validation.name, validation.valid);
	    });
	  };
	
	  upload.getValidationAttr = function (attr, scope, name, validationName, file) {
	    var dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
	    var val = upload.attrGetter(dName, attr, scope, {$file: file});
	    if (val == null) {
	      val = upload.attrGetter('ngfValidate', attr, scope, {$file: file});
	      if (val) {
	        var split = (validationName || name).split('.');
	        val = val[split[0]];
	        if (split.length > 1) {
	          val = val && val[split[1]];
	        }
	      }
	    }
	    return val;
	  };
	
	  upload.validate = function (files, prevLength, ngModel, attr, scope) {
	    ngModel = ngModel || {};
	    ngModel.$ngfValidations = ngModel.$ngfValidations || [];
	
	    angular.forEach(ngModel.$ngfValidations, function (v) {
	      v.valid = true;
	    });
	
	    var attrGetter = function (name, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    var ignoredErrors = (upload.attrGetter('ngfIgnoreInvalid', attr, scope) || '').split(' ');
	    var runAllValidation = upload.attrGetter('ngfRunAllValidations', attr, scope);
	
	    if (files == null || files.length === 0) {
	      return upload.emptyPromise({'validFiles': files, 'invalidFiles': []});
	    }
	
	    files = files.length === undefined ? [files] : files.slice(0);
	    var invalidFiles = [];
	
	    function validateSync(name, validationName, fn) {
	      if (files) {
	        var i = files.length, valid = null;
	        while (i--) {
	          var file = files[i];
	          if (file) {
	            var val = upload.getValidationAttr(attr, scope, name, validationName, file);
	            if (val != null) {
	              if (!fn(file, val, i)) {
	                if (ignoredErrors.indexOf(name) === -1) {
	                  file.$error = name;
	                  (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
	                  file.$errorParam = val;
	                  if (invalidFiles.indexOf(file) === -1) {
	                    invalidFiles.push(file);
	                  }
	                  if (!runAllValidation) {
	                    files.splice(i, 1);
	                  }
	                  valid = false;
	                } else {
	                  files.splice(i, 1);
	                }
	              }
	            }
	          }
	        }
	        if (valid !== null) {
	          ngModel.$ngfValidations.push({name: name, valid: valid});
	        }
	      }
	    }
	
	    validateSync('pattern', null, upload.validatePattern);
	    validateSync('minSize', 'size.min', function (file, val) {
	      return file.size + 0.1 >= upload.translateScalars(val);
	    });
	    validateSync('maxSize', 'size.max', function (file, val) {
	      return file.size - 0.1 <= upload.translateScalars(val);
	    });
	    var totalSize = 0;
	    validateSync('maxTotalSize', null, function (file, val) {
	      totalSize += file.size;
	      if (totalSize > upload.translateScalars(val)) {
	        files.splice(0, files.length);
	        return false;
	      }
	      return true;
	    });
	
	    validateSync('validateFn', null, function (file, r) {
	      return r === true || r === null || r === '';
	    });
	
	    if (!files.length) {
	      return upload.emptyPromise({'validFiles': [], 'invalidFiles': invalidFiles});
	    }
	
	    function validateAsync(name, validationName, type, asyncFn, fn) {
	      function resolveResult(defer, file, val) {
	        function resolveInternal(fn) {
	          if (fn()) {
	            if (ignoredErrors.indexOf(name) === -1) {
	              file.$error = name;
	              (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
	              file.$errorParam = val;
	              if (invalidFiles.indexOf(file) === -1) {
	                invalidFiles.push(file);
	              }
	              if (!runAllValidation) {
	                var i = files.indexOf(file);
	                if (i > -1) files.splice(i, 1);
	              }
	              defer.resolve(false);
	            } else {
	              var j = files.indexOf(file);
	              if (j > -1) files.splice(j, 1);
	              defer.resolve(true);
	            }
	          } else {
	            defer.resolve(true);
	          }
	        }
	
	        if (val != null) {
	          asyncFn(file, val).then(function (d) {
	            resolveInternal(function () {
	              return !fn(d, val);
	            });
	          }, function () {
	            resolveInternal(function () {
	              return attrGetter('ngfValidateForce', {$file: file});
	            });
	          });
	        } else {
	          defer.resolve(true);
	        }
	      }
	
	      var promises = [upload.emptyPromise(true)];
	      if (files) {
	        files = files.length === undefined ? [files] : files;
	        angular.forEach(files, function (file) {
	          var defer = $q.defer();
	          promises.push(defer.promise);
	          if (type && (file.type == null || file.type.search(type) !== 0)) {
	            defer.resolve(true);
	            return;
	          }
	          if (name === 'dimensions' && upload.attrGetter('ngfDimensions', attr) != null) {
	            upload.imageDimensions(file).then(function (d) {
	              resolveResult(defer, file,
	                attrGetter('ngfDimensions', {$file: file, $width: d.width, $height: d.height}));
	            }, function () {
	              defer.resolve(false);
	            });
	          } else if (name === 'duration' && upload.attrGetter('ngfDuration', attr) != null) {
	            upload.mediaDuration(file).then(function (d) {
	              resolveResult(defer, file,
	                attrGetter('ngfDuration', {$file: file, $duration: d}));
	            }, function () {
	              defer.resolve(false);
	            });
	          } else {
	            resolveResult(defer, file,
	              upload.getValidationAttr(attr, scope, name, validationName, file));
	          }
	        });
	      }
	      var deffer = $q.defer();
	      $q.all(promises).then(function (values) {
	        var isValid = true;
	        for (var i = 0; i < values.length; i++) {
	          if (!values[i]) {
	            isValid = false;
	            break;
	          }
	        }
	        ngModel.$ngfValidations.push({name: name, valid: isValid});
	        deffer.resolve(isValid);
	      });
	      return deffer.promise;
	    }
	
	    var deffer = $q.defer();
	    var promises = [];
	
	    promises.push(validateAsync('maxHeight', 'height.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.height <= val;
	      }));
	    promises.push(validateAsync('minHeight', 'height.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.height >= val;
	      }));
	    promises.push(validateAsync('maxWidth', 'width.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.width <= val;
	      }));
	    promises.push(validateAsync('minWidth', 'width.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.width >= val;
	      }));
	    promises.push(validateAsync('dimensions', null, /image/,
	      function (file, val) {
	        return upload.emptyPromise(val);
	      }, function (r) {
	        return r;
	      }));
	    promises.push(validateAsync('ratio', null, /image/,
	      this.imageDimensions, function (d, val) {
	        var split = val.toString().split(','), valid = false;
	        for (var i = 0; i < split.length; i++) {
	          if (Math.abs((d.width / d.height) - upload.ratioToFloat(split[i])) < 0.01) {
	            valid = true;
	          }
	        }
	        return valid;
	      }));
	    promises.push(validateAsync('maxRatio', 'ratio.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return (d.width / d.height) - upload.ratioToFloat(val) < 0.0001;
	      }));
	    promises.push(validateAsync('minRatio', 'ratio.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return (d.width / d.height) - upload.ratioToFloat(val) > -0.0001;
	      }));
	    promises.push(validateAsync('maxDuration', 'duration.max', /audio|video/,
	      this.mediaDuration, function (d, val) {
	        return d <= upload.translateScalars(val);
	      }));
	    promises.push(validateAsync('minDuration', 'duration.min', /audio|video/,
	      this.mediaDuration, function (d, val) {
	        return d >= upload.translateScalars(val);
	      }));
	    promises.push(validateAsync('duration', null, /audio|video/,
	      function (file, val) {
	        return upload.emptyPromise(val);
	      }, function (r) {
	        return r;
	      }));
	
	    promises.push(validateAsync('validateAsyncFn', null, null,
	      function (file, val) {
	        return val;
	      }, function (r) {
	        return r === true || r === null || r === '';
	      }));
	
	    $q.all(promises).then(function () {
	
	      if (runAllValidation) {
	        for (var i = 0; i < files.length; i++) {
	          var file = files[i];
	          if (file.$error) {
	            files.splice(i--, 1);
	          }
	        }
	      }
	
	      runAllValidation = false;
	      validateSync('maxFiles', null, function (file, val, i) {
	        return prevLength + i < val;
	      });
	
	      deffer.resolve({'validFiles': files, 'invalidFiles': invalidFiles});
	    });
	    return deffer.promise;
	  };
	
	  upload.imageDimensions = function (file) {
	    if (file.$ngfWidth && file.$ngfHeight) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve({width: file.$ngfWidth, height: file.$ngfHeight});
	      });
	      return d.promise;
	    }
	    if (file.$ngfDimensionPromise) return file.$ngfDimensionPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('image') !== 0) {
	        deferred.reject('not image');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var img = angular.element('<img>').attr('src', dataUrl)
	          .css('visibility', 'hidden').css('position', 'fixed')
	          .css('max-width', 'none !important').css('max-height', 'none !important');
	
	        function success() {
	          var width = img[0].naturalWidth || img[0].clientWidth;
	          var height = img[0].naturalHeight || img[0].clientHeight;
	          img.remove();
	          file.$ngfWidth = width;
	          file.$ngfHeight = height;
	          deferred.resolve({width: width, height: height});
	        }
	
	        function error() {
	          img.remove();
	          deferred.reject('load error');
	        }
	
	        img.on('load', success);
	        img.on('error', error);
	
	        var secondsCounter = 0;
	        function checkLoadErrorInCaseOfNoCallback() {
	          $timeout(function () {
	            if (img[0].parentNode) {
	              if (img[0].clientWidth) {
	                success();
	              } else if (secondsCounter++ > 10) {
	                error();
	              } else {
	                checkLoadErrorInCaseOfNoCallback();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadErrorInCaseOfNoCallback();
	
	        angular.element(document.getElementsByTagName('body')[0]).append(img);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDimensionPromise = deferred.promise;
	    file.$ngfDimensionPromise['finally'](function () {
	      delete file.$ngfDimensionPromise;
	    });
	    return file.$ngfDimensionPromise;
	  };
	
	  upload.mediaDuration = function (file) {
	    if (file.$ngfDuration) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve(file.$ngfDuration);
	      });
	      return d.promise;
	    }
	    if (file.$ngfDurationPromise) return file.$ngfDurationPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('audio') !== 0 && file.type.indexOf('video') !== 0) {
	        deferred.reject('not media');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var el = angular.element(file.type.indexOf('audio') === 0 ? '<audio>' : '<video>')
	          .attr('src', dataUrl).css('visibility', 'none').css('position', 'fixed');
	
	        function success() {
	          var duration = el[0].duration;
	          file.$ngfDuration = duration;
	          el.remove();
	          deferred.resolve(duration);
	        }
	
	        function error() {
	          el.remove();
	          deferred.reject('load error');
	        }
	
	        el.on('loadedmetadata', success);
	        el.on('error', error);
	        var count = 0;
	
	        function checkLoadError() {
	          $timeout(function () {
	            if (el[0].parentNode) {
	              if (el[0].duration) {
	                success();
	              } else if (count > 10) {
	                error();
	              } else {
	                checkLoadError();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadError();
	
	        angular.element(document.body).append(el);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDurationPromise = deferred.promise;
	    file.$ngfDurationPromise['finally'](function () {
	      delete file.$ngfDurationPromise;
	    });
	    return file.$ngfDurationPromise;
	  };
	  return upload;
	}
	]);
	
	ngFileUpload.service('UploadResize', ['UploadValidate', '$q', function (UploadValidate, $q) {
	  var upload = UploadValidate;
	
	  /**
	   * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
	   * images to fit into a certain area.
	   * Source:  http://stackoverflow.com/a/14731922
	   *
	   * @param {Number} srcWidth Source area width
	   * @param {Number} srcHeight Source area height
	   * @param {Number} maxWidth Nestable area maximum available width
	   * @param {Number} maxHeight Nestable area maximum available height
	   * @return {Object} { width, height }
	   */
	  var calculateAspectRatioFit = function (srcWidth, srcHeight, maxWidth, maxHeight, centerCrop) {
	    var ratio = centerCrop ? Math.max(maxWidth / srcWidth, maxHeight / srcHeight) :
	      Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
	    return {
	      width: srcWidth * ratio, height: srcHeight * ratio,
	      marginX: srcWidth * ratio - maxWidth, marginY: srcHeight * ratio - maxHeight
	    };
	  };
	
	  // Extracted from https://github.com/romelgomez/angular-firebase-image-upload/blob/master/app/scripts/fileUpload.js#L89
	  var resize = function (imagen, width, height, quality, type, ratio, centerCrop, resizeIf) {
	    var deferred = $q.defer();
	    var canvasElement = document.createElement('canvas');
	    var imageElement = document.createElement('img');
	    imageElement.setAttribute('style', 'visibility:hidden;position:fixed;z-index:-100000');
	    document.body.appendChild(imageElement);
	
	    imageElement.onload = function () {
	      var imgWidth = imageElement.width, imgHeight = imageElement.height;
	      imageElement.parentNode.removeChild(imageElement);
	      if (resizeIf != null && resizeIf(imgWidth, imgHeight) === false) {
	        deferred.reject('resizeIf');
	        return;
	      }
	      try {
	        if (ratio) {
	          var ratioFloat = upload.ratioToFloat(ratio);
	          var imgRatio = imgWidth / imgHeight;
	          if (imgRatio < ratioFloat) {
	            width = imgWidth;
	            height = width / ratioFloat;
	          } else {
	            height = imgHeight;
	            width = height * ratioFloat;
	          }
	        }
	        if (!width) {
	          width = imgWidth;
	        }
	        if (!height) {
	          height = imgHeight;
	        }
	        var dimensions = calculateAspectRatioFit(imgWidth, imgHeight, width, height, centerCrop);
	        canvasElement.width = Math.min(dimensions.width, width);
	        canvasElement.height = Math.min(dimensions.height, height);
	        var context = canvasElement.getContext('2d');
	        context.drawImage(imageElement,
	          Math.min(0, -dimensions.marginX / 2), Math.min(0, -dimensions.marginY / 2),
	          dimensions.width, dimensions.height);
	        deferred.resolve(canvasElement.toDataURL(type || 'image/WebP', quality || 0.934));
	      } catch (e) {
	        deferred.reject(e);
	      }
	    };
	    imageElement.onerror = function () {
	      imageElement.parentNode.removeChild(imageElement);
	      deferred.reject();
	    };
	    imageElement.src = imagen;
	    return deferred.promise;
	  };
	
	  upload.dataUrltoBlob = function (dataurl, name, origSize) {
	    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
	      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
	    while (n--) {
	      u8arr[n] = bstr.charCodeAt(n);
	    }
	    var blob = new window.Blob([u8arr], {type: mime});
	    blob.name = name;
	    blob.$ngfOrigSize = origSize;
	    return blob;
	  };
	
	  upload.isResizeSupported = function () {
	    var elem = document.createElement('canvas');
	    return window.atob && elem.getContext && elem.getContext('2d') && window.Blob;
	  };
	
	  if (upload.isResizeSupported()) {
	    // add name getter to the blob constructor prototype
	    Object.defineProperty(window.Blob.prototype, 'name', {
	      get: function () {
	        return this.$ngfName;
	      },
	      set: function (v) {
	        this.$ngfName = v;
	      },
	      configurable: true
	    });
	  }
	
	  upload.resize = function (file, options) {
	    if (file.type.indexOf('image') !== 0) return upload.emptyPromise(file);
	
	    var deferred = $q.defer();
	    upload.dataUrl(file, true).then(function (url) {
	      resize(url, options.width, options.height, options.quality, options.type || file.type,
	        options.ratio, options.centerCrop, options.resizeIf)
	        .then(function (dataUrl) {
	          if (file.type === 'image/jpeg' && options.restoreExif !== false) {
	            try {
	              dataUrl = upload.restoreExif(url, dataUrl);
	            } catch (e) {
	              setTimeout(function () {throw e;}, 1);
	            }
	          }
	          try {
	            var blob = upload.dataUrltoBlob(dataUrl, file.name, file.size);
	            deferred.resolve(blob);
	          } catch (e) {
	            deferred.reject(e);
	          }
	        }, function (r) {
	          if (r === 'resizeIf') {
	            deferred.resolve(file);
	          }
	          deferred.reject(r);
	        });
	    }, function (e) {
	      deferred.reject(e);
	    });
	    return deferred.promise;
	  };
	
	  return upload;
	}]);
	
	(function () {
	  ngFileUpload.directive('ngfDrop', ['$parse', '$timeout', '$window', 'Upload', '$http', '$q',
	    function ($parse, $timeout, $window, Upload, $http, $q) {
	      return {
	        restrict: 'AEC',
	        require: '?ngModel',
	        link: function (scope, elem, attr, ngModel) {
	          linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, Upload, $http, $q);
	        }
	      };
	    }]);
	
	  ngFileUpload.directive('ngfNoFileDrop', function () {
	    return function (scope, elem) {
	      if (dropAvailable()) elem.css('display', 'none');
	    };
	  });
	
	  ngFileUpload.directive('ngfDropAvailable', ['$parse', '$timeout', 'Upload', function ($parse, $timeout, Upload) {
	    return function (scope, elem, attr) {
	      if (dropAvailable()) {
	        var model = $parse(Upload.attrGetter('ngfDropAvailable', attr));
	        $timeout(function () {
	          model(scope);
	          if (model.assign) {
	            model.assign(scope, true);
	          }
	        });
	      }
	    };
	  }]);
	
	  function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, upload, $http, $q) {
	    var available = dropAvailable();
	
	    var attrGetter = function (name, scope, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    if (attrGetter('dropAvailable')) {
	      $timeout(function () {
	        if (scope[attrGetter('dropAvailable')]) {
	          scope[attrGetter('dropAvailable')].value = available;
	        } else {
	          scope[attrGetter('dropAvailable')] = available;
	        }
	      });
	    }
	    if (!available) {
	      if (attrGetter('ngfHideOnDropNotAvailable', scope) === true) {
	        elem.css('display', 'none');
	      }
	      return;
	    }
	
	    function isDisabled() {
	      return elem.attr('disabled') || attrGetter('ngfDropDisabled', scope);
	    }
	
	    if (attrGetter('ngfSelect') == null) {
	      upload.registerModelChangeValidator(ngModel, attr, scope);
	    }
	
	    var leaveTimeout = null;
	    var stopPropagation = $parse(attrGetter('ngfStopPropagation'));
	    var dragOverDelay = 1;
	    var actualDragOverClass;
	
	    elem[0].addEventListener('dragover', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      // handling dragover events from the Chrome download bar
	      if (navigator.userAgent.indexOf('Chrome') > -1) {
	        var b = evt.dataTransfer.effectAllowed;
	        evt.dataTransfer.dropEffect = ('move' === b || 'linkMove' === b) ? 'move' : 'copy';
	      }
	      $timeout.cancel(leaveTimeout);
	      if (!actualDragOverClass) {
	        actualDragOverClass = 'C';
	        calculateDragOverClass(scope, attr, evt, function (clazz) {
	          actualDragOverClass = clazz;
	          elem.addClass(actualDragOverClass);
	          attrGetter('ngfDrag', scope, {$isDragging: true, $class: actualDragOverClass, $event: evt});
	        });
	      }
	    }, false);
	    elem[0].addEventListener('dragenter', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	    }, false);
	    elem[0].addEventListener('dragleave', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      leaveTimeout = $timeout(function () {
	        if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	        actualDragOverClass = null;
	        attrGetter('ngfDrag', scope, {$isDragging: false, $event: evt});
	      }, dragOverDelay || 100);
	    }, false);
	    elem[0].addEventListener('drop', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	      actualDragOverClass = null;
	      extractFilesAndUpdateModel(evt.dataTransfer, evt, 'dropUrl');
	    }, false);
	    elem[0].addEventListener('paste', function (evt) {
	      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
	        attrGetter('ngfEnableFirefoxPaste', scope)) {
	        evt.preventDefault();
	      }
	      if (isDisabled() || !upload.shouldUpdateOn('paste', attr, scope)) return;
	      extractFilesAndUpdateModel(evt.clipboardData || evt.originalEvent.clipboardData, evt, 'pasteUrl');
	    }, false);
	
	    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
	      attrGetter('ngfEnableFirefoxPaste', scope)) {
	      elem.attr('contenteditable', true);
	      elem.on('keypress', function (e) {
	        if (!e.metaKey && !e.ctrlKey) {
	          e.preventDefault();
	        }
	      });
	    }
	
	    function extractFilesAndUpdateModel(source, evt, updateOnType) {
	      if (!source) return;
	      // html needs to be calculated on the same process otherwise the data will be wiped
	      // after promise resolve or setTimeout.
	      var html;
	      try {
	        html = source && source.getData && source.getData('text/html');
	      } catch (e) {/* Fix IE11 that throw error calling getData */
	      }
	      extractFiles(source.items, source.files, attrGetter('ngfAllowDir', scope) !== false,
	        attrGetter('multiple') || attrGetter('ngfMultiple', scope)).then(function (files) {
	        if (files.length) {
	          updateModel(files, evt);
	        } else {
	          extractFilesFromHtml(updateOnType, html).then(function (files) {
	            updateModel(files, evt);
	          });
	        }
	      });
	    }
	
	    function updateModel(files, evt) {
	      upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
	    }
	
	    function extractFilesFromHtml(updateOn, html) {
	      if (!upload.shouldUpdateOn(updateOn, attr, scope) || typeof html !== 'string') return upload.rejectPromise([]);
	      var urls = [];
	      html.replace(/<(img src|img [^>]* src) *=\"([^\"]*)\"/gi, function (m, n, src) {
	        urls.push(src);
	      });
	      var promises = [], files = [];
	      if (urls.length) {
	        angular.forEach(urls, function (url) {
	          promises.push(upload.urlToBlob(url).then(function (blob) {
	            files.push(blob);
	          }));
	        });
	        var defer = $q.defer();
	        $q.all(promises).then(function () {
	          defer.resolve(files);
	        }, function (e) {
	          defer.reject(e);
	        });
	        return defer.promise;
	      }
	      return upload.emptyPromise();
	    }
	
	    function calculateDragOverClass(scope, attr, evt, callback) {
	      var obj = attrGetter('ngfDragOverClass', scope, {$event: evt}), dClass = 'dragover';
	      if (angular.isString(obj)) {
	        dClass = obj;
	      } else if (obj) {
	        if (obj.delay) dragOverDelay = obj.delay;
	        if (obj.accept || obj.reject) {
	          var items = evt.dataTransfer.items;
	          if (items == null || !items.length) {
	            dClass = obj.accept;
	          } else {
	            var pattern = obj.pattern || attrGetter('ngfPattern', scope, {$event: evt});
	            var len = items.length;
	            while (len--) {
	              if (!upload.validatePattern(items[len], pattern)) {
	                dClass = obj.reject;
	                break;
	              } else {
	                dClass = obj.accept;
	              }
	            }
	          }
	        }
	      }
	      callback(dClass);
	    }
	
	    function extractFiles(items, fileList, allowDir, multiple) {
	      var maxFiles = upload.getValidationAttr(attr, scope, 'maxFiles');
	      if (maxFiles == null) {
	        maxFiles = Number.MAX_VALUE;
	      }
	      var maxTotalSize = upload.getValidationAttr(attr, scope, 'maxTotalSize');
	      if (maxTotalSize == null) {
	        maxTotalSize = Number.MAX_VALUE;
	      }
	      var includeDir = attrGetter('ngfIncludeDir', scope);
	      var files = [], totalSize = 0;
	
	      function traverseFileTree(entry, path) {
	        var defer = $q.defer();
	        if (entry != null) {
	          if (entry.isDirectory) {
	            var promises = [upload.emptyPromise()];
	            if (includeDir) {
	              var file = {type: 'directory'};
	              file.name = file.path = (path || '') + entry.name;
	              files.push(file);
	            }
	            var dirReader = entry.createReader();
	            var entries = [];
	            var readEntries = function () {
	              dirReader.readEntries(function (results) {
	                try {
	                  if (!results.length) {
	                    angular.forEach(entries.slice(0), function (e) {
	                      if (files.length <= maxFiles && totalSize <= maxTotalSize) {
	                        promises.push(traverseFileTree(e, (path ? path : '') + entry.name + '/'));
	                      }
	                    });
	                    $q.all(promises).then(function () {
	                      defer.resolve();
	                    }, function (e) {
	                      defer.reject(e);
	                    });
	                  } else {
	                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
	                    readEntries();
	                  }
	                } catch (e) {
	                  defer.reject(e);
	                }
	              }, function (e) {
	                defer.reject(e);
	              });
	            };
	            readEntries();
	          } else {
	            entry.file(function (file) {
	              try {
	                file.path = (path ? path : '') + file.name;
	                if (includeDir) {
	                  file = upload.rename(file, file.path);
	                }
	                files.push(file);
	                totalSize += file.size;
	                defer.resolve();
	              } catch (e) {
	                defer.reject(e);
	              }
	            }, function (e) {
	              defer.reject(e);
	            });
	          }
	        }
	        return defer.promise;
	      }
	
	      var promises = [upload.emptyPromise()];
	
	      if (items && items.length > 0 && $window.location.protocol !== 'file:') {
	        for (var i = 0; i < items.length; i++) {
	          if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
	            var entry = items[i].webkitGetAsEntry();
	            if (entry.isDirectory && !allowDir) {
	              continue;
	            }
	            if (entry != null) {
	              promises.push(traverseFileTree(entry));
	            }
	          } else {
	            var f = items[i].getAsFile();
	            if (f != null) {
	              files.push(f);
	              totalSize += f.size;
	            }
	          }
	          if (files.length > maxFiles || totalSize > maxTotalSize ||
	            (!multiple && files.length > 0)) break;
	        }
	      } else {
	        if (fileList != null) {
	          for (var j = 0; j < fileList.length; j++) {
	            var file = fileList.item(j);
	            if (file.type || file.size > 0) {
	              files.push(file);
	              totalSize += file.size;
	            }
	            if (files.length > maxFiles || totalSize > maxTotalSize ||
	              (!multiple && files.length > 0)) break;
	          }
	        }
	      }
	
	      var defer = $q.defer();
	      $q.all(promises).then(function () {
	        if (!multiple && !includeDir && files.length) {
	          var i = 0;
	          while (files[i] && files[i].type === 'directory') i++;
	          defer.resolve([files[i]]);
	        } else {
	          defer.resolve(files);
	        }
	      }, function (e) {
	        defer.reject(e);
	      });
	
	      return defer.promise;
	    }
	  }
	
	  function dropAvailable() {
	    var div = document.createElement('div');
	    return ('draggable' in div) && ('ondrop' in div) && !/Edge\/12./i.test(navigator.userAgent);
	  }
	
	})();
	
	// customized version of https://github.com/exif-js/exif-js
	ngFileUpload.service('UploadExif', ['UploadResize', '$q', function (UploadResize, $q) {
	  var upload = UploadResize;
	
	  upload.isExifSupported = function () {
	    return window.FileReader && new FileReader().readAsArrayBuffer && upload.isResizeSupported();
	  };
	
	  function applyTransform(ctx, orientation, width, height) {
	    switch (orientation) {
	      case 2:
	        return ctx.transform(-1, 0, 0, 1, width, 0);
	      case 3:
	        return ctx.transform(-1, 0, 0, -1, width, height);
	      case 4:
	        return ctx.transform(1, 0, 0, -1, 0, height);
	      case 5:
	        return ctx.transform(0, 1, 1, 0, 0, 0);
	      case 6:
	        return ctx.transform(0, 1, -1, 0, height, 0);
	      case 7:
	        return ctx.transform(0, -1, -1, 0, height, width);
	      case 8:
	        return ctx.transform(0, -1, 1, 0, 0, width);
	    }
	  }
	
	  upload.readOrientation = function (file) {
	    var defer = $q.defer();
	    var reader = new FileReader();
	    var slicedFile = file.slice ? file.slice(0, 64 * 1024) : file;
	    reader.readAsArrayBuffer(slicedFile);
	    reader.onerror = function (e) {
	      return defer.reject(e);
	    };
	    reader.onload = function (e) {
	      var result = {orientation: 1};
	      var view = new DataView(this.result);
	      if (view.getUint16(0, false) !== 0xFFD8) return defer.resolve(result);
	
	      var length = view.byteLength,
	        offset = 2;
	      while (offset < length) {
	        var marker = view.getUint16(offset, false);
	        offset += 2;
	        if (marker === 0xFFE1) {
	          if (view.getUint32(offset += 2, false) !== 0x45786966) return defer.resolve(result);
	
	          var little = view.getUint16(offset += 6, false) === 0x4949;
	          offset += view.getUint32(offset + 4, little);
	          var tags = view.getUint16(offset, little);
	          offset += 2;
	          for (var i = 0; i < tags; i++)
	            if (view.getUint16(offset + (i * 12), little) === 0x0112) {
	              var orientation = view.getUint16(offset + (i * 12) + 8, little);
	              if (orientation >= 2 && orientation <= 8) {
	                view.setUint16(offset + (i * 12) + 8, 1, little);
	                result.fixedArrayBuffer = e.target.result;
	              }
	              result.orientation = orientation;
	              return defer.resolve(result);
	            }
	        } else if ((marker & 0xFF00) !== 0xFF00) break;
	        else offset += view.getUint16(offset, false);
	      }
	      return defer.resolve(result);
	    };
	    return defer.promise;
	  };
	
	  function arrayBufferToBase64(buffer) {
	    var binary = '';
	    var bytes = new Uint8Array(buffer);
	    var len = bytes.byteLength;
	    for (var i = 0; i < len; i++) {
	      binary += String.fromCharCode(bytes[i]);
	    }
	    return window.btoa(binary);
	  }
	
	  upload.applyExifRotation = function (file) {
	    if (file.type.indexOf('image/jpeg') !== 0) {
	      return upload.emptyPromise(file);
	    }
	
	    var deferred = $q.defer();
	    upload.readOrientation(file).then(function (result) {
	      if (result.orientation < 2 || result.orientation > 8) {
	        return deferred.resolve(file);
	      }
	      upload.dataUrl(file, true).then(function (url) {
	        var canvas = document.createElement('canvas');
	        var img = document.createElement('img');
	
	        img.onload = function () {
	          try {
	            canvas.width = result.orientation > 4 ? img.height : img.width;
	            canvas.height = result.orientation > 4 ? img.width : img.height;
	            var ctx = canvas.getContext('2d');
	            applyTransform(ctx, result.orientation, img.width, img.height);
	            ctx.drawImage(img, 0, 0);
	            var dataUrl = canvas.toDataURL(file.type || 'image/WebP', 0.934);
	            dataUrl = upload.restoreExif(arrayBufferToBase64(result.fixedArrayBuffer), dataUrl);
	            var blob = upload.dataUrltoBlob(dataUrl, file.name);
	            deferred.resolve(blob);
	          } catch (e) {
	            return deferred.reject(e);
	          }
	        };
	        img.onerror = function () {
	          deferred.reject();
	        };
	        img.src = url;
	      }, function (e) {
	        deferred.reject(e);
	      });
	    }, function (e) {
	      deferred.reject(e);
	    });
	    return deferred.promise;
	  };
	
	  upload.restoreExif = function (orig, resized) {
	    var ExifRestorer = {};
	
	    ExifRestorer.KEY_STR = 'ABCDEFGHIJKLMNOP' +
	      'QRSTUVWXYZabcdef' +
	      'ghijklmnopqrstuv' +
	      'wxyz0123456789+/' +
	      '=';
	
	    ExifRestorer.encode64 = function (input) {
	      var output = '',
	        chr1, chr2, chr3 = '',
	        enc1, enc2, enc3, enc4 = '',
	        i = 0;
	
	      do {
	        chr1 = input[i++];
	        chr2 = input[i++];
	        chr3 = input[i++];
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        enc4 = chr3 & 63;
	
	        if (isNaN(chr2)) {
	          enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	          enc4 = 64;
	        }
	
	        output = output +
	          this.KEY_STR.charAt(enc1) +
	          this.KEY_STR.charAt(enc2) +
	          this.KEY_STR.charAt(enc3) +
	          this.KEY_STR.charAt(enc4);
	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';
	      } while (i < input.length);
	
	      return output;
	    };
	
	    ExifRestorer.restore = function (origFileBase64, resizedFileBase64) {
	      if (origFileBase64.match('data:image/jpeg;base64,')) {
	        origFileBase64 = origFileBase64.replace('data:image/jpeg;base64,', '');
	      }
	
	      var rawImage = this.decode64(origFileBase64);
	      var segments = this.slice2Segments(rawImage);
	
	      var image = this.exifManipulation(resizedFileBase64, segments);
	
	      return 'data:image/jpeg;base64,' + this.encode64(image);
	    };
	
	
	    ExifRestorer.exifManipulation = function (resizedFileBase64, segments) {
	      var exifArray = this.getExifArray(segments),
	        newImageArray = this.insertExif(resizedFileBase64, exifArray);
	      return new Uint8Array(newImageArray);
	    };
	
	
	    ExifRestorer.getExifArray = function (segments) {
	      var seg;
	      for (var x = 0; x < segments.length; x++) {
	        seg = segments[x];
	        if (seg[0] === 255 & seg[1] === 225) //(ff e1)
	        {
	          return seg;
	        }
	      }
	      return [];
	    };
	
	
	    ExifRestorer.insertExif = function (resizedFileBase64, exifArray) {
	      var imageData = resizedFileBase64.replace('data:image/jpeg;base64,', ''),
	        buf = this.decode64(imageData),
	        separatePoint = buf.indexOf(255, 3),
	        mae = buf.slice(0, separatePoint),
	        ato = buf.slice(separatePoint),
	        array = mae;
	
	      array = array.concat(exifArray);
	      array = array.concat(ato);
	      return array;
	    };
	
	
	    ExifRestorer.slice2Segments = function (rawImageArray) {
	      var head = 0,
	        segments = [];
	
	      while (1) {
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) {
	          break;
	        }
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) {
	          head += 2;
	        }
	        else {
	          var length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3],
	            endPoint = head + length + 2,
	            seg = rawImageArray.slice(head, endPoint);
	          segments.push(seg);
	          head = endPoint;
	        }
	        if (head > rawImageArray.length) {
	          break;
	        }
	      }
	
	      return segments;
	    };
	
	
	    ExifRestorer.decode64 = function (input) {
	      var chr1, chr2, chr3 = '',
	        enc1, enc2, enc3, enc4 = '',
	        i = 0,
	        buf = [];
	
	      // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
	      var base64test = /[^A-Za-z0-9\+\/\=]/g;
	      if (base64test.exec(input)) {
	        console.log('There were invalid base64 characters in the input text.\n' +
	          'Valid base64 characters are A-Z, a-z, 0-9, ' + ', ' / ',and "="\n' +
	          'Expect errors in decoding.');
	      }
	      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
	
	      do {
	        enc1 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc2 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc3 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc4 = this.KEY_STR.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        buf.push(chr1);
	
	        if (enc3 !== 64) {
	          buf.push(chr2);
	        }
	        if (enc4 !== 64) {
	          buf.push(chr3);
	        }
	
	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';
	
	      } while (i < input.length);
	
	      return buf;
	    };
	
	    return ExifRestorer.restore(orig, resized);  //<= EXIF
	  };
	
	  return upload;
	}]);
	


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(45);
	var image = "<symbol viewBox=\"0 0 20 20\" id=\"Upload-20px\" ><style>#Upload-20px .st0{fill:#959595}</style><path class=\"st0\" d=\"M2 1h16v3H2zm2.5 9.5l1 1 3.8-3.8V20h1.4V7.7l3.8 3.8 1-1L10 5l-5.5 5.5z\"/></symbol>";
	module.exports = sprite.add(image, "Upload-20px");

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var Sprite = __webpack_require__(46);
	var globalSprite = new Sprite();
	
	if (document.body) {
	  globalSprite.elem = globalSprite.render(document.body);
	} else {
	  document.addEventListener('DOMContentLoaded', function () {
	    globalSprite.elem = globalSprite.render(document.body);
	  }, false);
	}
	
	module.exports = globalSprite;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var Sniffr = __webpack_require__(47);
	
	/**
	 * List of SVG attributes to fix url target in them
	 * @type {string[]}
	 */
	var fixAttributes = [
	  'clipPath',
	  'colorProfile',
	  'src',
	  'cursor',
	  'fill',
	  'filter',
	  'marker',
	  'markerStart',
	  'markerMid',
	  'markerEnd',
	  'mask',
	  'stroke'
	];
	
	/**
	 * Query to find'em
	 * @type {string}
	 */
	var fixAttributesQuery = '[' + fixAttributes.join('],[') + ']';
	/**
	 * @type {RegExp}
	 */
	var URI_FUNC_REGEX = /^url\((.*)\)$/;
	
	/**
	 * Convert array-like to array
	 * @param {Object} arrayLike
	 * @returns {Array.<*>}
	 */
	function arrayFrom(arrayLike) {
	  return Array.prototype.slice.call(arrayLike, 0);
	}
	
	/**
	 * Handles forbidden symbols which cannot be directly used inside attributes with url(...) content.
	 * Adds leading slash for the brackets
	 * @param {string} url
	 * @return {string} encoded url
	 */
	function encodeUrlForEmbedding(url) {
	  return url.replace(/\(|\)/g, "\\$&");
	}
	
	/**
	 * Replaces prefix in `url()` functions
	 * @param {Element} svg
	 * @param {string} currentUrlPrefix
	 * @param {string} newUrlPrefix
	 */
	function baseUrlWorkAround(svg, currentUrlPrefix, newUrlPrefix) {
	  var nodes = svg.querySelectorAll(fixAttributesQuery);
	
	  if (!nodes) {
	    return;
	  }
	
	  arrayFrom(nodes).forEach(function (node) {
	    if (!node.attributes) {
	      return;
	    }
	
	    arrayFrom(node.attributes).forEach(function (attribute) {
	      var attributeName = attribute.localName.toLowerCase();
	
	      if (fixAttributes.indexOf(attributeName) !== -1) {
	        var match = URI_FUNC_REGEX.exec(node.getAttribute(attributeName));
	
	        // Do not touch urls with unexpected prefix
	        if (match && match[1].indexOf(currentUrlPrefix) === 0) {
	          var referenceUrl = encodeUrlForEmbedding(newUrlPrefix + match[1].split(currentUrlPrefix)[1]);
	          node.setAttribute(attributeName, 'url(' + referenceUrl + ')');
	        }
	      }
	    });
	  });
	}
	
	/**
	 * Because of Firefox bug #353575 gradients and patterns don't work if they are within a symbol.
	 * To workaround this we move the gradient definition outside the symbol element
	 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=353575
	 * @param {Element} svg
	 */
	var FirefoxSymbolBugWorkaround = function (svg) {
	  var defs = svg.querySelector('defs');
	
	  var moveToDefsElems = svg.querySelectorAll('symbol linearGradient, symbol radialGradient, symbol pattern');
	  for (var i = 0, len = moveToDefsElems.length; i < len; i++) {
	    defs.appendChild(moveToDefsElems[i]);
	  }
	};
	
	/**
	 * Fix for browser (IE, maybe other too) which are throwing 'WrongDocumentError'
	 * if you insert an element which is not part of the document
	 * @see http://stackoverflow.com/questions/7981100/how-do-i-dynamically-insert-an-svg-image-into-html#7986519
	 * @param {Element} svg
	 */
	function importSvg(svg) {
	  try {
	    if (document.importNode) {
	      return document.importNode(svg, true);
	    }
	  } catch(e) {}
	
	  return svg;
	}
	
	/**
	 * @type {string}
	 */
	var DEFAULT_URI_PREFIX = '#';
	
	/**
	 * @type {string}
	 */
	var xLinkHref = 'xlink:href';
	/**
	 * @type {string}
	 */
	var xLinkNS = 'http://www.w3.org/1999/xlink';
	/**
	 * @type {string}
	 */
	var svgOpening = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="' + xLinkNS + '"';
	/**
	 * @type {string}
	 */
	var svgClosing = '</svg>';
	/**
	 * @type {string}
	 */
	var contentPlaceHolder = '{content}';
	
	/**
	 * Representation of SVG sprite
	 * @constructor
	 */
	function Sprite() {
	  var baseElement = document.getElementsByTagName('base')[0];
	  var currentUrl = window.location.href.split('#')[0];
	  var baseUrl = baseElement && baseElement.href;
	  this.urlPrefix = baseUrl && baseUrl !== currentUrl ? currentUrl + DEFAULT_URI_PREFIX : DEFAULT_URI_PREFIX;
	
	  var sniffr = new Sniffr();
	  sniffr.sniff();
	  this.browser = sniffr.browser;
	  this.content = [];
	
	  if (this.browser.name !== 'ie' && baseUrl) {
	    window.addEventListener('spriteLoaderLocationUpdated', function (e) {
	      var currentPrefix = this.urlPrefix;
	      var newUrlPrefix = e.detail.newUrl.split(DEFAULT_URI_PREFIX)[0] + DEFAULT_URI_PREFIX;
	      baseUrlWorkAround(this.svg, currentPrefix, newUrlPrefix);
	      this.urlPrefix = newUrlPrefix;
	
	      if (this.browser.name === 'firefox' || this.browser.name === 'edge' || this.browser.name === 'chrome' && this.browser.version[0] >= 49) {
	        var nodes = arrayFrom(document.querySelectorAll('use[*|href]'));
	        nodes.forEach(function (node) {
	          var href = node.getAttribute(xLinkHref);
	          if (href && href.indexOf(currentPrefix) === 0) {
	            node.setAttributeNS(xLinkNS, xLinkHref, newUrlPrefix + href.split(DEFAULT_URI_PREFIX)[1]);
	          }
	        });
	      }
	    }.bind(this));
	  }
	}
	
	Sprite.styles = ['position:absolute', 'width:0', 'height:0'];
	
	Sprite.spriteTemplate = function(){ return svgOpening + ' style="'+ Sprite.styles.join(';') +'"><defs>' + contentPlaceHolder + '</defs>' + svgClosing; }
	Sprite.symbolTemplate = function() { return svgOpening + '>' + contentPlaceHolder + svgClosing; }
	
	/**
	 * @type {Array<String>}
	 */
	Sprite.prototype.content = null;
	
	/**
	 * @param {String} content
	 * @param {String} id
	 */
	Sprite.prototype.add = function (content, id) {
	  if (this.svg) {
	    this.appendSymbol(content);
	  }
	
	  this.content.push(content);
	
	  return DEFAULT_URI_PREFIX + id;
	};
	
	/**
	 *
	 * @param content
	 * @param template
	 * @returns {Element}
	 */
	Sprite.prototype.wrapSVG = function (content, template) {
	  var svgString = template.replace(contentPlaceHolder, content);
	
	  var svg = new DOMParser().parseFromString(svgString, 'image/svg+xml').documentElement;
	  var importedSvg = importSvg(svg);
	
	  if (this.browser.name !== 'ie' && this.urlPrefix) {
	    baseUrlWorkAround(importedSvg, DEFAULT_URI_PREFIX, this.urlPrefix);
	  }
	
	  return importedSvg;
	};
	
	Sprite.prototype.appendSymbol = function (content) {
	  var symbol = this.wrapSVG(content, Sprite.symbolTemplate()).childNodes[0];
	
	  this.svg.querySelector('defs').appendChild(symbol);
	  if (this.browser.name === 'firefox') {
	    FirefoxSymbolBugWorkaround(this.svg);
	  }
	};
	
	/**
	 * @returns {String}
	 */
	Sprite.prototype.toString = function () {
	  var wrapper = document.createElement('div');
	  wrapper.appendChild(this.render());
	  return wrapper.innerHTML;
	};
	
	/**
	 * @param {HTMLElement} [target]
	 * @param {Boolean} [prepend=true]
	 * @returns {HTMLElement} Rendered sprite node
	 */
	Sprite.prototype.render = function (target, prepend) {
	  target = target || null;
	  prepend = typeof prepend === 'boolean' ? prepend : true;
	
	  var svg = this.wrapSVG(this.content.join(''), Sprite.spriteTemplate());
	
	  if (this.browser.name === 'firefox') {
	    FirefoxSymbolBugWorkaround(svg);
	  }
	
	  if (target) {
	    if (prepend && target.childNodes[0]) {
	      target.insertBefore(svg, target.childNodes[0]);
	    } else {
	      target.appendChild(svg);
	    }
	  }
	
	  this.svg = svg;
	
	  return svg;
	};
	
	module.exports = Sprite;


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	(function(host) {
	
	  var properties = {
	    browser: [
	      [/msie ([\.\_\d]+)/, "ie"],
	      [/trident\/.*?rv:([\.\_\d]+)/, "ie"],
	      [/firefox\/([\.\_\d]+)/, "firefox"],
	      [/chrome\/([\.\_\d]+)/, "chrome"],
	      [/version\/([\.\_\d]+).*?safari/, "safari"],
	      [/mobile safari ([\.\_\d]+)/, "safari"],
	      [/android.*?version\/([\.\_\d]+).*?safari/, "com.android.browser"],
	      [/crios\/([\.\_\d]+).*?safari/, "chrome"],
	      [/opera/, "opera"],
	      [/opera\/([\.\_\d]+)/, "opera"],
	      [/opera ([\.\_\d]+)/, "opera"],
	      [/opera mini.*?version\/([\.\_\d]+)/, "opera.mini"],
	      [/opios\/([a-z\.\_\d]+)/, "opera"],
	      [/blackberry/, "blackberry"],
	      [/blackberry.*?version\/([\.\_\d]+)/, "blackberry"],
	      [/bb\d+.*?version\/([\.\_\d]+)/, "blackberry"],
	      [/rim.*?version\/([\.\_\d]+)/, "blackberry"],
	      [/iceweasel\/([\.\_\d]+)/, "iceweasel"],
	      [/edge\/([\.\d]+)/, "edge"]
	    ],
	    os: [
	      [/linux ()([a-z\.\_\d]+)/, "linux"],
	      [/mac os x/, "macos"],
	      [/mac os x.*?([\.\_\d]+)/, "macos"],
	      [/os ([\.\_\d]+) like mac os/, "ios"],
	      [/openbsd ()([a-z\.\_\d]+)/, "openbsd"],
	      [/android/, "android"],
	      [/android ([a-z\.\_\d]+);/, "android"],
	      [/mozilla\/[a-z\.\_\d]+ \((?:mobile)|(?:tablet)/, "firefoxos"],
	      [/windows\s*(?:nt)?\s*([\.\_\d]+)/, "windows"],
	      [/windows phone.*?([\.\_\d]+)/, "windows.phone"],
	      [/windows mobile/, "windows.mobile"],
	      [/blackberry/, "blackberryos"],
	      [/bb\d+/, "blackberryos"],
	      [/rim.*?os\s*([\.\_\d]+)/, "blackberryos"]
	    ],
	    device: [
	      [/ipad/, "ipad"],
	      [/iphone/, "iphone"],
	      [/lumia/, "lumia"],
	      [/htc/, "htc"],
	      [/nexus/, "nexus"],
	      [/galaxy nexus/, "galaxy.nexus"],
	      [/nokia/, "nokia"],
	      [/ gt\-/, "galaxy"],
	      [/ sm\-/, "galaxy"],
	      [/xbox/, "xbox"],
	      [/(?:bb\d+)|(?:blackberry)|(?: rim )/, "blackberry"]
	    ]
	  };
	
	  var UNKNOWN = "Unknown";
	
	  var propertyNames = Object.keys(properties);
	
	  function Sniffr() {
	    var self = this;
	
	    propertyNames.forEach(function(propertyName) {
	      self[propertyName] = {
	        name: UNKNOWN,
	        version: [],
	        versionString: UNKNOWN
	      };
	    });
	  }
	
	  function determineProperty(self, propertyName, userAgent) {
	    properties[propertyName].forEach(function(propertyMatcher) {
	      var propertyRegex = propertyMatcher[0];
	      var propertyValue = propertyMatcher[1];
	
	      var match = userAgent.match(propertyRegex);
	
	      if (match) {
	        self[propertyName].name = propertyValue;
	
	        if (match[2]) {
	          self[propertyName].versionString = match[2];
	          self[propertyName].version = [];
	        } else if (match[1]) {
	          self[propertyName].versionString = match[1].replace(/_/g, ".");
	          self[propertyName].version = parseVersion(match[1]);
	        } else {
	          self[propertyName].versionString = UNKNOWN;
	          self[propertyName].version = [];
	        }
	      }
	    });
	  }
	
	  function parseVersion(versionString) {
	    return versionString.split(/[\._]/).map(function(versionPart) {
	      return parseInt(versionPart);
	    });
	  }
	
	  Sniffr.prototype.sniff = function(userAgentString) {
	    var self = this;
	    var userAgent = (userAgentString || navigator.userAgent || "").toLowerCase();
	
	    propertyNames.forEach(function(propertyName) {
	      determineProperty(self, propertyName, userAgent);
	    });
	  };
	
	
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = Sniffr;
	  } else {
	    host.Sniffr = new Sniffr();
	    host.Sniffr.sniff(navigator.userAgent);
	  }
	})(this);


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('HomepageServices').component('addUser', __webpack_require__(49));

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var template = __webpack_require__(50);
	__webpack_require__(51);
	var logger = __webpack_require__(11);
	
	var AddUserController = function () {
		function AddUserController($http, $scope, $translate, $timeout, shellUtil) {
			var _this = this;
	
			_classCallCheck(this, AddUserController);
	
			this.$http = $http;
			this.$scope = $scope;
			this.$timeout = $timeout;
			this.shellUtil = shellUtil;
	
			this.user = {
				displayName: '',
				firstName: '',
				lastName: '',
				externalId: '',
				roles: []
			};
	
			this.emptyEmail_st = "The email address field is required and cannot be empty. Provide a valid email address.";
			this.invalidEmail_st = "The email address you entered is invalid. Provide a valid email address.";
	
			this.userRoles = [{ name: 'Authenticated visitor', id: 'authenticatedVisitor' }, { name: 'Viewer', id: 'viewer' }, { name: 'Editor', id: 'editor' }, { name: 'Manager', id: 'manager' }, { name: 'Administrator', id: 'admin' }];
	
			$translate(this.userRoles.map(function (role) {
				return role.name;
			})).then(function (translations) {
				_this.userRoles.forEach(function (role) {
					role.name = translations[role.name];
				});
			});
	
			this.selectedRole = this.userRoles[2];
			// role info needs to be in scope for drop down widget
			$scope.userRoles = this.userRoles;
			$scope.selectedRole = this.selectedRole;
		}
	
		_createClass(AddUserController, [{
			key: 'select',
			value: function select(item) {
				logger.info("add user: item selected = " + JSON.stringify(item));
				this.selectedRole = item;
				this.$scope.selectedRole = this.selectedRole;
			}
		}, {
			key: 'addUser',
			value: function addUser() {
				var _this2 = this;
	
				// clear out old success/error messages before processing
				this.success = "";
				this.error = "";
	
				if (this.$scope.addUser.$invalid) {
					return;
				}
	
				this.user.roles = [this.selectedRole.id];
				logger.info("add user: posting new user = " + JSON.stringify(this.user));
				this.newUser = this.user.externalId;
				this.$http.post('/api/user-profile/v1/users', this.user).then(function () {
					_this2.success = "Added {USER}.";
					_this2.shellUtil.bindAnalytics("e", "WCH Widget Add Users", "WCH Widgets");
				}).catch(function (res) {
					// set default failure message
					var errorMessage = "Failed to add user {USER}.";
					logger.error("add user: failure response = " + JSON.stringify(res.data));
	
					// see if we have a more descriptive error to present to the user
					if (res.data && res.data.errors && res.data.errors.length > 0) {
						var error = res.data.errors[0];
	
						if (res.status === 409 && error.code && error.code === 106) {
							errorMessage = "User with the email address {USER} already exists. Provide a different email address.";
						} else {
							if (error.message) {
								errorMessage = error.message;
							} else if (error.description) {
								errorMessage = error.description;
							}
						}
					}
					// now display error message
					_this2.error = errorMessage;
				});
	
				//workaround to remove the submitted state on the form.
				this.$timeout(function () {
					_this2.clear();
				});
			}
		}, {
			key: 'clear',
			value: function clear() {
				this.$scope.addUser.$setPristine();
				this.$scope.addUser.$setUntouched();
				this.user = {
					displayName: '',
					firstName: '',
					lastName: '',
					externalId: '',
					roles: []
				};
			}
		}]);
	
		return AddUserController;
	}();
	
	module.exports = {
		templateUrl: template,
		controller: ['$http', '$scope', '$translate', '$timeout', 'shellUtil', AddUserController]
	};

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	var path = '/authoring-homepage-ui/addUser/addUser.html';
	var html = "<div id=add-user-form> <div ng-if=$ctrl.success class=\"alert alert-success\" role=alert> <span translate={{$ctrl.success}} translate-values=\"{USER: $ctrl.newUser}\"></span> <a href=# class=close data-dismiss=alert aria-label=close ng-click=\"$ctrl.success='';\">&times;</a> </div> <div ng-if=$ctrl.error class=\"alert alert-danger\" role=alert> <span translate={{$ctrl.error}} translate-values=\"{USER: $ctrl.newUser}\"></span> <a href=# class=close data-dismiss=alert aria-label=close ng-click=\"$ctrl.error='';\">&times;</a> </div> <form novalidate name=addUser aria-label=\"Add user\"> <div class=form-group> <label for=id-input translate>Email address / IBM ID</label> <div class=\"alert alert-danger error\" ng-show=\"addUser.$submitted && addUser.$invalid\" aria-atomic=true role=alert> <span role=alert ng-show=\"addUser.$error.required && addUser.$submitted && addUser.$invalid\" translate>{{$ctrl.emptyEmail_st}}</span> <span role=alert ng-show=\"addUser.$error.pattern && addUser.$submitted && addUser.$invalid\" translate>{{$ctrl.invalidEmail_st}}</span> </div> <input id=id-input class=form-control type=text pattern=\"^(?:[\\w\\!\\#\\$\\%\\&\\'\\*\\+\\-\\/\\=\\?\\^\\`\\{\\|\\}\\~]+\\.)*[\\w\\!\\#\\$\\%\\&\\'\\*\\+\\-\\/\\=\\?\\^\\`\\{\\|\\}\\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\\-](?!\\.)){0,61}[a-zA-Z0-9]?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\\[(?:(?:[01]?\\d{1,2}|2[0-4]\\d|25[0-5])\\.){3}(?:[01]?\\d{1,2}|2[0-4]\\d|25[0-5])\\]))$\" name=externalId ng-model=$ctrl.user.externalId required> </div> <div class=form-group> <label id=user_role_id translate>Role</label> <div id=edit-user-roles class=\"btn-group contentTypeBtn\" dropdown uib-dropdown on-toggle=toggled(open) uib-keyboard-nav> <button role=button class=\"btn dropdown-toggle btn-default contentTypeBtn\" dropdown-toggle uib-dropdown-toggle type=button id=user_role_button ng-disabled=false aria-labelledby=user_role_placeholder> <span id=user_role_placeholder class=\"select-placeholder pull-left\"> {{ selectedRole.name }} </span> </button> <ul id=user_role_dropdown class=dropdown-menu aria-labelledby=user_role_id> <li class=list-option ng-repeat=\"item in userRoles\" ng-class=\"\"> <a href=# ng-click=$ctrl.select(item)>{{ ::item.name }}</a> </li> </ul> </div> </div> <div class=button-right> <button type=submit class=\"btn btn-primary\" ng-click=$ctrl.addUser() translate=\"Add user\"></button> <button type=button class=\"btn btn-default\" ng-click=$ctrl.clear() translate=Cancel></button> </div> </form> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(52);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./addUser.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./addUser.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)(false);
	// Module
	exports.push([module.id, ".screen-reader-text{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}#add-user-form>*{padding:10px;flex:1 100%;margin:5px}#add-user-form .modal-header .close{color:#fff;line-height:44px;font-size:15pt}#add-user-form .ng-dirty #id-input.ng-valid,#add-user-form .ng-submitted #id-input.ng-valid{box-shadow:0 0 0 1px #fff,0 0 0 2px #cef3d1}#add-user-form .ng-dirty #id-input.ng-invalid,#add-user-form .ng-submitted #id-input.ng-invalid{box-shadow:0 0 0 1px #fff,0 0 0 2px #f7e6e6}#add-user-form .glyphicon-warning-sign{padding-bottom:10px}#add-user-form .glyphicon-warning-sign::before{padding-right:10px;color:#e62325}#add-user-form .close{font-size:x-large}#add-user-form .close:focus{border:1px dashed}#add-user-form .alert{white-space:normal;display:flex;word-break:break-word;word-wrap:break-word;line-height:22px;padding-top:5px;padding-bottom:5px}#add-user-form .alert span{padding-left:5px;padding-right:5px;flex-grow:3}#add-user-form .alert-success{line-height:22px}#add-user-form .alert-danger{line-height:22px}#add-user-form .alert:before{font-size:20px}#add-user-form .error{padding-top:5px;padding-bottom:10px}#add-user-form .button-right{display:flex;justify-content:flex-end;flex-wrap:wrap}#add-user-form .button-right .btn-primary{margin-bottom:5px}\n", ""]);
	


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('HomepageServices').component('createContent', __webpack_require__(54)).filter('createContentFilter', __webpack_require__(59));

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var template = __webpack_require__(55);
	__webpack_require__(56);
	var logger = __webpack_require__(11);
	
	var CreateContentController = function () {
		function CreateContentController($scope, $state, $filter, contentService, userProfileService, shellUtil) {
			var _this = this;
	
			_classCallCheck(this, CreateContentController);
	
			this.state = $state;
			this.buttonDisabled = false;
			this.query = "";
			this.content_types = "";
			this.filtered_content_types = "";
			this.search_icon = __webpack_require__(58);
			this.status = {
				isopen: false
			};
	
			$scope.typeaheadToggleOn = shellUtil.isToggleOn('typeahead-createContent');
	
			contentService.getCurrentContentTypes().then(function (data) {
				if ($scope.typeaheadToggleOn) {
					if (!data || !data.items) {
						logger.error('Error retrieving current content type data from server');
						return;
					}
	
					_this.content_types = data.items.filter(function (item) {
						if (item && item.kind) {
							return item.kind.includes('standalone');
						} else {
							return false;
						}
					});
					_this.filtered_content_types = _this.content_types;
					logger.info("compose content: number of content types = " + _this.content_types.length);
					if (_this.content_types.length === 0) {
						_this.displayNoContentTypeMessage(userProfileService);
					}
				} else {
					$scope.content_types = $filter('createContentFilter')(data.items);
					logger.info("compose content: number of content types = " + $scope.content_types.length);
					if ($scope.content_types.length === 0) {
						_this.displayNoContentTypeMessage(userProfileService);
					}
				}
			}, function (error) {
				logger.error('Error retrieving current content type data from server: ' + error);
			});
		}
	
		_createClass(CreateContentController, [{
			key: 'select',
			value: function select(item) {
				this.selectedType = item;
				this.addContent();
			}
		}, {
			key: 'addContent',
			value: function addContent() {
				this.error = '';
				var type = this.selectedType;
				if (typeof type === 'undefined') {
					this.error = "Select a content type";
				} else {
					if (type && type.id) {
						this.clear();
						this.state.go('authoring.content.new', { typeId: type.id, typeName: type.name });
					}
				}
			}
		}, {
			key: 'displayNoContentTypeMessage',
			value: function displayNoContentTypeMessage(userProfileService) {
				var _this2 = this;
	
				this.buttonDisabled = true;
				// lookup the role of the current user
				userProfileService.getCurrentUserData().then(function (data) {
					var currentUserRole = data.roles[0];
					logger.info("createContent current user role = " + currentUserRole);
	
					switch (currentUserRole) {
						case 'administrator':
						case 'admin':
						case 'manager':
							_this2.noContentTypeMsg = "NoContentTypesManager";
							_this2.noContentTypeMsgManager = true;
							break;
						case 'editor':
							_this2.noContentTypeMsg = "NoContentTypesEditor";
							_this2.noContentTypeMsgEditor = true;
							break;
						default:
							logger.info('Unexpected user role in createContent: ' + currentUserRole);
							break;
					}
				}, function (error) {
					logger.error('Error retrieving current user role data from server: ' + error);
				});
			}
		}, {
			key: 'createContentType',
			value: function createContentType() {
				logger.info("Routing user to authoring to create a new content type...");
				this.state.go('authoring.types.new');
			}
		}, {
			key: 'clear',
			value: function clear() {
				this.selectedType = '';
				this.query = '';
				this.filtered_content_types = this.content_types;
			}
		}, {
			key: 'search',
			value: function search() {
				var _this3 = this;
	
				this.filtered_content_types = this.content_types.filter(function (item) {
					if (item && item.name) {
						return item.name.toLowerCase().includes(_this3.query);
					} else {
						return false;
					}
				});
			}
	
			/**
	   * Callback method when keyup event is triggered on 'Compose content' field
	   * @param event
	   */
	
		}, {
			key: 'toggle_keyup',
			value: function toggle_keyup(event) {
				var charCode = event.charCode || event.keyCode || event.which;
				switch (charCode) {
					// ESC key. Dismisses the popup, clears the textbox
					case 27:
						// When there is a query, clear the query and force dropdown to open
						this.status.isopen = true;
						break;
					default:
						break;
				}
				return true;
			}
	
			/**
	   * Callback method when keyup event is triggered on input field
	   * @param event
	   */
	
		}, {
			key: 'input_keyup',
			value: function input_keyup(event) {
				var charCode = event.charCode || event.keyCode || event.which;
				switch (charCode) {
					// down. If the popup is available, moves focus into the popup
					case 40:
						if (document.activeElement.parentElement.nextElementSibling) {
							var firstResultElement = document.activeElement.parentElement.nextElementSibling.querySelector("a");
							if (firstResultElement) firstResultElement.focus();
						}
						break;
					default:
						this.search();
						break;
				}
				return true;
			}
	
			/**
	   * Callback method when keyup event is triggered on menu items
	   * @param event
	   */
	
		}, {
			key: 'item_keyup',
			value: function item_keyup(event) {
				event = event || window.event;
				event.preventDefault();
				var searchBoxDiv = document.getElementById('typeahead_search_input');
	
				var charCode = event.charCode || event.keyCode || event.which;
				switch (charCode) {
					// ESC key. Closes the popup and returns focus to the textbox
					case 27:
						this.clear();
						if (searchBoxDiv) searchBoxDiv.focus();
						break;
					// Left Arrow
					case 37:
						if (searchBoxDiv) {
							searchBoxDiv.focus();
							var left_pos = searchBoxDiv.selectionStart > 0 ? searchBoxDiv.selectionStart - 1 : 0;
							// Move cursor to left by 1 byte
							searchBoxDiv.setSelectionRange(left_pos, left_pos);
						}
						break;
					// Right Arrow
					case 39:
						if (searchBoxDiv) {
							searchBoxDiv.focus();
							var right_pos = searchBoxDiv.selectionStart < this.query.length ? searchBoxDiv.selectionStart + 1 : this.query.length;
							// Move cursor to right by 1 byte
							searchBoxDiv.setSelectionRange(right_pos, right_pos);
						}
						break;
					// Navigate up
					case 38:
						if (document.activeElement.parentElement.previousElementSibling) {
							var prevElement = document.activeElement.parentElement.previousElementSibling.querySelector("a");
							// Navigate up
							if (prevElement) prevElement.focus();
							// Focus to input if it is on first result
							else searchBoxDiv.focus();
						}
						break;
					// Navigate down
					case 40:
						if (document.activeElement.parentElement.nextElementSibling) {
							var nextElement = document.activeElement.parentElement.nextElementSibling.querySelector("a");
							if (nextElement) nextElement.focus();
						}
						break;
					// Tab
					case 9:
						break;
					default:
						if (searchBoxDiv) searchBoxDiv.focus();
						this.search();
						break;
				}
				return true;
			}
	
			// Triggered when you click on "Compose content" toggle
	
		}, {
			key: 'toggleDropdown',
			value: function toggleDropdown($event) {
				$event.preventDefault();
				$event.stopPropagation();
				this.status.isopen = !this.status.isopen;
				this.clear();
			}
		}]);
	
		return CreateContentController;
	}();
	
	;
	
	module.exports = {
		templateUrl: template,
		controller: ["$scope", "$state", "$filter", "contentService", "userProfileService", "shellUtil", CreateContentController]
	};

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	var path = '/authoring-homepage-ui/createContent/createContent.html';
	var html = "<div class=create-content-wrapper> <div ng-if=$ctrl.error class=\"alert alert-danger\" role=alert translate={{$ctrl.error}}></div> <div> <label class=screen-reader-text for=content_type_button translate=\"Select a content type\"></label> <div id=_content_type class=\"btn-group contentTypeBtn\" dropdown uib-dropdown auto-close=outsideClick is-open=$ctrl.status.isopen uib-keyboard-nav ng-keyup=$ctrl.toggle_keyup($event)> <button role=button class=\"btn dropdown-toggle btn-default contentTypeBtn\" dropdown-toggle uib-dropdown-toggle type=button id=content_type_button ng-disabled=$ctrl.buttonDisabled ng-click=$ctrl.toggleDropdown($event)> <span id=content_type_placeholder class=\"select-placeholder pull-left\"> {{ $ctrl.selectedType ? $ctrl.selectedType.name : 'Compose content'|translate }} </span> </button> <ul ng-if=!typeaheadToggleOn id=create_content_dropdown class=dropdown-menu aria-labelledby=content_type_placeholder> <li class=list-option ng-repeat=\"item in content_types track by $index\" ng-class=\"\"> <a href=# ng-click=$ctrl.select(item)>{{ ::item.name }}</a> </li> </ul> <ul ng-if=typeaheadToggleOn id=create_content_typeahead_dropdown class=dropdown-menu uib-dropdown-menu aria-labelledby=content_type_placeholder> <form class=search-form id=search-form name=search-form> <div id=content-type-search-btn class=search-icon> <svg width=16 height=16 alt=\"{{'Seach icon'|translate}}\" role=img aria-label=\"{{'Seach icon'|translate}}\"> <use xlink:href={{::$ctrl.search_icon}} /> </svg> </div> <input ng-if=\"$ctrl.content_types.length > 0\" id=typeahead_search_input class=search-box type=search name=search-box placeholder=\"{{'Search' | translate}}\" ng-model=$ctrl.query ng-keyup=$ctrl.input_keyup($event) autocomplete=off aria-labelledby=content-type-search-btn translate-value-browser={{app.browser}} /> <span id=content-type-clear-btn class=\"search-input-clear glyphicon glyphicon-remove\" ng-click=$ctrl.clear() ng-show=\"$ctrl.query.length > 0\" aria-label=\"{{::'Clear search'|translate}}\"></span> </form> <li class=list-option ng-repeat=\"item in $ctrl.filtered_content_types\" ng-keyup=$ctrl.item_keyup($event)> <a href=# ng-click=$ctrl.select(item)>{{ ::item.name }}</a> </li> </ul> </div> <div ng-if=$ctrl.noContentTypeMsg class=no-content-type-msg-area> <span ng-if=$ctrl.noContentTypeMsgManager class=\"h2 no-content-type-msg\" role=alert translate={{$ctrl.noContentTypeMsg}} ng-click=$ctrl.createContentType()></span> <span ng-if=$ctrl.noContentTypeMsgEditor class=\"h2 no-content-type-msg\" role=alert translate={{$ctrl.noContentTypeMsg}}></span> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(57);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./createContent.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./createContent.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)(false);
	// Module
	exports.push([module.id, ".screen-reader-text{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}#topHomepageContainer .create-content-wrapper{display:-webkit-flex;display:flex;-webkit-flex-flow:row wrap;flex-flow:row wrap;text-align:start;background-color:#ffffff;align-items:flex-end}#topHomepageContainer .create-content-wrapper .search-form{position:relative;display:block;margin:10px;padding:1px;border:1px solid #7f7f7f}#topHomepageContainer .create-content-wrapper .search-form .search-icon{position:absolute;top:55%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);margin-left:10px}#topHomepageContainer .create-content-wrapper .search-form .glyphicon-search{font-size:14px}#topHomepageContainer .create-content-wrapper .search-form .search-box{height:30px;width:100%;padding-left:36px;border:none}#topHomepageContainer .create-content-wrapper .search-form .search-box::placeholder{color:#7f7f7f;font-size:12px;font-style:italic}#topHomepageContainer .create-content-wrapper .search-form .search-box:focus{border:1px solid #5499c3}#topHomepageContainer .create-content-wrapper .search-form .search-input-clear{position:absolute;top:55%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);right:10px;cursor:pointer;transition:all 0.2s ease-in-out}#topHomepageContainer .create-content-wrapper .search-form .glyphicon-remove{font-size:16px}#topHomepageContainer .create-content-wrapper>*{padding:0px;flex:1 100%;margin-top:5px;margin-bottom:5px}#topHomepageContainer .create-content-wrapper>* .alert{white-space:normal}#topHomepageContainer .content-input{min-width:100%;width:100%}#topHomepageContainer .contentTypeBtn{width:100%}#topHomepageContainer .no-content-type-msg-area{display:flex;flex-flow:column;justify-content:center;align-items:center;height:10rem}#topHomepageContainer .no-content-type-msg{width:80%;text-align:center;margin:0}#topHomepageContainer .no-content-type-msg>a{font-weight:400}#topHomepageContainer .alert{@extends : .alert;height:auto}@media only screen and (max-width: 768px){#topHomepageContainer .no-content-type-msg{font-size:16px}}\n", ""]);
	


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(45);
	var image = "<symbol viewBox=\"0 0 16 16\" id=\"search_16\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <path d=\"M6,0C2.7,0,0,2.7,0,6s2.7,6,6,6s6-2.7,6-6S9.3,0,6,0z M6,11c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5\n\t\tS8.8,11,6,11z\" fill=\"#949494\"> </path> <rect fill=\"#949494\" height=\"5.7\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 31.4698 13.0355)\" width=\"2\" x=\"12\" y=\"10.2\"> </rect> </g> </symbol>";
	module.exports = sprite.add(image, "search_16");

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _logging = __webpack_require__(11);
	
	var logger = (0, _logging.createLogger)('createContentFilter');
	
	module.exports = [function () {
	
	    // Filter the content type entries based on the kind field
	    return function (entries) {
	        var filteredEntries = []; // NOSONAR, not constant
	
	        entries.forEach(function (entry) {
	            if (entry.kind && entry.kind.includes('standalone')) {
	                filteredEntries.push(entry);
	            } else {
	                logger.info('Filtering out content type: ' + entry.name);
	            }
	        });
	
	        return filteredEntries;
	    };
	}];

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('HomepageServices').component('hubUsage', __webpack_require__(61));

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var template = __webpack_require__(62);
	__webpack_require__(63);
	__webpack_require__(65);
	var logger = __webpack_require__(11);
	
	var WARNING_PERCENT = 0.8;
	var MARKETPLACE_URL = 'https://acoustic.com/products/content/';
	
	var HubUsageController = function () {
		function HubUsageController($scope, $filter, $translate, matchmedia, tenantRegistryService, contentService, homepageDataService, shellUtil) {
			var _this = this;
	
			_classCallCheck(this, HubUsageController);
	
			this.filter = $filter;
			this.tenantRegistryService = tenantRegistryService;
			this.contentService = contentService;
			this.marketplaceURL = MARKETPLACE_URL;
			this.homepageDataService = homepageDataService;
	
			this.unlimitedText = "Unlimited";
			$translate(this.unlimitedText).then(function (text) {
				_this.unlimitedText = text;
			});
			this.unavailableText = "Unavailable";
			$translate(this.unavailableText).then(function (text) {
				_this.unavailableText = text;
			});
	
			// flags if resource is in warning levels
			this.isStorageWarningLevel = false;
			this.isDataWarningLevel = false;
	
			// flags if an error occurs fetching current value for a resource
			this.isErrorForStorageUsage = false;
			this.isErrorForDataUsage = false;
	
			// Might reuse this piece of code if needed
			// $scope.unregister = matchmedia.onPhone( mediaQueryList => {
			// //$scope.unregister = matchmedia.onDesktop( mediaQueryList => {
			// 	$scope.isPhone = mediaQueryList.matches;
			// 	if ($scope.isPhone) {
			// 		this.render();
			// 	}
			// 	else {
			// 		this.render();
			// 	}
			// });
	
			this.errorMessages = [];
	
			this.maxStorage = 10; //GB
			this.maxData = 100; //GB
			this.subscriptionDisplay = "Essentials subscription";
			this.subscription = "base";
	
			// Fetch dashboard max values and subscription
			this.getTenantInformation();
	
			// Fetch current storage dashboard value
			this.usedStorage = 0;
			this.getTenantCurrentFileStorage();
	
			if (this.usedStorage > this.maxStorage) {
				this.setErrorMessage("storageExceededAlt", "");
			}
	
			// Fetch current data transfer dashboard value
			this.usedData = 0;
			this.getTenantCurrentDataTransfer();
	
			if (this.usedData > this.maxData) {
				this.setErrorMessage("dataTransferExceededAlt", "");
			}
	
			// remove ondesktop listener on teardown
			$scope.$on("$destroy", function () {
				if ($scope.unregister) {
					$scope.unregister();
				}
			});
	
			this.render();
		}
	
		_createClass(HubUsageController, [{
			key: 'getTenantInformation',
			value: function getTenantInformation() {
				var _this2 = this;
	
				var isInfoUpdated = false;
				this.tenantRegistryService.getTenantInformation().then(function (data) {
					if (data.maxStorageSize && _this2.maxStorage !== data.maxStorageSize) {
						isInfoUpdated = true;
						_this2.maxStorage = data.maxStorageSize;
					}
					if (data.maxDataTransfer && _this2.maxData !== data.maxDataTransfer) {
						isInfoUpdated = true;
						_this2.maxData = data.maxDataTransfer;
					}
	
					// get subscription plan
					if (data.tier) {
						var tier = data.tier.toLowerCase();
						if (tier !== _this2.subscription) {
							isInfoUpdated = true;
	
							switch (tier) {
								case "base":
									_this2.subscriptionDisplay = "Essentials subscription";
									_this2.subscription = tier;
									break;
								case "standard":
									_this2.subscriptionDisplay = "Standard subscription";
									_this2.subscription = tier;
									break;
								case "plus":
									_this2.subscriptionDisplay = "Plus subscription";
									_this2.subscription = tier;
									break;
								case "trial":
									_this2.subscriptionDisplay = "Trial subscription";
									_this2.subscription = tier;
									break;
								default:
									logger.info("hubUsage unrecognized subscription plan: " + tier);
									break;
							}
						}
					}
	
					if (isInfoUpdated) {
						_this2.render();
					}
				}, function (error) {
					logger.error('Error retrieving tenant max usage information from server: ' + error);
				});
			}
		}, {
			key: 'getTenantCurrentFileStorage',
			value: function getTenantCurrentFileStorage() {
				var _this3 = this;
	
				this.homepageDataService.getTenantDiskUsage().then(function (data) {
					if (data) {
						_this3.isErrorForStorageUsage = false;
						var isInfoUpdated = false;
						if (_this3.usedStorage !== data) {
							isInfoUpdated = true;
							_this3.usedStorage = data;
						}
					}
					if (isInfoUpdated) {
						_this3.isStorageWarningLevel = _this3.usedStorage >= _this3.maxStorage * WARNING_PERCENT && _this3.usedStorage < _this3.maxStorage;
						_this3.render();
					}
				}, function (error) {
					_this3.isErrorForStorageUsage = true;
					logger.error('Error retrieving tenant current storage usage information from server: ' + error);
					_this3.render();
				});
			}
		}, {
			key: 'getTenantCurrentDataTransfer',
			value: function getTenantCurrentDataTransfer() {
				var _this4 = this;
	
				this.homepageDataService.getTenantDataTransferUsage().then(function (data) {
					if (data) {
						_this4.isErrorForDataUsage = false;
						var isInfoUpdated = false;
						if (_this4.usedData !== data) {
							isInfoUpdated = true;
							_this4.usedData = data;
						}
					}
					if (isInfoUpdated) {
						_this4.isDataWarningLevel = _this4.usedData >= _this4.maxData * WARNING_PERCENT && _this4.usedData < _this4.maxData;
						_this4.render();
					}
				}, function (error) {
					_this4.isErrorForDataUsage = true;
					logger.error('Error retrieving tenant current data transfer usage information from server: ' + error);
					_this4.render();
				});
			}
	
			// Display usage info
	
		}, {
			key: 'render',
			value: function render() {
				// display storage dashboard information - usage display strings
				if (!this.isErrorForStorageUsage) {
					this.storageUsed = this.filter('number')(this.usedStorage, 1);
				} else {
					this.storageUsed = this.unavailableText;
				}
				this.storageMax = this.filter('number')(this.maxStorage);
	
				// display data transfer dashboard information - usage display strings
				if (!this.isErrorForDataUsage) {
					this.dataUsed = this.filter('number')(this.usedData, 1);
				} else {
					this.dataUsed = this.unavailableText;
				}
				this.dataMax = this.filter('number')(this.maxData);
			}
		}, {
			key: 'setErrorMessage',
			value: function setErrorMessage(key, amount) {
				var errorMessage = {};
				errorMessage.key = key;
				errorMessage.amount = amount;
				this.errorMessages.push(errorMessage);
			}
	
			// Return the color fill style for percentage usage
	
		}, {
			key: 'getStorageUsagePercentStyle',
			value: function getStorageUsagePercentStyle() {
				return {
					"height": (this.usedStorage / this.maxStorage * 100).toFixed(2) + '%'
				};
			}
	
			// Return the color fill style for percentage usage
	
		}, {
			key: 'getDataTransferUsagePercentStyle',
			value: function getDataTransferUsagePercentStyle() {
				return {
					"height": (this.usedData / this.maxData * 100).toFixed(2) + '%'
				};
			}
		}]);
	
		return HubUsageController;
	}();
	
	;
	
	module.exports = {
		templateUrl: template,
		controller: ["$scope", "$filter", "$translate", "matchmedia", "tenantRegistryService", "contentService", "homepageDataService", "shellUtil", HubUsageController]
	};

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	var path = '/authoring-homepage-ui/hubUsage/hubUsage.html';
	var html = "<div class=hub-usage-wrapper> <p class=subscription><span translate={{$ctrl.subscriptionDisplay}}></span></p> <div role=alert class=errorMessages ng-show=$ctrl.errorMessages ng-repeat=\"message in $ctrl.errorMessages\"> <p class=\"alert alert-danger\" translate={{message.key}} translate-values=\"{AMOUNT: message.amount}\"></p> </div> <div class=dashboard-container> <div class=usage-wrapper> <div id=storage-usage class=usage-container> <span class=fill ng-style=$ctrl.getStorageUsagePercentStyle() attr.aria-label={{$ctrl.getStorageUsagePercentStyle()}} /> <div class=storage-icon> <svg width=121px height=121px viewBox=\"0 0 121 121\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink> <title>{{\"Storage\" | translate}}</title> <defs></defs> <g id=wch-storage stroke=none stroke-width=1 fill=none fill-rule=evenodd opacity=0.2> <g id=storage fill=#FFFFFF> <path d=\"M95.109137,47.1847759 C99.5814067,47.1847759 103.207815,50.8111837 103.207815,55.2834534 C103.207815,59.7557231 99.5814067,63.382131 95.109137,63.382131 C90.6368673,63.382131 87.0104595,59.7557231 87.0104595,55.2834534 C87.0104595,50.8111837 90.6368673,47.1847759 95.109137,47.1847759\" id=Fill-1></path> <path d=\"M95.109137,87.8777841 C99.5814067,87.8777841 103.207815,91.5041919 103.207815,95.9764616 C103.207815,100.448731 99.5814067,104.075139 95.109137,104.075139 C90.6368673,104.075139 87.0104595,100.448731 87.0104595,95.9764616 C87.0104595,91.5041919 90.6368673,87.8777841 95.109137,87.8777841\" id=Fill-3></path> <path d=\"M9.02436647,71.7037037 L112.098441,71.7037037 L112.098441,40.3333333 L9.02436647,40.3333333 L9.02436647,71.7037037 Z M9.02436647,112.037037 L112.098441,112.037037 L112.098441,80.6666667 L9.02436647,80.6666667 L9.02436647,112.037037 Z M96.4132554,12.5481481 C100.894737,12.5481481 104.479922,16.1333333 104.479922,20.6148148 C104.479922,25.0962963 100.894737,28.6814815 96.4132554,28.6814815 C91.9317739,28.6814815 88.3465887,25.0962963 88.3465887,20.6148148 C88.3465887,16.1333333 91.9317739,12.5481481 96.4132554,12.5481481 Z M0.0614035088,121 L121.061404,121 L121.061404,0 L0.0614035088,0 L0.0614035088,121 Z\" id=Fill-5></path> </g> </g> </svg> </div> </div> <div class=usage-labels> <p class=usage-name translate>{{\"Storage\"}}</p> <p ng-if=$ctrl.isStorageWarningLevel role=tooltip class=\"glyphicon glyphicon-info-circle\" tabindex=0 style=color:#fff x1-tooltip data-placement=right data-title=\"{{'storageWarningAlt'|translate}}\" data-close-icon=true aria-label=\"{{'storageWarningAlt'|translate}}\"></p> <p class=usage-used> <span class=used-size>{{$ctrl.storageUsed | translate}}</span><span>/{{$ctrl.storageMax}} GB</span> </p> <p class=used-text translate>{{ \"used\" }}</p> </div> </div> <div class=usage-wrapper> <div id=dataTransfer-usage class=usage-container> <span class=fill ng-style=$ctrl.getDataTransferUsagePercentStyle() attr.aria-label={{$ctrl.getDataTransferUsagePercentStyle()}} /> <div class=dataTransfer-icon> <svg width=121px height=121px viewBox=\"0 0 121 121\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink> <title>{{\"Data transfer\" | translate}}</title> <defs></defs> <g id=wch-transfer stroke=none stroke-width=1 fill=none fill-rule=evenodd fill-opacity=0.2> <path d=\"M60.5,40.3333333 L67.2222222,33.6111111 L33.6111111,0 L7.10542736e-15,33.6111111 L6.72222222,40.3333333 L28.9055556,18.15 L28.9055556,114.277778 L38.3166667,114.277778 L38.3166667,18.15 L60.5,40.3333333 Z M114.277778,80.6666667 L92.0944444,102.85 L92.0944444,6.72222222 L82.6833333,6.72222222 L82.6833333,102.85 L60.5,80.6666667 L53.7777778,87.3888889 L87.3888889,121 L121,87.3888889 L114.277778,80.6666667 Z\" id=transfer fill=#FFFFFF fill-rule=nonzero transform=\"translate(60.500000, 60.500000) rotate(90.000000) translate(-60.500000, -60.500000) \"></path> </g> </svg> </div> </div> <div class=usage-labels> <p class=usage-name translate>{{\"Data transfer\"}}</p> <p ng-if=$ctrl.isDataWarningLevel role=tooltip class=\"glyphicon glyphicon-info-circle\" tabindex=0 style=color:#fff x1-tooltip data-placement=left data-title=\"{{'dataTransferWarningAlt'|translate}}\" data-close-icon=true aria-label=\"{{'dataTransferWarningAlt'|translate}}\"></p> <p class=usage-used translate=\"<span class='used-size'>{{$ctrl.dataUsed}}</span>/{{$ctrl.dataMax}} GB\"> <span class=used-size>{{$ctrl.dataUsed | translate}}</span><span>/{{$ctrl.dataMax}} GB</span> </p> <p class=used-text translate>{{ \"used\" }}</p> </div> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(64);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./hubUsage.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./hubUsage.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)(false);
	// Module
	exports.push([module.id, ".screen-reader-text{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}#topHomepageContainer .hub-usage-wrapper{display:-webkit-flex;display:flex;-webkit-flex-flow:row wrap;flex-flow:row wrap;text-align:start;background-color:#fff;align-items:flex-end}#topHomepageContainer .hub-usage-wrapper>*{flex:1 100%}#topHomepageContainer .subscription{margin-bottom:20px;color:#595859}#topHomepageContainer .errorMessages{margin-bottom:20px}#topHomepageContainer .dashboard-container{display:flex;flex-flow:row;justify-content:space-around;align-items:center}#topHomepageContainer .dashboard-container .usage-wrapper{position:relative;text-align:center;display:flex;align-items:center;justify-content:center}#topHomepageContainer .dashboard-container .usage-wrapper .usage-container{width:190px;height:190px;border-radius:100%;position:relative;background-color:#595859;overflow:hidden;display:flex;align-items:center;justify-content:center}#topHomepageContainer .dashboard-container .usage-wrapper .usage-container .fill{background:#79a6f6;display:block;width:190px;height:190px;position:absolute;left:0;bottom:0;z-index:1}#topHomepageContainer .dashboard-container .usage-wrapper .usage-container .storage-icon{position:absolute;z-index:2;width:121px;height:121px}#topHomepageContainer .dashboard-container .usage-wrapper .usage-container .dataTransfer-icon{position:absolute;z-index:2;width:121px;height:121px}#topHomepageContainer .dashboard-container .usage-wrapper .usage-labels{position:absolute;max-width:100%;z-index:3;color:white}#topHomepageContainer .dashboard-container .usage-wrapper .usage-labels .usage-name{text-align:center;font-size:18px;font-family:\"IBM Plex Sans\";font-weight:lighter;line-height:20px}#topHomepageContainer .dashboard-container .usage-wrapper .usage-labels .usage-used{line-height:2rem;text-align:center;font-size:31px;font-family:\"IBM Plex Sans\"}#topHomepageContainer .dashboard-container .usage-wrapper .usage-labels .usage-used>span{display:inline-block}#topHomepageContainer .dashboard-container .usage-wrapper .usage-labels .used-text{text-align:center;font-size:14px;font-family:\"IBM Plex Sans\";line-height:20px}#topHomepageContainer .dashboard-container .usage-wrapper .tooltip{position:absolute;z-index:4}\n", ""]);
	


/***/ }),
/* 65 */
/***/ (function(module, exports) {

	/*
	 * matchmedia-ng (c) 2014 Jason Kulatunga, Inc. | http://analogj.mit-license.org/
	 */
	(function(window, angular, undefined) {
	'use strict';
	
	angular.module("matchmedia-ng", []).
	    provider('matchmedia', function (){
	
	        ///////////////////////////////////////////////////////////////////////
	        // Configuration
	        ///////////////////////////////////////////////////////////////////////
	        /**
	         *
	         * these settings can be changed by injecting matchmediaProvider into
	         * the config function of your module and
	         * changing the matchmediaProvider.rules with your own rule key value
	         * pairs E.G.
	
	         *  angular.module('app').config(['matchmediaProvider', function (matchmediaProvider) {
	         *      matchmediaProvider.rules.phone = "(max-width: 500px)";
	         *      matchmediaProvider.rules.desktop: = "(max-width: 1500px)";
	         *  }]);
	         *
	         * default values taken from twitter bootstrap :
	         * https://github.com/twitter/bootstrap/blob/master/less/responsive-utilities.less
	         */
	        var matchmedia = {
	            rules: {
	                print : "print",
	                screen : "screen",
	                phone : "(max-width: 767px)",
	                tablet : "(min-width: 768px) and (max-width: 979px)",
	                desktop : "(min-width: 980px)",
	                portrait : "(orientation: portrait)",
	                landscape : "(orientation: landscape)"
	            }
	        };
	        matchmedia.$get = ['$window','safeApply', 'logger', function($window, safeApply, logger) {
	
	            logger.log('Creating matchmedia');
	
	            ///////////////////////////////////////////////////////////////////////
	            // Private Methods
	            ///////////////////////////////////////////////////////////////////////
	            function createSafeListener(cb, $scope){
	                return function(mediaQueryList){
	                    safeApply(function() {
	                        cb(mediaQueryList);
	                    },$scope);
	                };
	            }
	
	            ///////////////////////////////////////////////////////////////////////
	            // Public Methods
	            ///////////////////////////////////////////////////////////////////////
	            //should never be called directly, but is available for custom calls.
	            var matchmediaService = {};
	
	            /**
	             * @param {string} query media query to listen on.
	             * @param {function(mediaQueryList)} listener Function to call when the media query is matched.
	             * @returns {function()} Returns a deregistration function for this listener.
	             */
	            matchmediaService.on = function(query, listener, $scope) {
	                var supportsMatchMedia = $window.matchMedia !== undefined && !!$window.matchMedia('all').addListener;
	                if(supportsMatchMedia) {
	                    logger.log('adding listener for query: '+ query);
	                    var mediaQueryList = $window.matchMedia(query);
	                    var handler = createSafeListener(listener, $scope);
	                    mediaQueryList.addListener(handler);
	                    //immediately return the current mediaQueryList;
	                    handler(mediaQueryList);
	
	                    return function() {
	                        logger.log('removing listener from query: '+ query);
	                        mediaQueryList.removeListener(handler);
	
	                    };
	                }
	            };
	            /**
	             * @param {string} query media query to test.
	             * @returns {mediaQueryList} Returns a boolean.
	             */
	            matchmediaService.is = function(query) {
	                logger.log('test query: '+ query);
	                return $window.matchMedia(query).matches;
	            };
	
	
	
	            ///////////////////////////////////////////////////////////////////////
	            // Aliased Methods
	            ///////////////////////////////////////////////////////////////////////
	            matchmediaService.onPrint = function(listener, $scope){
	                return matchmediaService.on(matchmedia.rules.print,listener, $scope);
	            };
	            matchmediaService.onScreen = function(listener, $scope){
	                return matchmediaService.on(matchmedia.rules.screen,listener, $scope);
	            };
	            matchmediaService.onPhone = function(listener, $scope){
	                return matchmediaService.on(matchmedia.rules.phone,listener, $scope);
	            };
	            matchmediaService.onTablet = function(listener, $scope){
	                return matchmediaService.on(matchmedia.rules.tablet,listener, $scope);
	            };
	            matchmediaService.onDesktop = function(listener, $scope){
	                return matchmediaService.on(matchmedia.rules.desktop,listener, $scope);
	            };
	            matchmediaService.onPortrait = function(listener, $scope){
	                return matchmediaService.on(matchmedia.rules.portrait,listener, $scope);
	            };
	            matchmediaService.onLandscape = function(listener, $scope){
	                return matchmediaService.on(matchmedia.rules.landscape,listener, $scope);
	            };
	
	            matchmediaService.isPrint = function(){
	                return matchmediaService.is(matchmedia.rules.print);
	            };
	            matchmediaService.isScreen = function(){
	                return matchmediaService.is(matchmedia.rules.screen);
	            };
	            matchmediaService.isPhone = function(){
	                return matchmediaService.is(matchmedia.rules.phone);
	            };
	            matchmediaService.isTablet = function(){
	                return matchmediaService.is(matchmedia.rules.tablet);
	            };
	            matchmediaService.isDesktop = function(){
	                return matchmediaService.is(matchmedia.rules.desktop);
	            };
	            matchmediaService.isPortrait = function(){
	                return matchmediaService.is(matchmedia.rules.portrait);
	            };
	            matchmediaService.isLandscape = function(){
	                return matchmediaService.is(matchmedia.rules.landscape);
	            };
	            return matchmediaService;
	        }];
	        return matchmedia;
	    })
	    .directive('ajMatchmedia', ['matchmedia', function(matchmedia) {
	        return {
	            restrict: 'E',
	            scope: {
	                'queryListener': '&',
	                'queryMatches': '='
	            },
	            link: function(scope, element, attrs, controllers) {
	                var deregister;
	
	                if (attrs.on && attrs.queryListener) {
	                    if (attrs.on.slice(0, 2) === 'on' && matchmedia[attrs.on] !== 'undefined') {
	                        deregister = matchmedia[attrs.on](function(mediaQueryList) {
	                            scope.queryListener({mediaQueryList: mediaQueryList});
	                        });
	                    } else {
	                        deregister = matchmedia.on(attrs.on, function(mediaQueryList) {
	                            scope.queryListener({mediaQueryList: mediaQueryList});
	                        });
	                    }
	                    scope.$on('$destroy', deregister);
	                } else if (attrs.is && attrs.queryMatches) {
	                    if (attrs.is.slice(0, 2) === 'is' && matchmedia[attrs.is] !== 'undefined') {
	                        scope.queryMatches = matchmedia[attrs.is]();
	                    } else {
	                        scope.queryMatches = matchmedia.is(attrs.is);
	                    }
	                }
	            }
	        };
	    }])
	    .factory('safeApply', ['$rootScope',function($rootScope) {
	        return function(fn, $scope) {
	            $scope = $scope || $rootScope;
	            var phase = $scope.$root.$$phase;
	            if(phase == '$apply' || phase == '$digest') {
	                if (fn) {
	                    $scope.$eval(fn);
	                }
	            } else {
	                if (fn) {
	                    $scope.$apply(fn);
	                } else {
	                    $scope.$apply();
	                }
	            }
	        };
	    }])
	    .provider('logger', function(){
	        this.DEVMODE = false;
	
	        this.setDEVMODE = function(devmode){
	            this.DEVMODE = devmode;
	        };
	
	        this.$get = ['$window', '$log', function($window, $log) {
	            var DEVMODE = this.DEVMODE;
	            var logger = {};
	            logger.log = function(){
	                if (DEVMODE) $log.info(arguments);
	            };
	            logger.always = function(){
	                $log.info(arguments);
	            };
	            return logger;
	        }];
	    });
	})(window, window.angular);


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('HomepageServices').component('search', __webpack_require__(67));

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var template = __webpack_require__(68);
	__webpack_require__(69);
	var logger = __webpack_require__(11);
	
	var SearchController = function () {
	    function SearchController($state, $q, $translate, $timeout, authSearchService, SearchTransformerService) {
	        _classCallCheck(this, SearchController);
	
	        this.$state = $state;
	        this.$q = $q;
	        this.$translate = $translate;
	        this.searchService = authSearchService;
	        this.SearchTransformerService = SearchTransformerService;
	        this.customSearchPerformed = false;
	
	        this.searchRequest = SearchTransformerService.SearchRequest();
	
	        // a11y hack - remove aria-expanded now that search input has role searchbox
	        $timeout(function () {
	            var searchInput = angular.element(document.querySelector('#search-input'));
	            searchInput.removeAttr('aria-expanded');
	        });
	    }
	
	    // user has submitted a search query with input text
	
	
	    _createClass(SearchController, [{
	        key: 'doFulltextSearch',
	        value: function doFulltextSearch(query) {
	            logger.info("SearchController doFulltextSearch entry");
	            if (query.trim() === "") {
	                return;
	            }
	            logger.info("Navigating to All Content and Assets with query: " + query);
	            this.$state.go('authoring.content.all-content-and-assets', { searchParameter: { "q": query } });
	        }
	    }, {
	        key: 'clearSearch',
	        value: function clearSearch() {
	            this.query = "";
	            this.customSearchPerformed = false;
	        }
	
	        // user has typed some characters into text field so look for content item matches
	
	    }, {
	        key: 'getTypeahead',
	        value: function getTypeahead(userInput) {
	            var _this = this;
	
	            logger.info("getTypeahead - " + userInput);
	            this.customSearchPerformed = true;
	            // don't bother unless 2 characters have been entered
	            if (userInput && userInput.trim().length >= 2) {
	                return this.searchService.getTypeaheadSearchResults(this.searchRequest.getTypeaheadSearchString(userInput)).then(function (data) {
	                    logger.info("Got typeahead search result - " + data);
	
	                    var result = _this.SearchTransformerService.SearchResult(data);
	                    var facets = result.getFacets();
	                    if (!_this.interruptTypeahead) {
	                        var typeaheads = _this.SearchTransformerService.transformFacetsIntoTypeahead(facets);
	                        // translate key to NLS field label here
	                        typeaheads.forEach(function (typeahead) {
	                            _this.$translate(typeahead.fieldLabel).then(function (translation) {
	                                typeahead.fieldLabel = translation;
	                            });
	                        });
	                        return typeaheads;
	                    } else {
	                        return [];
	                    }
	                }, function (error) {
	                    logger.error('Error retrieving typeahead search results data from server: ' + JSON.stringify(error));
	                    return [];
	                });
	            } else {
	                return this.$q(function (resolve) {
	                    resolve([]);
	                });
	            }
	        }
	
	        // user selected one of the typeahead items shown
	
	    }, {
	        key: 'onSearchTypeaheadSelect',
	        value: function onSearchTypeaheadSelect($item) {
	            logger.info("onSearchTypeaheadSelect - " + $item.getField() + ", " + $item.getValue() + ", " + $item.getFieldLabel() + ", " + $item.getValueLabel());
	
	            // create a SearchFilter and send to authoring page
	            var filter = this.SearchTransformerService.SearchFilter($item.getField(), $item.getValue(), $item.getFieldLabel(), $item.getValueLabel());
	            this.$state.go('authoring.content.all-content-and-assets', { searchParameter: { "filters": [filter] } });
	        }
	
	        /**
	         * Callback method when keyup event is triggered on input field
	         * Note: Keypress can't be used for ESC key, keydown doesn't work for firefox
	         * @param event
	         */
	
	    }, {
	        key: 'keyup',
	        value: function keyup(event) {
	            logger.info("keyup: " + event.which);
	            if (event.which === 13) {
	                this.interruptTypeahead = true;
	                this.doFulltextSearch(this.query);
	            } else if (event.which === 27) {
	                this.clearSearch();
	            } else {
	                this.interruptTypeahead = false;
	            }
	        }
	    }]);
	
	    return SearchController;
	}();
	
	;
	
	module.exports = {
	    templateUrl: template,
	    controller: ['$state', '$q', '$translate', '$timeout', 'authSearchService', 'SearchTransformerService', SearchController]
	};

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	var path = '/authoring-homepage-ui/search/search.html';
	var html = "<div class=search-wrapper> <form class=form-group style=margin-bottom:-10px aria-label=Search> <script type=text/ng-template id=customFacetTemplate.html> <a class=\"search-th-row\">\n        <span style=\"visibility: {{match.model.isSeparator ? 'visible' : 'hidden'}}\" class=\"keyColumn\">{{match.model.fieldLabel}}</span>\n\t\t<span ng-bind-html=\"match.model.getValue() | uibTypeaheadHighlight:query\" class=\"valueColumn\"></span>\n\t</a> </script> <div class=search-component role=search> <input type=search id=search-input class=form-control uib-typeahead=\"facet for facet in $ctrl.getTypeahead($viewValue)\" typeahead-template-url=customFacetTemplate.html typeahead-on-select=\"$ctrl.onSearchTypeaheadSelect($item, $model, $label)\" typeahead-focus-first=true typeahead-wait-ms=500 autocomplete=off placeholder=Search aria-labelledby=search-btn role=searchbox translate translate-attr-placeholder=Search translate-value-browser={{app.browser}} ng-keyup=$ctrl.keyup($event) ng-model=$ctrl.query aria-labelledby=search-btn> <button id=search-btn aria-label=\"{{::'Do Search'|translate}}\" type=submit ng-click=$ctrl.doFulltextSearch($ctrl.query) class=search-action-icon> {{::'Search'|translate}}<span class=\"glyphicon glyphicon-search\"></span> </button> <button id=clear-search-btn aria-label=\"{{::'Clear search'|translate}}\" ng-click=$ctrl.clearSearch() ng-show=$ctrl.customSearchPerformed class=search-clear-icon> {{::'Clear Search'|translate}}<span class=\"glyphicon glyphicon-remove\" aria-hidden=!$ctrl.customSearchPerformed></span> </button> </div> </form> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(70);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./search.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./search.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)(false);
	// Module
	exports.push([module.id, "#topHomepageContainer .search-wrapper{margin-left:-5px;margin-right:-5px}#topHomepageContainer .search-wrapper form{margin:0 !important}#topHomepageContainer .search-wrapper>*{flex:1 100%}#topHomepageContainer .search-component input[type=\"search\"]{padding:0 35px;height:40px;line-height:40px;border-width:0}#topHomepageContainer .search-component{position:relative}#topHomepageContainer .search-component .search-action-icon{position:absolute;font-size:14px;line-height:inherit;color:black;left:10px;top:10px;background:transparent;border:1px dotted transparent;padding:1px;font-size:0pt;height:20px}#topHomepageContainer .search-component .search-action-icon:focus{border:1px dotted black}#topHomepageContainer .search-component .search-clear-icon{position:absolute;font-size:14px;line-height:inherit;color:#5A5A5A;right:10px;top:10px;background:transparent;padding:0;border:1px dotted transparent;padding:1px;font-size:0pt;height:20px}#topHomepageContainer .search-component .search-clear-icon:focus{border:1px dotted black}#topHomepageContainer .search-component .search-th-row{height:40px;line-height:40px}#topHomepageContainer .search-component .search-th-row:hover{background-color:#eef4fc;border-left:2px solid #5596E6;color:#5596E6}#topHomepageContainer .search-component .keyColumn{text-align:right;width:80px;display:inline-block;font-size:11px;font-weight:bold;overflow:hidden;text-overflow:ellipsis}#topHomepageContainer .search-component .valueColumn{text-align:left;margin-left:20px;display:inline-block;font-size:14px;overflow:hidden;text-overflow:ellipsis}#topHomepageContainer .search-component .filter-list{padding:10px 0}#topHomepageContainer .search-component .filter-list tag-component{margin-right:10px}\n", ""]);
	


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _publishingAtAGlance = __webpack_require__(72);
	
	var _publishingAtAGlance2 = _interopRequireDefault(_publishingAtAGlance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module('HomepageServices').component('publishingAtAGlance', _publishingAtAGlance2.default);
	
	__webpack_require__(76);
	__webpack_require__(81);
	__webpack_require__(86);
	__webpack_require__(91);
	__webpack_require__(96);
	__webpack_require__(101);
	__webpack_require__(106);

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _publishingAtAGlance = __webpack_require__(73);
	
	var _publishingAtAGlance2 = _interopRequireDefault(_publishingAtAGlance);
	
	__webpack_require__(74);
	
	var _logging = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var logger = (0, _logging.createLogger)('publishing-at-a-glance');
	
	var PublishingAtAGlanceTabsController = function PublishingAtAGlanceTabsController($scope, $rootScope, $timeout, $stateParams, publishingErrorService, homepageDataService, tenantRegistryService) {
		var _this = this;
	
		_classCallCheck(this, PublishingAtAGlanceTabsController);
	
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;
		this.$stateParams = $stateParams;
		this.homepageDataService = homepageDataService;
	
		// old constants for x1 tabs
		this.pendingTabId = 'pendingTab';
		this.publishedTabId = 'publishedTab';
		this.errorsTabId = 'errorsTab';
	
		this.errorCount = 0;
		this.returningFromAuthoringDetailsView = false;
	
		this.initialTab = 'pending';
	
		this.$onInit = function () {
			// get the WCH tier we are running
			_this.tier = 'base';
			tenantRegistryService.getTenantInformation().then(function (tenantData) {
				// get the layout for that user
				_this.tier = tenantData.tier.toLowerCase();
				if (_this.tier === 'base') {
					_this.initialTab = 'published';
				}
			}, function (error) {
				logger.error('Error retrieving tenant tier info from server: ' + error.Error);
			});
	
			// check to see if we are coming back from Publishing Job Details view and
			// if so return to the same tab
			logger.info('$stateParams = ' + JSON.stringify(_this.$stateParams));
			if (_this.$stateParams.paagTab && _this.$stateParams.paagTab !== null) {
				_this.initialTab = _this.$stateParams.paagTab;
				_this.returningFromAuthoringDetailsView = true;
			}
	
			// check to see if there are any publishing errors
			publishingErrorService.getCurrentErrorCount().then(function (data) {
				logger.info("Publishing error count = " + data.count);
				_this.errorCount = data.count;
				if (_this.errorCount > 0) {
	
					if (_this.returningFromAuthoringDetailsView === false) {
						_this.initialTab = 'errors';
					}
	
					_this.$timeout(function () {
						var errorsTabLink = document.querySelector("a#link-errors") || document.querySelector("li[index*='errors']>a");
						if (errorsTabLink) {
							errorsTabLink.setAttribute('data-attr', _this.errorCount);
							errorsTabLink.classList.add('error-badge');
							// make the tabs code render again to layout with the error badge
							if (_this.returningFromAuthoringDetailsView === false || _this.initialTab === 'errors') {
								errorsTabLink.click();
							}
						}
					}, 1000);
				} else if (_this.initialTab === 'published') {
					// make the tabs code render again to remove the next/prev arrows if not needed
					_this.$timeout(function () {
						var publishedTabLink = document.querySelector("a#link-published");
						if (publishedTabLink) {
							publishedTabLink.click();
						}
					}, 5);
				}
			});
		};
	};
	
	exports.default = {
		bindings: {
			publishEvents: '<'
		},
		controller: ['$scope', '$rootScope', '$timeout', '$stateParams', 'publishingErrorService', 'homepageDataService', 'tenantRegistryService', PublishingAtAGlanceTabsController],
		templateUrl: _publishingAtAGlance2.default
	};

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	var path = '/authoring-homepage-ui/publishingAtAGlance/publishingAtAGlance.html';
	var html = "<div id=publishing-at-a-glance> <div class=tab-container> <authoring-tabset ng-if=\"$ctrl.tier!=='base'\" class=authoring-tabs active=$ctrl.initialTab>  <authoring-tab index=\"'pending'\" heading=\"{{'Pending' | translate}}\" select=\"$ctrl.selectTab('pending')\"> <publishing-at-a-glance-pending></publishing-at-a-glance-pending> </authoring-tab> <authoring-tab index=\"'published'\" heading=\"{{'Published' | translate}}\" select=\"$ctrl.selectTab('published')\"> <publishing-at-a-glance-published></publishing-at-a-glance-published> </authoring-tab> <authoring-tab index=\"'onHold'\" heading=\"{{'On hold' | translate}}\" select=\"$ctrl.selectTab('onHold')\"> <publishing-at-a-glance-on-hold></publishing-at-a-glance-on-hold> </authoring-tab> <authoring-tab index=\"'errors'\" heading=\"{{'Errors' | translate}}\" select=\"$ctrl.selectTab('errors')\"> <publishing-at-a-glance-errors></publishing-at-a-glance-errors> </authoring-tab> </authoring-tabset> <authoring-tabset ng-if=\"$ctrl.tier==='base'\" class=authoring-tabs active=$ctrl.initialTab> <authoring-tab index=\"'published'\" heading=\"{{'Published' | translate}}\" select=\"$ctrl.selectTab('published')\"> <publishing-at-a-glance-published></publishing-at-a-glance-published> </authoring-tab> <authoring-tab index=\"'errors'\" heading=\"{{'Errors' | translate}}\" select=\"$ctrl.selectTab('errors')\"> <publishing-at-a-glance-errors></publishing-at-a-glance-errors> </authoring-tab> </authoring-tabset> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(75);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./publishingAtAGlance.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./publishingAtAGlance.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)(false);
	// Module
	exports.push([module.id, ".screen-reader-text{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}publishing-at-a-glance{flex:1 1 100%;overflow:auto;padding-left:10px}#publishing-at-a-glance{display:flex;flex-direction:column;flex:1 1;background-color:#fff;height:100%}#publishing-at-a-glance h4{margin:0 0 20px 0}#publishing-at-a-glance .tab-container ul{padding:0;margin:0}#publishing-at-a-glance .tab-container .nav-tabs>li:first-child{margin-left:0px}#publishing-at-a-glance .section{display:flex;flex-direction:column;flex:1 1 0}#publishing-at-a-glance .section .title{margin:0}#publishing-at-a-glance .x1-ui-tabs-content.tab-content{background-color:inherit;padding:10px}#publishing-at-a-glance hr{margin-top:10px}#publishing-at-a-glance .error-badge::after{content:attr(data-attr);width:1rem;height:1rem;line-height:1rem;text-align:center;display:inline-block;border-radius:50%;background:#e62325;color:#FFF;font-size:10px;margin-left:8px;vertical-align:1px}#publishing-at-a-glance .authoring-tabs{display:flex;flex-flow:column;width:100%}#publishing-at-a-glance .authoring-tabs .tab-content{flex:1 1 auto;display:flex;padding:0 20px 10px 20px;overflow:auto}#publishing-at-a-glance .tab-nav{display:flex;flex:0 0 auto;align-items:center}#publishing-at-a-glance .tab-nav .nav-dir{display:block;border:none;background-color:inherit;padding:4px}#publishing-at-a-glance .tab-nav .nav-dir svg{display:block;width:16px;height:16px;stroke:#777677;stroke-width:1.2;fill:none;outline:1px transparent}#publishing-at-a-glance .tab-nav .nav-dir:hover svg,#publishing-at-a-glance .tab-nav .nav-dir:focus svg{stroke:#2d74da;outline:1px dashed #2d74da}#publishing-at-a-glance .tab-nav .nav-dir:disabled svg{stroke:#777677;stroke-dasharray:2, 2}#publishing-at-a-glance .tab-nav .tab-nav-slider{flex:1 0 auto;position:relative;overflow-x:hidden;width:0}#publishing-at-a-glance .tab-nav .tab-nav-slider.left-fade::before,#publishing-at-a-glance .tab-nav .tab-nav-slider.right-fade::after{display:block;position:absolute;top:0;z-index:1;width:30px;height:100%;content:'';pointer-events:none}#publishing-at-a-glance .tab-nav .tab-nav-slider.left-fade::before{left:0;box-shadow:30px 0 30px -15px #fff inset}#publishing-at-a-glance .tab-nav .tab-nav-slider.right-fade::after{right:0;box-shadow:-30px 0 30px -15px #fff inset}#publishing-at-a-glance .tab-nav .tab-nav-slider .nav-tabs{display:flex;flex:0 0 auto;margin:0;padding:0;transition:0.5s ease-in-out}#publishing-at-a-glance .tab-nav .tab-nav-slider .nav-tabs li{position:static;float:none;margin:0 8px}#publishing-at-a-glance .tab-nav .tab-nav-slider .nav-tabs li a{color:#595859;border:1px dotted transparent}#publishing-at-a-glance .tab-nav .tab-nav-slider .nav-tabs li a:focus{border:1px dotted grey}#publishing-at-a-glance .tab-nav .tab-nav-slider .nav-tabs li.active a{border-bottom:2px solid #4178BE}#publishing-at-a-glance .tab-content>.active{flex:1 1 100%;display:flex;flex-direction:column}#publishing-at-a-glance .tab-pane>div{flex:1 1 auto}\n", ""]);
	


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _publishingAtAGlanceAccordion = __webpack_require__(77);
	
	var _publishingAtAGlanceAccordion2 = _interopRequireDefault(_publishingAtAGlanceAccordion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module('HomepageServices').component('publishingAtAGlanceAccordion', _publishingAtAGlanceAccordion2.default);

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _publishingAtAGlanceAccordion = __webpack_require__(78);
	
	var _publishingAtAGlanceAccordion2 = _interopRequireDefault(_publishingAtAGlanceAccordion);
	
	__webpack_require__(79);
	
	var _logging = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var logger = (0, _logging.createLogger)('publishing-at-a-glance-accordion');
	
	var PublishingAtAGlanceAccordionController = function () {
		function PublishingAtAGlanceAccordionController($rootScope, $scope, $state, $document, homepageUtil) {
			var _this = this;
	
			_classCallCheck(this, PublishingAtAGlanceAccordionController);
	
			this.$rootScope = $rootScope;
			this.$state = $state;
			this.$document = $document;
			this.maxDaysToShow = 5;
			this.maxEventsToShow = 8;
			this.homepageUtil = homepageUtil;
	
			this.getUserPreferences();
	
			this.$onChanges = function (binding) {
				// wait for binding entries promise to get delivered to create collapsed/expanded tracking array
				if (angular.isDefined(binding) && binding.entries && binding.entries.currentValue) {
					_this.collapsed = new Array(_this.entries.length).fill(true); //NOSONAR
					_this.collapsed[0] = false;
					logger.info('entries binding updated');
				}
			};
	
			this.$onInit = function () {
				_this.datesort = _this.datesort || '+date';
				_this.timesort = _this.timesort || '+time';
			};
	
			// listen for the event to apply new preferences
			var handler = $rootScope.$on('apply-preferences', function (event, payload) {
				_this.getUserPreferences();
			});
			$scope.$on('$destroy', handler);
		}
	
		// toggle the accordion at the specified index
	
	
		_createClass(PublishingAtAGlanceAccordionController, [{
			key: 'toggle',
			value: function toggle(event, index) {
				// this routine is called for both keypress and mouse events
				var keycode = this.homepageUtil.getKeyCode(event);
				if (typeof keycode !== 'undefined') {
					// a key was pressed, accept enter or space to toggle current accordion
					if (keycode === 13 || keycode === 32) {
						event.preventDefault();
					}
					// down or up arrow, home or end, move title focus
					else if (keycode === 40 || keycode === 38 || keycode === 36 || keycode === 35) {
							var nextIndex = void 0;
	
							switch (keycode) {
								// down arrow key
								case 40:
									nextIndex = index === this.entries.length - 1 ? 0 : index + 1;
									break;
								// home key
								case 36:
									nextIndex = 0;
									break;
								// end key
								case 35:
									nextIndex = this.entries.length - 1;
									break;
								// up arrow key
								case 38:
									nextIndex = index === 0 ? this.entries.length - 1 : index - 1;
									break;
							}
	
							var activeId = angular.element(window.document.activeElement).attr('id');
							if (activeId && activeId.includes('-paneltitle-')) {
								var nextActiveId = activeId.substring(0, activeId.lastIndexOf('-') + 1).concat(nextIndex);
								var elem = this.$document.find('#' + nextActiveId);
								if (elem) {
									logger.info("focus accordion " + nextIndex);
									elem.focus();
									event.preventDefault();
								}
							}
							return;
						}
						// key is not accepted
						else {
								return;
							}
				}
	
				if (this.entries && index < this.entries.length) {
					logger.info("toggle panel " + index);
					this.collapsed[index] = !this.collapsed[index];
				}
			}
		}, {
			key: 'getUserPreferences',
			value: function getUserPreferences() {
				var _this2 = this;
	
				this.homepageUtil.getPublishingAtAGlancePreferences().then(function (rv) {
					// make sure we read something from storage
					if (Object.keys(rv).length > 0) {
						_this2.maxDaysToShow = rv.maxDaysToShow;
						_this2.maxEventsToShow = rv.maxEventsToShow;
					}
				});
			}
		}, {
			key: 'isUndefined',
			value: function isUndefined(value) {
				return angular.isUndefined(value);
			}
		}, {
			key: 'isDefined',
			value: function isDefined(value) {
				return angular.isDefined(value);
			}
		}, {
			key: 'navigateToDetails',
			value: function navigateToDetails(event, kind, id, name) {
				// on keypress event, only accept enter or space
				var keycode = this.homepageUtil.getKeyCode(event);
				if (typeof keycode !== 'undefined' && keycode !== 13 && keycode !== 32) {
					return;
				}
				var detailState = void 0;
				var stateParams = void 0;
				if (kind && kind.length > 0) {
					switch (kind[0]) {
						case 'publishing-job':
							detailState = 'publishing-jobs';
							stateParams = { publishingJobId: id, publishingJobName: name };
							break;
						case 'managed':
							detailState = 'projects';
							stateParams = { projectId: id, projectName: name };
							break;
					}
				}
				if (detailState) {
					var myTab = '';
					switch (this.idprefix) {
						case 'c':
							myTab = 'published';
							break;
						case 'e':
							myTab = 'errors';
							break;
						case 'o':
							myTab = 'onHold';
							break;
						case 'p':
							myTab = 'pending';
							break;
						default:
							break;
					}
					stateParams.paagTab = myTab;
					this.$state.go('authoring.' + detailState + '.detail', stateParams);
				}
			}
		}]);
	
		return PublishingAtAGlanceAccordionController;
	}();
	
	exports.default = {
		//module.exports = {
		controller: ['$rootScope', '$scope', '$state', '$document', 'homepageUtil', PublishingAtAGlanceAccordionController],
		bindings: {
			datesort: '@',
			timesort: '@',
			idprefix: '@',
			entries: '<'
		},
		templateUrl: _publishingAtAGlanceAccordion2.default
	};

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	var path = '/authoring-homepage-ui/publishingAtAGlance/publishingAtAGlanceAccordion/publishingAtAGlanceAccordion.html';
	var html = "<div class=pub-at-a-glance-accordion-top> <div class=pub-at-a-glance-accordion> <div class=panel-group ng-repeat=\"entry in $ctrl.entries | orderBy: $ctrl.datesort | limitTo: $ctrl.maxDaysToShow\"> <div class=panel> <div ng-if=\"$ctrl.idprefix ==='o'\"> <p id={{$ctrl.idprefix}}-title-{{$index}} class=on-hold-message> {{entry.title}} </p> </div> <div class=panel-heading ng-if=\"$ctrl.idprefix !=='o'\"> <div class=\"h4 panel-title\" id={{$ctrl.idprefix}}-paneltitle-{{$index}} ng-click=\"$ctrl.toggle($event, $index)\" ng-keydown=\"$ctrl.toggle($event, $index)\" aria-controls={{$ctrl.idprefix}}-collapse-{{$index}} aria-expanded={{!$ctrl.collapsed[$index]}}> <p ng-if=\"$ctrl.idprefix !=='e'\" id={{$ctrl.idprefix}}-title-{{$index}} class=accordion-toggle ng-class=\"{'collapsed':($ctrl.collapsed[$index])}\" data-toggle=collapse data-parent=#accordion translate=\"{DATE} at {TIME}\" translate-values=\"{DATE: entry.title, TIME: entry.time}\" translate-interpolation=messageformat> </p> <p ng-if=\"$ctrl.idprefix ==='e'\" id={{$ctrl.idprefix}}-title-{{$index}} class=accordion-toggle ng-class=\"{'collapsed':($ctrl.collapsed[$index])}\" data-toggle=collapse data-parent=#accordion translate={{entry.title}}> </p> </div> </div> <div id={{$ctrl.idprefix}}-collapse-{{$index}} class=\"panel-collapse collapse\" ng-class=\"{'in':(!$ctrl.collapsed[$index])}\" aria-hidden={{$ctrl.collapsed[$index]}} role=region aria-labelledby={{$ctrl.idprefix}}-title-{{$index}}> <div class=panel-body role=presentation> <div class=panel-entry ng-repeat=\"body in entry.body | orderBy: $ctrl.timesort | limitTo: $ctrl.maxEventsToShow\" role=presentation> <span ng-if=$ctrl.isUndefined(body.bodyKind) class=body-title>{{body.bodyTitle}}</span><span ng-if=body.bodyIcon class=body-icon style=color:#e62325></span> <a ng-if=$ctrl.isDefined(body.bodyKind) class=body-title href=# ng-click=\"$ctrl.navigateToDetails($event, body.bodyKind, body.bodyId, body.bodyTitle)\">{{body.bodyTitle}}</a><span ng-if=body.bodyIcon class=body-icon style=color:#e62325></span> <p class=body-entry>{{body.bodyEntryName}}</p> </div> </div> </div> </div> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(80);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/sass-loader/index.js!./publishingAtAGlanceAccordion.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/sass-loader/index.js!./publishingAtAGlanceAccordion.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)(false);
	// Module
	exports.push([module.id, ".screen-reader-text{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}publishing-at-a-glance-accordion .pub-at-a-glance-accordion-top{display:block;overflow-y:auto;margin-bottom:5px}publishing-at-a-glance-accordion .pub-at-a-glance-accordion-top .pub-at-a-glance-accordion{max-height:350px;height:350px}publishing-at-a-glance-accordion .pub-at-a-glance-accordion-top .panel-group{margin-bottom:0px}publishing-at-a-glance-accordion .pub-at-a-glance-accordion-top .panel-title{margin:0px;font-size:14px;padding-left:1px;padding-right:1px}publishing-at-a-glance-accordion .pub-at-a-glance-accordion-top .panel-title:focus{color:#2d74da;outline:dashed 1px #343334}publishing-at-a-glance-accordion .pub-at-a-glance-accordion-top .panel-heading{margin-bottom:0px;border-bottom:1px solid #d8d8d8}publishing-at-a-glance-accordion .pub-at-a-glance-accordion-top .panel-heading .accordion-toggle{overflow:auto}publishing-at-a-glance-accordion .pub-at-a-glance-accordion-top .panel-heading .accordion-toggle:after{font-family:'UX1 Glyphicons';font-size:16px;content:\"\\E60D\";float:right !important;color:grey}publishing-at-a-glance-accordion .pub-at-a-glance-accordion-top .panel-heading .accordion-toggle.collapsed:after{content:\"\\E610\"}publishing-at-a-glance-accordion .pub-at-a-glance-accordion-top .panel-entry{padding-bottom:15px}publishing-at-a-glance-accordion .pub-at-a-glance-accordion-top .panel-body{padding-bottom:0px;border-top:0 !important;border-bottom:none !important}publishing-at-a-glance-accordion .pub-at-a-glance-accordion-top .panel{border:none !important}publishing-at-a-glance-accordion .pub-at-a-glance-accordion-top .body-icon{color:\"#e62325\"}publishing-at-a-glance-accordion .pub-at-a-glance-accordion-top .body-icon:after{float:right !important;color:\"#e62325\";content:\"\\E617\";font-size:16px;font-family:\"UX1 Glyphicons\"}publishing-at-a-glance-accordion .pub-at-a-glance-accordion-top .body-title{font-size:12px;font-weight:600}publishing-at-a-glance-accordion .pub-at-a-glance-accordion-top .body-entry{font-size:12px;color:#343334}publishing-at-a-glance-accordion .pub-at-a-glance-accordion-top .on-hold-message{padding-left:15px;padding-top:20px}\n", ""]);
	


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _publishingAtAGlanceErrors = __webpack_require__(82);
	
	var _publishingAtAGlanceErrors2 = _interopRequireDefault(_publishingAtAGlanceErrors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module('HomepageServices').component('publishingAtAGlanceErrors', _publishingAtAGlanceErrors2.default);

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _publishingAtAGlanceErrors = __webpack_require__(83);
	
	var _publishingAtAGlanceErrors2 = _interopRequireDefault(_publishingAtAGlanceErrors);
	
	__webpack_require__(84);
	
	var _logging = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var logger = (0, _logging.createLogger)('publishing-at-a-glance-errors');
	
	var PublishingAtAGlanceErrorsController = function () {
		function PublishingAtAGlanceErrorsController($rootScope, $scope, publishingErrorService) {
			var _this = this;
	
			_classCallCheck(this, PublishingAtAGlanceErrorsController);
	
			this.$rootScope = $rootScope;
			this.$scope = $scope;
			this.publishingErrorService = publishingErrorService;
			this.entries = [];
			this.errorMessages = [];
	
			this.$onInit = function () {
				_this.fetchErrorPublishingJobs();
				//TODO handle error messages from API when available
				//this.errorMessages.push(this.getErrorMessage('OUTAGE'));
			};
	
			// listen for the event to apply new preferences
			var handler = $rootScope.$on('apply-preferences', function (event, payload) {
				_this.fetchErrorPublishingJobs();
			});
			$scope.$on('$destroy', handler);
		}
	
		_createClass(PublishingAtAGlanceErrorsController, [{
			key: 'getErrorMessage',
			value: function getErrorMessage(error) {
				var errorMessage = {};
				switch (error) {
					case 'OUTAGE':
						errorMessage.key = "There is a publishing service outage. As soon as service is restored, the following items will publish.";
						break;
					case 'CANCELLATION':
						errorMessage.key = "Publishing events, routines, or both were cancelled. As a result, content that was scheduled for publishing needs to be rescheduled.";
						break;
					default:
						errorMessage.key = "";
				}
				return errorMessage;
			}
	
			// remove the error message specified by the index
	
		}, {
			key: 'clearErrorMessage',
			value: function clearErrorMessage(index) {
				if (this.errorMessages && index < this.errorMessages.length) {
					this.errorMessages.splice(index, 1);
				}
			}
		}, {
			key: 'fetchErrorPublishingJobs',
			value: function fetchErrorPublishingJobs() {
				var _this2 = this;
	
				this.publishingErrorService.getCurrentErrors().then(function (data) {
					_this2.entries = data;
					_this2.$scope.$apply();
				});
			}
		}]);
	
		return PublishingAtAGlanceErrorsController;
	}();
	
	exports.default = {
		controller: ['$rootScope', '$scope', 'publishingErrorService', PublishingAtAGlanceErrorsController],
		templateUrl: _publishingAtAGlanceErrors2.default
	};

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	var path = '/authoring-homepage-ui/publishingAtAGlance/publishingAtAGlanceErrors/publishingAtAGlanceErrors.html';
	var html = "<div id=publishing-at-a-glance-errors> <div role=alert ng-show=$ctrl.errorMessages ng-repeat=\"message in $ctrl.errorMessages\"> <div class=\"alert alert-danger\"> <span translate={{message.key}}></span> <a href=# class=close data-dismiss=alert aria-label=close ng-click=$ctrl.clearErrorMessage($index);>&times;</a> </div> </div> <div class=section-container> <p class=no-entries translate ng-if=\"$ctrl.entries.length === 0\">There are no publishing errors.</p> <publishing-at-a-glance-accordion entries=$ctrl.entries datesort=-date idprefix=e></publishing-at-a-glance-accordion> <div class=no-calendar-spacer ng-class=\"{'no-entries-empty-height':$ctrl.entries.length === 0}\"></div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(85);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/sass-loader/index.js!./publishingAtAGlanceErrors.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/sass-loader/index.js!./publishingAtAGlanceErrors.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)(false);
	// Module
	exports.push([module.id, ".screen-reader-text{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}#publishing-at-a-glance-errors .alert{white-space:normal;word-break:break-word;word-wrap:break-word;line-height:22px;padding-top:5px;padding-bottom:5px;display:flex}#publishing-at-a-glance-errors .alert span{padding-left:5px;padding-right:5px;flex-grow:3;width:0}#publishing-at-a-glance-errors .alert .close{font-size:x-large}#publishing-at-a-glance-errors .alert .close:focus{border:1px dashed}#publishing-at-a-glance-errors .alert:before{font-size:20px}#publishing-at-a-glance-errors .no-entries{padding-top:10px}#publishing-at-a-glance-errors .no-calendar-spacer{height:78px;max-height:78px}#publishing-at-a-glance-errors .no-entries-empty-height{height:40px}\n", ""]);
	


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _publishingAtAGlancePending = __webpack_require__(87);
	
	var _publishingAtAGlancePending2 = _interopRequireDefault(_publishingAtAGlancePending);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module('HomepageServices').component('publishingAtAGlancePending', _publishingAtAGlancePending2.default);

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _publishingAtAGlancePending = __webpack_require__(88);
	
	var _publishingAtAGlancePending2 = _interopRequireDefault(_publishingAtAGlancePending);
	
	__webpack_require__(89);
	
	var _logging = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var logger = (0, _logging.createLogger)('publishing-at-a-glance-pending');
	
	var PublishingAtAGlancePendingController = function () {
		function PublishingAtAGlancePendingController($rootScope, $scope, $timeout, publishingService, x1UiTabsConstants) {
			var _this = this;
	
			_classCallCheck(this, PublishingAtAGlancePendingController);
	
			this.$rootScope = $rootScope;
			this.$scope = $scope;
			this.$timeout = $timeout;
			this.publishingService = publishingService;
			this.x1UiTabsConstants = x1UiTabsConstants;
			this.entries = [];
			this.message = 'There are no pending publishing events.'; // normal visible message when no entries
			this.srmessage = ''; // used by screen reader
	
			this.$onInit = function () {
				_this.fetchPendingPublishingJobs();
			};
	
			// listen for the event to apply new preferences
			var handler = $rootScope.$on('apply-preferences', function (event, payload) {
				_this.fetchPendingPublishingJobs();
			});
			$scope.$on('$destroy', handler);
	
			// listen for x1 tab selection events
			var handler2 = $rootScope.$on(this.x1UiTabsConstants.EVENTS.selectComplete, function (event, data) {
				if (data.tabId === 'pendingTab') {
	
					// get Jaws to read the message when there are no entries
					if (_this.entries && _this.entries.length === 0) {
						_this.message = 'There are no pending publishing events.';
	
						_this.$timeout(function () {
							_this.srmessage = 'There are no pending publishing events.';
						}, 1500);
					}
				} else {
					_this.srmessage = '';
				}
			});
			$scope.$on('$destroy', handler2);
		}
	
		_createClass(PublishingAtAGlancePendingController, [{
			key: 'fetchPendingPublishingJobs',
			value: function fetchPendingPublishingJobs() {
				var _this2 = this;
	
				this.publishingService.getCurrentPending().then(function (data) {
					_this2.entries = data;
					_this2.$scope.$apply();
				}, function (error) {
					_this2.entries = [];
					_this2.srmessage = 'searchError';
					_this2.message = 'searchError';
				});
			}
		}]);
	
		return PublishingAtAGlancePendingController;
	}();
	
	exports.default = {
		controller: ['$rootScope', '$scope', '$timeout', 'publishingService', 'x1.ui.tabs.constant', PublishingAtAGlancePendingController],
		templateUrl: _publishingAtAGlancePending2.default
	};

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	var path = '/authoring-homepage-ui/publishingAtAGlance/publishingAtAGlancePending/publishingAtAGlancePending.html';
	var html = "<div id=publishing-at-a-glance-pending aria-live=polite> <span class=\"sr-only ng-scope\" translate aria-label=\"There are no pending publishing events.\" role=alert aria-live=polite aria-atomic=true>{{$ctrl.srmessage}}</span> <p class=no-entries translate ng-if=\"$ctrl.entries.length === 0\">{{$ctrl.message}}</p> <publishing-at-a-glance-accordion ng-if=\"$ctrl.entries.length > 0\" datesort=+date timesort=+time idprefix=p entries=$ctrl.entries></publishing-at-a-glance-accordion> <publishing-at-a-glance-open-calendar></publishing-at-a-glance-open-calendar> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(90);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/sass-loader/index.js!./publishingAtAGlancePending.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/sass-loader/index.js!./publishingAtAGlancePending.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)(false);
	// Module
	exports.push([module.id, ".screen-reader-text{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}#publishing-at-a-glance-pending .no-entries{padding-top:10px;height:355px;margin-bottom:0px}\n", ""]);
	


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _publishingAtAGlanceOnHold = __webpack_require__(92);
	
	var _publishingAtAGlanceOnHold2 = _interopRequireDefault(_publishingAtAGlanceOnHold);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module('HomepageServices').component('publishingAtAGlanceOnHold', _publishingAtAGlanceOnHold2.default);

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _publishingAtAGlanceOnHold = __webpack_require__(93);
	
	var _publishingAtAGlanceOnHold2 = _interopRequireDefault(_publishingAtAGlanceOnHold);
	
	__webpack_require__(94);
	
	var _logging = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var logger = (0, _logging.createLogger)('publishing-at-a-glance-on-hold');
	
	var PublishingAtAGlanceOnHoldController = function () {
		function PublishingAtAGlanceOnHoldController($rootScope, $scope, publishingService) {
			var _this = this;
	
			_classCallCheck(this, PublishingAtAGlanceOnHoldController);
	
			this.$rootScope = $rootScope;
			this.$scope = $scope;
			this.publishingService = publishingService;
			this.entries = [];
	
			// fetch current publishing on hold items
			this.fetchOnHoldPublishingJobs();
	
			// listen for the event to apply new preferences
			var handler = $rootScope.$on('apply-preferences', function (event, payload) {
				_this.fetchOnHoldPublishingJobs();
			});
			$scope.$on('$destroy', handler);
		}
	
		_createClass(PublishingAtAGlanceOnHoldController, [{
			key: 'fetchOnHoldPublishingJobs',
			value: function fetchOnHoldPublishingJobs() {
				var _this2 = this;
	
				this.publishingService.getCurrentOnHold().then(function (data) {
					_this2.entries = data;
					_this2.$scope.$apply();
				});
			}
		}]);
	
		return PublishingAtAGlanceOnHoldController;
	}();
	
	exports.default = {
		controller: ['$rootScope', '$scope', 'publishingService', PublishingAtAGlanceOnHoldController],
		templateUrl: _publishingAtAGlanceOnHold2.default
	};

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	var path = '/authoring-homepage-ui/publishingAtAGlance/publishingAtAGlanceOnHold/publishingAtAGlanceOnHold.html';
	var html = "<div id=publishing-at-a-glance-on-hold> <div class=section-container> <p class=no-entries translate ng-if=\"$ctrl.entries.length === 0\">There are no publishing events on hold.</p> <publishing-at-a-glance-accordion entries=$ctrl.entries datesort=-date idprefix=o></publishing-at-a-glance-accordion> <div class=no-calendar-spacer ng-class=\"{'no-entries-empty-height':$ctrl.entries.length === 0}\"></div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(95);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/sass-loader/index.js!./publishingAtAGlanceOnHold.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/sass-loader/index.js!./publishingAtAGlanceOnHold.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)(false);
	// Module
	exports.push([module.id, ".screen-reader-text{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}#publishing-at-a-glance-on-hold .no-entries{padding-top:10px}#publishing-at-a-glance-on-hold .no-calendar-spacer{height:78px;max-height:78px}#publishing-at-a-glance-on-hold .no-entries-empty-height{height:40px}\n", ""]);
	


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _publishingAtAGlancePreferences = __webpack_require__(97);
	
	var _publishingAtAGlancePreferences2 = _interopRequireDefault(_publishingAtAGlancePreferences);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module('HomepageServices').component('publishingAtAGlancePreferences', _publishingAtAGlancePreferences2.default);

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _publishingAtAGlancePreferences = __webpack_require__(98);
	
	var _publishingAtAGlancePreferences2 = _interopRequireDefault(_publishingAtAGlancePreferences);
	
	__webpack_require__(99);
	
	var _logging = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var logger = (0, _logging.createLogger)('publishing-at-a-glance-preferences');
	
	var PublishingAtAGlancePreferencesController = function () {
		function PublishingAtAGlancePreferencesController($rootScope, $timeout, homepageUtil) {
			var _this = this;
	
			_classCallCheck(this, PublishingAtAGlancePreferencesController);
	
			this.$rootScope = $rootScope;
			this.$timeout = $timeout;
			this.homepageUtil = homepageUtil;
	
			this.loading = true;
	
			// max allowed values
			this.maxDays = 30;
			this.maxEvents = 50;
	
			// initial settings
			this.toggleValue = true;
			this.maxDaysToShow = 5;
			this.maxEventsToShow = 8;
			this.homepageUtil.getPublishingAtAGlancePreferences().then(function (rv) {
				// make sure we read something from storage
				if (Object.keys(rv).length > 0) {
					_this.toggleValue = rv.onlyMyEvents;
					_this.maxDaysToShow = rv.maxDaysToShow;
					_this.maxEventsToShow = rv.maxEventsToShow;
				}
				_this.loading = false;
	
				// set initial focus on toggle rather than on title close button
				_this.$timeout(function () {
					_this.setFocusOnToggle();
					// signal that preferences should be open (done here since x1-popover does not seem to provide)
					_this.$rootScope.$emit('preferences-open');
				}, 200);
			});
		}
	
		_createClass(PublishingAtAGlancePreferencesController, [{
			key: 'cancelPreferences',
			value: function cancelPreferences() {
				var close = document.querySelector(".x1-ui-popover .close");
				if (close) {
					this.$timeout(function () {
						close.click();
					}, 100);
				}
			}
		}, {
			key: 'applyPreferences',
			value: function applyPreferences() {
				var _this2 = this;
	
				var userPreferences = { onlyMyEvents: this.toggleValue, maxDaysToShow: this.maxDaysToShow, maxEventsToShow: this.maxEventsToShow };
				this.homepageUtil.setPublishingAtAGlancePreferences(userPreferences).then(function (rv) {
					// signal to apply the new preferences to pending and published
					_this2.$rootScope.$emit('apply-preferences', userPreferences);
				});
				this.cancelPreferences();
			}
	
			// keep the tab focus within our panel
	
		}, {
			key: 'keyTabFocus',
			value: function keyTabFocus(event) {
				if (event.shiftKey === false && event.keyCode === 9 && event.target.id === 'cancelBtn') {
					event.preventDefault();
					this.setFocusOnToggle();
				} else if (event.shiftKey === true && event.keyCode === 9 && event.target.id === 'myPublishEventsToggleCheckBox') {
					event.preventDefault();
					var btn = document.querySelector('#cancelBtn');
					btn.focus();
				}
			}
		}, {
			key: 'setFocusOnToggle',
			value: function setFocusOnToggle(event) {
				var toggle = document.querySelector('#myPublishEventsToggleCheckBox');
				toggle.focus();
			}
		}]);
	
		return PublishingAtAGlancePreferencesController;
	}();
	
	exports.default = {
		controller: ['$rootScope', '$timeout', 'homepageUtil', PublishingAtAGlancePreferencesController],
		templateUrl: _publishingAtAGlancePreferences2.default
	};

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	var path = '/authoring-homepage-ui/publishingAtAGlance/publishingAtAGlancePreferences/publishingAtAGlancePreferences.html';
	var html = "<div class=publishing-at-a-glance-preferences> <div class=loading ng-if=$ctrl.loading> <div class=loader> <div></div> <div></div> <div></div> <div></div> </div> </div> <div ng-show=!$ctrl.loading> <div class=\"form-group switch\" id=myPublishEventsToggle> <div></div> <label id=myPublishEventsToggleLabel> <p translate>Only see my publishing events</p> <input type=checkbox aria-labelledby=myPublishEventsToggleLabel ng-model=$ctrl.toggleValue ng-checked=$ctrl.toggleValue ng-click=$ctrl.onToggle($ctrl.toggleValue) ng-keydown=$ctrl.keyTabFocus($event) id=myPublishEventsToggleCheckBox> <span></span> </label> </div> <div class=form-group> <form name=maxDaysForm aria-labelledby=maxDaysLabel> <label id=maxDaysLabel for=maxDays translate>Maximum number of days to show</label> <div class=prefs-error ng-show=maxDaysForm.maxDaysToShow.$invalid> <span role=alert> <span class=\"glyphicon glyphicon-warning-sign\"></span> <span ng-if=!maxDaysForm.maxDaysToShow.$error.max class=errorText translate>The value for maximum number of days to show is invalid. Enter a numeric value greater than 0.</span> <span ng-if=maxDaysForm.maxDaysToShow.$error.max class=errorText translate=\"The value exceeds the maximum number of days to show. Enter a value that is less than or equal to {MAX}.\" translate-values=\"{MAX: $ctrl.maxDays}\"></span> </span> </div> <div class=input-group> <input id=maxDays ng-min=1 ng-max={{$ctrl.maxDays}} name=maxDaysToShow class=\"form-control auth-input-sm\" type=number placeholder={{$ctrl.maxDaysToShow}} ng-model=$ctrl.maxDaysToShow ng-required=true> <span class=input-group-addon translate>per tab</span> </div> </form> </div> <div class=form-group> <form name=maxEventsForm aria-labelledby=maxEventsLabel> <div class=prefs-error ng-show=maxEventsForm.maxEventsToShow.$invalid> <span role=alert> <span class=\"glyphicon glyphicon-warning-sign\"></span> <span ng-if=!maxEventsForm.maxEventsToShow.$error.max class=errorText translate>The value for maximum number of events to show is invalid. Enter a numeric value greater than 0.</span> <span ng-if=maxEventsForm.maxEventsToShow.$error.max class=errorText translate=\"The value exceeds the maximum number of events to show. Enter a value that is less than or equal to {MAX}.\" translate-values=\"{MAX: $ctrl.maxEvents}\"></span> </span> </div> <label id=maxEventsLabel for=maxEvents translate>Maximum number of events to show</label> <div class=input-group> <input id=maxEvents ng-min=1 ng-max={{$ctrl.maxEvents}} name=maxEventsToShow class=\"form-control auth-input-sm\" type=number placeholder={{$ctrl.maxEventsToShow}} ng-model=$ctrl.maxEventsToShow ng-required=true> <span class=input-group-addon translate>per day</span> </div> </form> </div> <div class=button-group> <div class=pull-right> <button class=\"btn btn-primary\" ng-click=$ctrl.applyPreferences() translate>Apply</button> <button class=\"btn btn-secondary\" ng-click=$ctrl.cancelPreferences() ng-keydown=$ctrl.keyTabFocus($event) id=cancelBtn translate>Cancel</button> </div> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(100);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/sass-loader/index.js!./publishingAtAGlancePreferences.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/sass-loader/index.js!./publishingAtAGlancePreferences.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)(false);
	// Module
	exports.push([module.id, ".screen-reader-text{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}.publishing-at-a-glance-preferences .form-group.switch{margin-bottom:10px}.publishing-at-a-glance-preferences .switch input[type=\"checkbox\"]+span{margin-left:0}.publishing-at-a-glance-preferences .form-control.auth-input-sm{width:100px}.publishing-at-a-glance-preferences .input-group-addon{border:none;background:transparent;width:initial;padding-left:5px}.publishing-at-a-glance-preferences .button-group{border-top:1px solid #d8d8d8;padding-top:10px}.publishing-at-a-glance-preferences .glyphicon-warning-sign::before{padding-right:5px;color:#e62325}.publishing-at-a-glance-preferences .prefs-error{padding-bottom:10px}.publishing-at-a-glance-preferences .form-control.ng-invalid,.publishing-at-a-glance-preferences .form-control.ng-invalid:focus:hover,.publishing-at-a-glance-preferences .form-control.ng-invalid:hover{box-shadow:0 0 0 1px #fff,0 0 0 2px #e62325}.publishing-at-a-glance-preferences .errorText{font-family:\"Helvetica Neue for IBM\", Helvetica, Arial, sans-serif;color:#343334}.publishing-at-a-glance-preferences .loading{text-align:center;align-items:center;width:250px}.publishing-at-a-glance-preferences .loader{width:80px;height:50px;font-size:20px}.publishing-at-a-glance-preferences .loader div{background-color:#b7c9e2;height:100%;width:6px;display:inline-block;animation:loader 1s infinite ease-in-out}.publishing-at-a-glance-preferences .loader div:nth-child(2){animation-delay:-.9s}.publishing-at-a-glance-preferences .loader div:nth-child(3){animation-delay:-.8s}.publishing-at-a-glance-preferences .loader div:nth-child(4){animation-delay:-.7s}@keyframes loader{0%,100%{transform:scaleY(0.2)}20%{transform:scaleY(1);background:#4e78b9}}\n", ""]);
	


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _publishingAtAGlancePublished = __webpack_require__(102);
	
	var _publishingAtAGlancePublished2 = _interopRequireDefault(_publishingAtAGlancePublished);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module('HomepageServices').component('publishingAtAGlancePublished', _publishingAtAGlancePublished2.default);

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _publishingAtAGlancePublished = __webpack_require__(103);
	
	var _publishingAtAGlancePublished2 = _interopRequireDefault(_publishingAtAGlancePublished);
	
	__webpack_require__(104);
	
	var _logging = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var logger = (0, _logging.createLogger)('publishing-at-a-glance-published');
	
	var PublishingAtAGlancePublishedController = function () {
		function PublishingAtAGlancePublishedController($rootScope, $scope, publishingService, x1UiTabsConstants, $timeout) {
			var _this = this;
	
			_classCallCheck(this, PublishingAtAGlancePublishedController);
	
			this.$rootScope = $rootScope;
			this.$scope = $scope;
			this.$timeout = $timeout;
			this.publishingService = publishingService;
			this.x1UiTabsConstants = x1UiTabsConstants;
			this.entries = [];
			this.message = 'There are no completed publishing events.'; // normal visible message when no entries
			this.srmessage = ''; // used by screen reader
	
			this.$onInit = function () {
				_this.fetchCompletedPublishingJobs();
			};
	
			// listen for the event to apply new preferences
			var handler = $rootScope.$on('apply-preferences', function (event, payload) {
				_this.fetchCompletedPublishingJobs();
			});
			$scope.$on('$destroy', handler);
	
			// listen for x1 tab selection events to hide the accordion
			var handler2 = $rootScope.$on(this.x1UiTabsConstants.EVENTS.selectComplete, function (event, data) {
				if (data.tabId === 'publishedTab') {
	
					// get Jaws to read the message when there are no entries
					if (_this.entries && _this.entries.length === 0) {
						_this.message = 'There are no completed publishing events.';
	
						_this.$timeout(function () {
							_this.srmessage = 'There are no completed publishing events.';
						}, 1500);
					}
				} else {
					_this.srmessage = '';
				}
			});
			$scope.$on('$destroy', handler2);
		}
	
		_createClass(PublishingAtAGlancePublishedController, [{
			key: 'fetchCompletedPublishingJobs',
			value: function fetchCompletedPublishingJobs() {
				var _this2 = this;
	
				this.publishingService.getCurrentPublished().then(function (data) {
					_this2.entries = data;
					_this2.$scope.$apply();
				}, function (error) {
					_this2.entries = [];
					_this2.srmessage = 'searchError';
					_this2.message = 'searchError';
				});
			}
		}]);
	
		return PublishingAtAGlancePublishedController;
	}();
	
	exports.default = {
		controller: ['$rootScope', '$scope', 'publishingService', 'x1.ui.tabs.constant', '$timeout', PublishingAtAGlancePublishedController],
		templateUrl: _publishingAtAGlancePublished2.default
	};

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	var path = '/authoring-homepage-ui/publishingAtAGlance/publishingAtAGlancePublished/publishingAtAGlancePublished.html';
	var html = "<div id=publishing-at-a-glance-published aria-live=polite> <span class=\"sr-only ng-scope\" translate aria-label=\"There are no completed publishing events.\" role=alert aria-live=polite aria-atomic=true>{{$ctrl.srmessage}}</span> <p class=no-entries id=no-completed-events translate ng-if=\"$ctrl.entries.length === 0\">{{$ctrl.message}}</p> <publishing-at-a-glance-accordion ng-if=\"$ctrl.entries.length > 0\" datesort=-date timesort=-time idprefix=c entries=$ctrl.entries></publishing-at-a-glance-accordion> <publishing-at-a-glance-open-calendar></publishing-at-a-glance-open-calendar> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(105);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/sass-loader/index.js!./publishingAtAGlancePublished.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/sass-loader/index.js!./publishingAtAGlancePublished.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)(false);
	// Module
	exports.push([module.id, ".screen-reader-text{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}#publishing-at-a-glance-published .no-entries{padding-top:10px;height:355px;margin-bottom:0px}\n", ""]);
	


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _publishingAtAGlanceOpenCalendar = __webpack_require__(107);
	
	var _publishingAtAGlanceOpenCalendar2 = _interopRequireDefault(_publishingAtAGlanceOpenCalendar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module('HomepageServices').component('publishingAtAGlanceOpenCalendar', _publishingAtAGlanceOpenCalendar2.default);

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _publishingAtAGlanceOpenCalendar = __webpack_require__(108);
	
	var _publishingAtAGlanceOpenCalendar2 = _interopRequireDefault(_publishingAtAGlanceOpenCalendar);
	
	__webpack_require__(109);
	
	var _logging = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var logger = (0, _logging.createLogger)('publishing-at-a-glance-open-calendar');
	
	var PublishingAtAGlanceOpenCalendarController = function () {
		function PublishingAtAGlanceOpenCalendarController($state, homepageUtil) {
			var _this = this;
	
			_classCallCheck(this, PublishingAtAGlanceOpenCalendarController);
	
			this.$state = $state;
			this.homepageUtil = homepageUtil;
			// icon used for open calendar button
			this.img = __webpack_require__(111);
	
			// this should be called when page loading completes
			angular.element(function () {
				_this.adjustRendering();
			});
	
			$(window).resize(this.adjustRendering);
		}
	
		_createClass(PublishingAtAGlanceOpenCalendarController, [{
			key: 'navigateToPublishCalendar',
			value: function navigateToPublishCalendar(event) {
				// on keypress event, only accept enter or space
				var keycode = this.homepageUtil.getKeyCode(event);
				if (typeof keycode !== 'undefined' && keycode !== 13 && keycode !== 32) {
					return;
				}
				this.$state.go('prod-authoring-publishing-ui.root');
			}
	
			// maintain the top padding as the title bar height changes when things get resized
	
		}, {
			key: 'adjustRendering',
			value: function adjustRendering() {
				var titlebarHeight = angular.element(document.querySelector('#pub_glance>.widget>.titlebar')).outerHeight();
				var newPadding = 60;
				if (titlebarHeight > 90) {
					newPadding = 26;
				} else if (titlebarHeight > 70) {
					newPadding = 44;
				}
				var newPaddingTop = 'padding-top:' + newPadding + 'px';
				var openCals = document.querySelectorAll('publishing-at-a-glance-open-calendar>.calendar-icon');
				// no forEach support, sigh
				for (var index = 0; index < openCals.length; index++) {
					angular.element(openCals[index]).attr('style', newPaddingTop);
				}
			}
		}]);
	
		return PublishingAtAGlanceOpenCalendarController;
	}();
	
	exports.default = {
		controller: ['$state', 'homepageUtil', PublishingAtAGlanceOpenCalendarController],
		templateUrl: _publishingAtAGlanceOpenCalendar2.default
	};

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	var path = '/authoring-homepage-ui/publishingAtAGlance/publishingAtAGlanceOpenCalendar/publishingAtAGlanceOpenCalendar.html';
	var html = "<div class=calendar-icon> <svg width=16 height=16 alt=\"{{'Open calendar' | translate}}\" role=img aria-label=\"{{'Open calendar' | translate}}\"> <use xlink:href={{::$ctrl.img}} /> </svg> <span role=link ng-click=$ctrl.navigateToPublishCalendar($event)> <a href=# translate=\"Open calendar\"></a> </span> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(110);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/sass-loader/index.js!./publishingAtAGlanceOpenCalendar.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/sass-loader/index.js!./publishingAtAGlanceOpenCalendar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)(false);
	// Module
	exports.push([module.id, ".screen-reader-text{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}publishing-at-a-glance-open-calendar .calendar-icon{display:flex;justify-content:center;padding-top:40px}publishing-at-a-glance-open-calendar .calendar-icon svg{fill:#777677}publishing-at-a-glance-open-calendar .calendar-icon a{margin-left:5px}publishing-at-a-glance-open-calendar .calendar-icon .text{color:#777677;padding-left:5px}publishing-at-a-glance-open-calendar .calendar-icon .text:hover,publishing-at-a-glance-open-calendar .calendar-icon .text:focus{color:#2d74da}publishing-at-a-glance-open-calendar .calendar-icon .btn{color:#595859;font-weight:400}publishing-at-a-glance-open-calendar .calendar-icon .btn:focus{color:#2d74da;text-decoration:underline}publishing-at-a-glance-open-calendar .calendar-icon .btn:hover{text-decoration:none}publishing-at-a-glance-open-calendar .calendar-icon .btn.open .text{color:#2d74da;text-decoration:underline}publishing-at-a-glance-open-calendar .calendar-icon .btn:disabled{border:0}\n", ""]);
	


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	
	var sprite = __webpack_require__(45);
	var image = "<symbol viewBox=\"0 0 20 20\" id=\"Clock-20px-Glance\" ><path d=\"M14.5 11H11V5.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5V12h4.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z\"/><path d=\"M10.5 2.2c4.6 0 8.3 3.7 8.3 8.3s-3.7 8.3-8.3 8.3-8.3-3.7-8.3-8.3 3.7-8.3 8.3-8.3m0-1.2C5.3 1 1 5.3 1 10.5S5.3 20 10.5 20s9.5-4.3 9.5-9.5S15.7 1 10.5 1z\"/></symbol>";
	module.exports = sprite.add(image, "Clock-20px-Glance");

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('HomepageServices').component('downloadSite', __webpack_require__(113));

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _logging = __webpack_require__(11);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var template = __webpack_require__(114);
	__webpack_require__(116);
	
	var logger = (0, _logging.createLogger)('download-site');
	//var logger = require('../../common/logging.config');
	
	
	var downloadAssetsController = function () {
	    function downloadAssetsController($scope, downloadInfoService, $translate, homepageUtil, tenantRegistryService, x1Modal, shellUtil) {
	        var _this = this;
	
	        _classCallCheck(this, downloadAssetsController);
	
	        this.$translate = $translate;
	        this.homepageUtil = homepageUtil;
	        this.shellUtil = shellUtil;
	        this.downloadInfoService = downloadInfoService;
	        this.modal = x1Modal;
	        this.$scope = $scope;
	
	        $scope.OsloDate = 'N/A';
	        $scope.StockholmDate = 'N/A';
	        $scope.installedSampleName = 'N/A';
	        $scope.showInstalledBuildDate = false;
	        $scope.showLatestAvailableBuildDate = false;
	        $scope.showLatestStockholmDate = false;
	        $scope.showInstalledSample = false;
	
	        $scope.showDownloadStockholm = false;
	        $scope.getDownloadStockholmInfo = false;
	        $scope.stockholmToggleOn = shellUtil.isToggleOn('downloadStockholm');
	        $scope.importSiteToggleOn = shellUtil.isToggleOn('importSite');
	
	        // Get Latest Stockholm available date. Called only downloadStockholm or importSite toggle is on
	        if ($scope.stockholmToggleOn || $scope.importSiteToggleOn) {
	            //get Latest Stockholm update date
	            downloadInfoService.getDownloadInfo('stockholm').then(function (data) {
	                logger.info("Got Stockholm Date - " + data.Date);
	                var date = new Date(data.NewVersion !== undefined ? data.NewVersion : data.Date);
	                $scope.getDownloadStockholmInfo = true;
	
	                //Don't show donwload stockholm in this case;
	                if (data.isCommerce === false) {
	                    $scope.showDownloadStockholm = false;
	                    return null;
	                } else {
	                    $scope.showDownloadStockholm = true;
	                    // Triggered when API fails
	                    if (!date || date.toDateString() === "Invalid Date") {
	                        $scope.StockholmDate = _this.$translate.instant("Unavailable");
	                        $scope.showLatestStockholmDate = false;
	                        return $scope.StockholmDate;
	                    }
	                    $scope.showLatestStockholmDate = true;
	                    $scope.StockholmDate = _this._getLocaleDateString(date);
	                    return $scope.StockholmDate;
	                }
	            }, function (error) {
	                logger.error('Error retrieving date of downloadable Stockholm templates: ' + error);
	                $scope.getDownloadStockholmInfo = true;
	                return [];
	            });
	        }
	
	        //Get Latest SPA available date
	        downloadInfoService.getDownloadInfo().then(function (data) {
	            logger.info("Got Oslo Date - " + data.NewVersion);
	            var date = new Date(data.NewVersion !== undefined ? data.NewVersion : data.Date);
	
	            // Triggered when API fails
	            if (!date || date.toDateString() === "Invalid Date") {
	                $scope.OsloDate = _this.$translate.instant("Unavailable");
	                $scope.showLatestAvailableBuildDate = false;
	                return $scope.OsloDate;
	            }
	            $scope.showLatestAvailableBuildDate = true;
	            $scope.OsloDate = _this._getLocaleDateString(date);
	            return $scope.OsloDate;
	        }, function (error) {
	            logger.error('Error retrieving date of downloadable Oslo templates: ' + error);
	            return [];
	        });
	
	        // Get installed build date
	        tenantRegistryService.getTenantInformation().then(function (tenantData) {
	            // If the tenant has a custom hostname(ch), then use the custom one, or use the hostname(h)
	            var domain_name = JSON.parse(tenantData.edgeToken)["ch"] ? JSON.parse(tenantData.edgeToken)["ch"] : JSON.parse(tenantData.edgeToken)["h"];
	            logger.info('Domain name used:' + domain_name);
	
	            _this.getSiteBuildDate(domain_name, tenantData.id);
	        }, function (error) {
	            logger.error('Error retrieving tenant id info from server: ' + error.Error);
	        });
	    }
	
	    // Get installed SPA build date by reading buildDate.json in Developer Assets
	
	
	    _createClass(downloadAssetsController, [{
	        key: 'getSiteBuildDate',
	        value: function getSiteBuildDate(domain_name, tenant_ID) {
	            var _this2 = this;
	
	            return this.downloadInfoService.getSiteBuildDate(domain_name, tenant_ID).then(function (data) {
	                logger.info("Installed sample build Date - " + data.buildDate);
	                var site_name = data.name;
	                var date = new Date(data.buildDate);
	
	                // Triggered when build Date is not available
	                if (!data.buildDate || !date || date.toDateString() === "Invalid Date") {
	                    _this2.$scope.showInstalledBuildDate = false;
	                    return false;
	                }
	                _this2.$scope.installedSampleName = site_name === undefined ? 'N/A' : site_name;
	                _this2.$scope.showInstalledSample = true;
	
	                _this2.$scope.showInstalledBuildDate = true;
	                _this2.$scope.buildDate = _this2._getLocaleDateString(date);
	                return true;
	            }, function (error) {
	                logger.info('Error retrieving build date of downloadable Oslo templates: ' + error);
	                return false;
	            });
	        }
	
	        // Download SPA sample 
	
	    }, {
	        key: 'getDownload',
	        value: function getDownload(template_name) {
	            var _this3 = this;
	
	            this.shellUtil.bindAnalytics("e", "WCH Widget Sample Site Download", "WCH Widgets");
	            var xhr = new XMLHttpRequest();
	            var url = template_name === undefined ? '/api/infra/v1/download' : template_name === 'stockholm' ? '/api/infra/v1/download/sample-stockholm' : '/api/infra/v1/download/sample-oslo';
	            xhr.open('head', url, true);
	            xhr.send(null);
	
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState === 4 && xhr.status === 200) {
	                    window.location.href = url;
	                    logger.info("Download Site: Successful");
	                } else if (xhr.readyState === 4) {
	                    _this3.errorMessage = "Download Site errors:" + xhr.status + ", " + xhr.statusText;
	                    logger.error(_this3.errorMessage);
	                }
	            };
	        }
	
	        // Deploy SPA sample
	
	    }, {
	        key: 'getDeploy',
	        value: function getDeploy(template_name) {
	            var _this4 = this;
	
	            return this.downloadInfoService.getDeploySite(template_name).then(function (data) {
	                logger.info("Got Deploy - " + data);
	
	                if (data.status && data.status === 'working') {
	                    _this4.showDeployErrorModal();
	                    return 'working';
	                }
	
	                _this4.showDeployStartModal();
	                return "deployed";
	            }, function (error) {
	                logger.error('Error retrieving deploy service: ' + error);
	                _this4.showDeployErrorModal(error);
	                return "deployment error";
	            });
	        }
	
	        // Open the warning modal before deploy/import service is triggered
	
	    }, {
	        key: 'showDeployModal',
	        value: function showDeployModal(template_name) {
	            var _this5 = this;
	
	            var deployHeader = 'Import your site';
	
	            return this.$translate([deployHeader]).then(function (nls) {
	                deployHeader = nls[deployHeader];
	
	                return _this5.modal.show({
	                    options: {
	                        headerText: deployHeader,
	                        showActionButton: true,
	                        actionButtonText: "Import",
	                        showCloseButton: true
	                    },
	                    settings: {
	                        type: "warning"
	                    },
	                    data: {
	                        text: "This action will delete all your content in your tenant. Do you want to continue?"
	                    }
	                }).then(function (result) {
	                    _this5.getDeploy(template_name);
	                    return 'success';
	                });
	            }).catch(function (err) {
	                if (err && err !== 'cancel' && err !== 'backdrop click') {
	                    logger.error(err);
	                    return 'error';
	                }
	            });
	        }
	
	        // Open the error modal when deploy/import service returned error
	
	    }, {
	        key: 'showDeployErrorModal',
	        value: function showDeployErrorModal(msg) {
	            var _this6 = this;
	
	            var errorHeader = 'Import error';
	            var errorMsg = msg === undefined ? "Acoustic Content is importing our newest site template into your tenant now!" : msg;
	
	            return this.$translate([errorHeader]).then(function (nls) {
	                errorHeader = nls[errorHeader];
	
	                return _this6.modal.show({
	                    options: {
	                        headerText: errorHeader,
	                        showActionButton: false,
	                        showCloseButton: false
	                    },
	                    settings: {
	                        type: "error"
	                    },
	                    data: {
	                        text: errorMsg
	                    }
	                }).then(function (res) {
	                    return 'success';
	                });
	            }).catch(function (err) {
	                if (err && err !== 'cancel' && err !== 'backdrop click') {
	                    logger.error(err);
	                    return 'error';
	                }
	            });
	        }
	
	        // Open the error modal when deploy/import service is busy
	
	    }, {
	        key: 'showDeployStartModal',
	        value: function showDeployStartModal() {
	            var _this7 = this;
	
	            var msgHeader = 'Import is started';
	
	            return this.$translate([msgHeader]).then(function (nls) {
	                msgHeader = nls[msgHeader];
	
	                return _this7.modal.show({
	                    options: {
	                        headerText: msgHeader,
	                        showActionButton: false,
	                        showCloseButton: false
	                    },
	                    settings: {
	                        type: "confirmation"
	                    },
	                    data: {
	                        text: "The import service is started. It may take up to 20 minutes to be finished."
	                    }
	                }).then(function (res) {
	                    return 'success';
	                });
	            }).catch(function (err) {
	                if (err && err !== 'cancel' && err !== 'backdrop click') {
	                    logger.error(err);
	                    return 'error';
	                }
	            });
	        }
	
	        // Show the date in different formats based on the locale you choose in both CUI and Browser
	
	    }, {
	        key: '_getLocaleDateString',
	        value: function _getLocaleDateString(date) {
	            if (!date || date === "Invalid Date") {
	                return null;
	            }
	            var currentLocale = this.homepageUtil.getCurrentLocale().replace('_', '-');
	            var options = { year: 'numeric', month: '2-digit', day: '2-digit' };
	
	            return date.toLocaleString(currentLocale, options);
	        }
	    }]);
	
	    return downloadAssetsController;
	}();
	
	;
	
	module.exports = {
	    templateUrl: template,
	    controller: ["$scope", "downloadInfoService", "$translate", "homepageUtil", "tenantRegistryService", "x1Modal", "shellUtil", downloadAssetsController]
	};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var path = '/authoring-homepage-ui/downloadSite/downloadSite.html';
	var html = "<div ng-if=\"stockholmToggleOn && showDownloadStockholm && getDownloadStockholmInfo || importSiteToggleOn\" class=download-widget> <div ng-if=showInstalledBuildDate class=installed-date-panel> <span ng-if=showInstalledSample> <span class=installed-sample-text>{{\"Installed sample: \"| translate}}</span> <span ng-if=\"installedSampleName !== 'Stockholm'\">{{\"Oslo (\"| translate}} {{buildDate}} {{\")\"}}</span> <span ng-if=\"installedSampleName == 'Stockholm'\">{{\"Stockholm (\"| translate}} {{buildDate}} {{\")\"}}</span> </span> </div> <div ng-if=showDownloadStockholm class=buttons-container> <div class=\"download-panel left-panel\"> <h4> <span ng-if=\"showInstalledSample && installedSampleName !== 'Stockholm'\" class=\"glyphicon glyphicon-ok-circle\" style=color:green aria-label=\"{{'Oslo site is installed'|translate}}\"></span> {{\"Oslo\"}} </h4> <span ng-if=showLatestAvailableBuildDate class=latestDate>{{\"Most current sample posted on: \" | translate}} {{OsloDate}}</span><br> <button class=\"download-site-btn btn btn-primary\" ng-click=\"$ctrl.showDeployModal('oslo')\"> <span translate>{{\"Import\"}}</span> </button> <button class=\"download-site-btn btn btn-primary\" ng-click=\"$ctrl.getDownload('oslo')\"> <span translate>{{\"Download\"}}</span> </button> </div> <div class=\"download-panel right-panel\"> <h4> <span ng-if=\"showInstalledSample && installedSampleName === 'Stockholm'\" class=\"glyphicon glyphicon-ok-circle\" style=color:green aria-label=\"{{'Stockholm site is installed'|translate}}\"></span> {{\"Stockholm\"}} </h4> <span ng-if=\"showLatestStockholmDate || importSiteToggleOn\" class=latestDate>{{\"Most current sample posted on: \" | translate}} {{StockholmDate}}</span><br> <button class=\"download-site-btn btn btn-primary\" ng-click=\"$ctrl.showDeployModal('stockholm')\"> <span translate>{{\"Import\"}}</span> </button> <button class=\"download-site-btn btn btn-primary\" ng-click=\"$ctrl.getDownload('stockholm')\"> <span translate>{{\"Download\"}}</span> </button> </div> </div> <div ng-if=!showDownloadStockholm class=buttons-container> <div class=download-panel-center> <h4> <span ng-if=\"showInstalledSample && installedSampleName !== 'Stockholm'\" class=\"glyphicon glyphicon-ok-circle\" style=color:green aria-label=\"{{'Oslo site is installed'|translate}}\"></span> {{\"Oslo\"}} </h4> <span ng-if=showLatestAvailableBuildDate class=latestDate>{{\"Most current sample posted on: \" | translate}} {{OsloDate}}</span><br> <button class=\"download-site-btn btn btn-primary\" ng-click=$ctrl.showDeployModal()> <span translate>{{\"Import\"}}</span> </button> <button class=\"download-site-btn btn btn-primary\" ng-click=$ctrl.getDownload()> <span translate>{{\"Download\"}}</span> </button> </div> </div> </div> <div ng-if=\"(!stockholmToggleOn && !importSiteToggleOn) || (stockholmToggleOn && showDownloadStockholm && getDownloadStockholmInfo)\" class=download-container> <img class=background-image src=" + __webpack_require__(115) + " alt=\"{{'Download widget background image' | translate}}\"> <div class=buttons-container> <button class=\"download-site-btn btn btn-primary\" ng-click=$ctrl.getDownload()> <span translate>{{\"Download\"}}</span> </button> <div class=latestDate> <span ng-if=showLatestAvailableBuildDate>{{\"Latest update:\" | translate}} {{OsloDate}}</span><br> <span ng-if=showInstalledBuildDate>{{\"Build date of installed sample:\" | translate}} {{buildDate}}</span> </div> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "85b31041dda0f24b0509e137e1725072.png";

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(117);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./downloadSite.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./downloadSite.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)(false);
	// Module
	exports.push([module.id, ".screen-reader-text{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}#topHomepageContainer .download-widget{position:relative;flex-flow:column;justify-content:flex-end;height:13.5rem;margin:20px;background-repeat:no-repeat;background-size:100% 100%}#topHomepageContainer .download-widget .download-panel{float:left;width:50%;padding:5px}#topHomepageContainer .download-widget .download-panel h4{margin:10px;color:#343334;font-size:medium}#topHomepageContainer .download-widget .download-panel-center{margin-left:auto;margin-right:auto;display:block;padding:5px}#topHomepageContainer .download-widget .download-panel-center h4{margin:10px;color:#343334;font-size:medium}#topHomepageContainer .download-widget .buttons-container{display:flex;align-self:center;align-items:center;text-align:center;text-align:center}#topHomepageContainer .download-widget .buttons-container .download-site-btn{margin:10px}#topHomepageContainer .download-widget .buttons-container .download-site-btn svg{vertical-align:middle}#topHomepageContainer .download-widget .buttons-container .latestDate{color:#343334;font-size:14px;margin-bottom:5px}#topHomepageContainer .download-widget .installed-date-panel{font-size:medium;padding-bottom:10px;margin-top:10px}#topHomepageContainer .download-widget .installed-date-panel .installed-sample-text{font-weight:bold}#topHomepageContainer .download-container{position:relative;display:flex;flex-flow:column;justify-content:flex-end;text-align:center;height:13.5rem;margin-right:20px;margin-left:20px;margin-bottom:20px}#topHomepageContainer .download-container .background-image{width:100%;height:100%}#topHomepageContainer .download-container .buttons-container{position:absolute;align-self:center;align-items:center;flex-flow:column}#topHomepageContainer .download-container .buttons-container .download-site-btn{margin-bottom:10px}#topHomepageContainer .download-container .buttons-container .download-site-btn svg{vertical-align:middle}#topHomepageContainer .download-container .buttons-container .latestDate{color:#343334;font-size:12px;margin-bottom:5px}\n", ""]);
	


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('HomepageServices').component('shutterstockImage', __webpack_require__(119));

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _logging = __webpack_require__(11);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var template = __webpack_require__(120);
	__webpack_require__(122);
	
	var logger = (0, _logging.createLogger)('shutterstock-images');
	
	var shutterStockImageController = function () {
	    function shutterStockImageController($scope, shutterstockService, $translate, homepageUtil, tenantRegistryService, shellUtil) {
	        _classCallCheck(this, shutterStockImageController);
	
	        this.$translate = $translate;
	        this.homepageUtil = homepageUtil;
	        this.shellUtil = shellUtil;
	        this.shutterstockService = shutterstockService;
	
	        this.imageOverages = 0;
	        this.usageLoaded = false;
	        this.getShutterstockImageLicense();
	    }
	
	    _createClass(shutterStockImageController, [{
	        key: 'getShutterstockImageLicense',
	        value: function getShutterstockImageLicense() {
	            var _this = this;
	
	            return this.shutterstockService.getShutterstockEnabled().then(function (data) {
	                if (data.licenses) {
	                    _this.imageUsed = data.licenses[0].used;
	                    _this.imageEntitled = data.licenses[0].entitled;
	                    _this.imageOverages = data.licenses[0].overages;
	                    _this.usageLoaded = true;
	                    return true;
	                }
	
	                // No license in this case
	                return false;
	            }, function (error) {
	                logger.error('Error retrieving shutterstock info: ' + error);
	                return false;
	            });
	        }
	    }, {
	        key: 'getImageUsagePercentStyle',
	        value: function getImageUsagePercentStyle() {
	            if (!this.usageLoaded) {
	                return {
	                    "height": 0
	                };
	            }
	            return {
	                "height": (this.imageUsed / this.imageEntitled * 100).toFixed(2) + '%'
	            };
	        }
	    }, {
	        key: 'getRemaining',
	        value: function getRemaining() {
	            if (!this.usageLoaded) {
	                return 0;
	            }
	            var remainNum = this.imageEntitled - this.imageUsed;
	            if (remainNum >= 0) {
	                return remainNum;
	            } else {
	                return '+' + (0 - remainNum);
	            }
	        }
	    }]);
	
	    return shutterStockImageController;
	}();
	
	;
	
	module.exports = {
	    templateUrl: template,
	    controller: ["$scope", "shutterstockService", "$translate", "homepageUtil", "tenantRegistryService", "shellUtil", shutterStockImageController]
	};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	var path = '/authoring-homepage-ui/shutterstockImage/shutterstockImage.html';
	var html = "<div class=shutterstock-image-container> <div class=usage-icon-container> <span ng-if=\"$ctrl.usageLoaded && ($ctrl.imageOverages ||  $ctrl.imageEntitled - $ctrl.imageUsed < 0)\" class=\"glyphicon glyphicon-warning-sign\" style=color:red;height:30px;width:30px tabindex=0 x1-tooltip data-placement=right data-title=\"{{'shutterstockImageOverLimitAlt'|translate}}\" data-close-icon=true aria-label=\"{{'shutterstockImageOverLimitAlt'|translate}}\"></span> <span ng-if=\"$ctrl.usageLoaded && $ctrl.imageEntitled - $ctrl.imageUsed === 0 \" class=\"glyphicon glyphicon-error-circle\" style=color:red;height:30px;width:30px tabindex=0 x1-tooltip data-placement=right data-title=\"{{'shutterstockImageReachLimitAlt'|translate}}\" data-close-icon=true aria-label=\"{{'shutterstockImageReachLimitAlt'|translate}}\"></span> </div> <div class=usage-wrapper> <div id=image-usage class=usage-container> <span class=fill ng-style=$ctrl.getImageUsagePercentStyle() attr.aria-label={{$ctrl.getImageUsagePercentStyle()}} /> <div class=shutterstock-usage-icon> <svg width=121px height=121px viewBox=\"0 0 121 121\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink> <title>{{\"Shutterstock image\" | translate}}</title> <defs> <path d=\"M113.4375,113.4375 L7.5625,113.4375 L7.5625,7.5625 L113.4375,7.5625 L113.4375,113.4375 Z M121,0 L0,0 L0,121 L121,121 L121,0 Z M83.1875,45.375 C91.5408068,45.375 98.3125,38.6033068 98.3125,30.25 C98.3125,21.8966932 91.5408068,15.125 83.1875,15.125 C74.8341932,15.125 68.0625,21.8966932 68.0625,30.25 C68.0625,38.6033068 74.8341932,45.375 83.1875,45.375 Z M105.875,83.1875 L86.96875,60.5 L68.0625,75.625 L37.8125,45.375 L15.125,68.0625 L15.125,105.875 L105.875,105.875 L105.875,83.1875 Z\" id=path-1></path> </defs> <g id=ss-image stroke=none stroke-width=1 fill=none fill-rule=evenodd> <mask id=mask-1 fill=white> <use xlink:href=#path-1></use> </mask> <use id=image fill-opacity=0.2 fill=#FFFFFF fill-rule=nonzero xlink:href=#path-1></use> </g> </svg> </div> </div> <div class=usage-labels> <p ng-if=$ctrl.usageLoaded class=usage-number translate>{{ $ctrl.getRemaining() }}</p> <p ng-if=!$ctrl.usageLoaded class=remaining-text translate>{{ \"Loading...\" }}</p> <p ng-if=\"$ctrl.usageLoaded && !$ctrl.imageOverages && $ctrl.imageEntitled - $ctrl.imageUsed >=0\" class=remaining-text translate>{{ \"remaining\" }}</p> <p ng-if=\"$ctrl.usageLoaded && ($ctrl.imageOverages ||  $ctrl.imageEntitled - $ctrl.imageUsed < 0)\" class=remaining-text translate>{{\"Over subscription\"}} </p> <p ng-if=$ctrl.usageLoaded class=usage-name translate>{{\"photos\"}}</p> </div> </div> <div class=shutterstock-footer> <div ng-if=\"$ctrl.usageLoaded && $ctrl.imageUsed != undefined && $ctrl.imageEntitled != undefined && $ctrl.imageEntitled - $ctrl.imageUsed >= 0\" class=usage-used>{{ $ctrl.imageUsed }} / {{ $ctrl.imageEntitled }} </div> <div ng-if=\"$ctrl.usageLoaded && ($ctrl.imageOverages ||  $ctrl.imageEntitled - $ctrl.imageUsed < 0)\" class=usage-used>{{\"Over subscription\" | translate}} </div> <img class=shutterstock-logo src=" + __webpack_require__(121) + " alt=Shutterstock-logo> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(123);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./shutterstockImage.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./shutterstockImage.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)(false);
	// Module
	exports.push([module.id, ".screen-reader-text{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}#topHomepageContainer .shutterstock-image-container{position:relative;flex-flow:column;justify-content:flex-end;height:16rem;margin-top:10px;margin-bottom:10px;margin-left:20px;margin-right:20px}#topHomepageContainer .shutterstock-image-container .usage-wrapper{position:relative;text-align:center;display:flex;align-items:center;justify-content:center}#topHomepageContainer .shutterstock-image-container .usage-wrapper .usage-container{width:190px;height:190px;border-radius:100%;position:relative;background-color:#595859;overflow:hidden;display:flex;align-items:center;justify-content:center}#topHomepageContainer .shutterstock-image-container .usage-wrapper .usage-container .fill{background:#dc267f;display:block;width:190px;height:190px;position:absolute;left:0;bottom:0;z-index:1}#topHomepageContainer .shutterstock-image-container .usage-wrapper .usage-container .shutterstock-usage-icon{position:absolute;z-index:2;width:121px;height:121px}#topHomepageContainer .shutterstock-image-container .usage-wrapper .usage-labels{position:absolute;z-index:3;color:white}#topHomepageContainer .shutterstock-image-container .usage-wrapper .usage-labels .usage-number{margin-bottom:20px;font-size:56px;font-family:\"Helvetica Neue for IBM\";font-weight:bold}#topHomepageContainer .shutterstock-image-container .usage-wrapper .usage-labels .remaining-text{font-size:14px;line-height:20px;font-family:\"IBM Plex Sans\"}#topHomepageContainer .shutterstock-image-container .usage-wrapper .usage-labels .usage-name{font-size:14px;line-height:20px;font-family:\"IBM Plex Sans\";font-weight:bold}#topHomepageContainer .shutterstock-image-container .usage-wrapper .tooltip{position:absolute;z-index:4}#topHomepageContainer .shutterstock-image-container .shutterstock-footer{position:relative}#topHomepageContainer .shutterstock-image-container .shutterstock-footer .usage-used{left:0;float:left}#topHomepageContainer .shutterstock-image-container .shutterstock-footer .shutterstock-logo{right:0;width:105px;float:right}\n", ""]);
	


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('HomepageServices').component('shutterstockFootage', __webpack_require__(125));

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _logging = __webpack_require__(11);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var template = __webpack_require__(126);
	__webpack_require__(128);
	
	var logger = (0, _logging.createLogger)('shutterstock-footage');
	
	var shutterStockFootageController = function () {
	    function shutterStockFootageController($scope, shutterstockService, $translate, homepageUtil, tenantRegistryService, shellUtil) {
	        _classCallCheck(this, shutterStockFootageController);
	
	        this.$translate = $translate;
	        this.homepageUtil = homepageUtil;
	        this.shellUtil = shellUtil;
	        this.shutterstockService = shutterstockService;
	
	        this.imageOverages = 0;
	        this.usageLoaded = false;
	        this.getShutterstockFootageLicense();
	    }
	
	    _createClass(shutterStockFootageController, [{
	        key: 'getShutterstockFootageLicense',
	        value: function getShutterstockFootageLicense() {
	            var _this = this;
	
	            return this.shutterstockService.getShutterstockEnabled().then(function (data) {
	                if (data.licenses) {
	                    _this.footageUsed = data.licenses[1].used;
	                    _this.footageEntitled = data.licenses[1].entitled;
	                    _this.footageOverages = data.licenses[1].overages;
	                    _this.usageLoaded = true;
	                    return true;
	                }
	
	                // No license in this case
	                return false;
	            }, function (error) {
	                logger.error('Error retrieving shutterstock info: ' + error);
	                return false;
	            });
	        }
	    }, {
	        key: 'getFootageUsagePercentStyle',
	        value: function getFootageUsagePercentStyle() {
	            if (!this.usageLoaded) {
	                return {
	                    "height": 0
	                };
	            }
	
	            return {
	                "height": (this.footageUsed / this.footageEntitled * 100).toFixed(2) + '%'
	            };
	        }
	    }, {
	        key: 'getRemaining',
	        value: function getRemaining() {
	            if (!this.usageLoaded) {
	                return 0;
	            }
	            var remainNum = this.footageEntitled - this.footageUsed;
	            if (remainNum >= 0) {
	                return remainNum;
	            } else {
	                return '+' + (0 - remainNum);
	            }
	        }
	    }]);
	
	    return shutterStockFootageController;
	}();
	
	;
	
	module.exports = {
	    templateUrl: template,
	    controller: ["$scope", "shutterstockService", "$translate", "homepageUtil", "tenantRegistryService", "shellUtil", shutterStockFootageController]
	};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var path = '/authoring-homepage-ui/shutterstockFootage/shutterstockFootage.html';
	var html = "<div class=shutterstock-footage-container> <div class=usage-icon-container> <span ng-if=\"$ctrl.usageLoaded && ($ctrl.footageOverages ||  $ctrl.footageEntitled - $ctrl.footageUsed < 0)\" class=\"glyphicon glyphicon-warning-sign\" style=color:red;height:30px;width:30px tabindex=0 x1-tooltip data-placement=right data-title=\"{{'shutterstockFootageOverLimitAlt'|translate}}\" data-close-icon=true aria-label=\"{{'shutterstockFootageOverLimitAlt'|translate}}\"></span> <span ng-if=\"$ctrl.usageLoaded && $ctrl.footageEntitled - $ctrl.footageUsed === 0 \" class=\"glyphicon glyphicon-error-circle\" style=color:red;height:30px;width:30px tabindex=0 x1-tooltip data-placement=right data-title=\"{{'shutterstockFootageReachLimitAlt'|translate}}\" data-close-icon=true aria-label=\"{{'shutterstockFootageReachLimitAlt'|translate}}\"></span> </div> <div class=usage-wrapper> <div id=footage-usage class=usage-container> <span class=fill ng-style=$ctrl.getFootageUsagePercentStyle() attr.aria-label={{$ctrl.getFootageUsagePercentStyle()}} /> <div class=shutterstock-usage-icon> <svg width=121px height=121px viewBox=\"0 0 121 121\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink> <title>{{\"Shutterstock footage and music\" | translate}}</title> <defs> <path d=\"M111.692308,0 L111.692308,12.9642857 L102.384615,12.9642857 L102.384615,0 L93.0769231,0 L93.0769231,12.9642857 L27.9230769,12.9642857 L27.9230769,0 L18.6153846,0 L18.6153846,12.9642857 L9.30769231,12.9642857 L9.30769231,0 L0,0 L0,121 L9.30769231,121 L9.30769231,108.035714 L18.6153846,108.035714 L18.6153846,121 L27.9230769,121 L27.9230769,108.035714 L93.0769231,108.035714 L93.0769231,121 L102.384615,121 L102.384615,108.035714 L111.692308,108.035714 L111.692308,121 L121,121 L121,0 L111.692308,0 Z M18.6153846,99.3928571 L9.30769231,99.3928571 L9.30769231,86.4285714 L18.6153846,86.4285714 L18.6153846,99.3928571 Z M18.6153846,77.7857143 L9.30769231,77.7857143 L9.30769231,64.8214286 L18.6153846,64.8214286 L18.6153846,77.7857143 Z M18.6153846,56.1785714 L9.30769231,56.1785714 L9.30769231,43.2142857 L18.6153846,43.2142857 L18.6153846,56.1785714 Z M18.6153846,34.5714286 L9.30769231,34.5714286 L9.30769231,21.6071429 L18.6153846,21.6071429 L18.6153846,34.5714286 Z M27.9230769,99.3928571 L27.9230769,21.6071429 L93.0769231,21.6071429 L93.0769231,99.3928571 L27.9230769,99.3928571 Z M111.692308,99.3928571 L102.384615,99.3928571 L102.384615,86.4285714 L111.692308,86.4285714 L111.692308,99.3928571 Z M111.692308,77.7857143 L102.384615,77.7857143 L102.384615,64.8214286 L111.692308,64.8214286 L111.692308,77.7857143 Z M111.692308,56.1785714 L102.384615,56.1785714 L102.384615,43.2142857 L111.692308,43.2142857 L111.692308,56.1785714 Z M111.692308,34.5714286 L102.384615,34.5714286 L102.384615,21.6071429 L111.692308,21.6071429 L111.692308,34.5714286 Z M41.8846154,38.8928571 L83.7692308,60.5 L41.8846154,82.1071429 L41.8846154,38.8928571 Z\" id=path-2></path> </defs> <g id=ss-video stroke=none stroke-width=1 fill=none fill-rule=evenodd> <mask id=mask-2 fill=white> <use xlink:href=#path-1></use> </mask> <use id=video fill-opacity=0.2 fill=#FFFFFF xlink:href=#path-2></use> </g> </svg> </div> </div> <div class=usage-labels> <p ng-if=$ctrl.usageLoaded class=usage-number translate>{{ $ctrl.getRemaining() }}</p> <p ng-if=!$ctrl.usageLoaded class=remaining-text translate>{{ \"Loading...\" }}</p> <p ng-if=\"$ctrl.usageLoaded && !$ctrl.footageOverages &&  $ctrl.footageEntitled - $ctrl.footageUsed >=0\" class=remaining-text translate>{{ \"remaining\" }}</p> <p ng-if=\"$ctrl.usageLoaded && ($ctrl.footageOverages ||  $ctrl.footageEntitled - $ctrl.footageUsed < 0)\" class=remaining-text translate>{{\"Over subscription\"}} </p> <p ng-if=$ctrl.usageLoaded class=usage-name translate>{{\"Footage/Music\"}}</p> </div> </div> <div class=shutterstock-footer> <div ng-if=\"$ctrl.usageLoaded && $ctrl.footageUsed != undefined && $ctrl.footageEntitled != undefined && $ctrl.footageEntitled - $ctrl.footageUsed >= 0\" class=usage-used>{{ $ctrl.footageUsed }} / {{ $ctrl.footageEntitled }} </div> <div ng-if=\"$ctrl.usageLoaded && ($ctrl.footageOverages ||  $ctrl.footageEntitled - $ctrl.footageUsed < 0)\" class=usage-used>{{\"Over subscription\" | translate}} </div> <img class=shutterstock-logo src=" + __webpack_require__(127) + " alt=Shutterstock-logo> </div> </div> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(129);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./shutterstockFootage.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/sass-loader/index.js!./shutterstockFootage.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)(false);
	// Module
	exports.push([module.id, ".screen-reader-text{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}#topHomepageContainer .shutterstock-footage-container{position:relative;flex-flow:column;justify-content:flex-end;height:16rem;margin-top:10px;margin-bottom:10px;margin-left:20px;margin-right:20px}#topHomepageContainer .shutterstock-footage-container .usage-wrapper{position:relative;text-align:center;display:flex;align-items:center;justify-content:center}#topHomepageContainer .shutterstock-footage-container .usage-wrapper .usage-container{width:190px;height:190px;border-radius:100%;position:relative;background-color:#595859;overflow:hidden;display:flex;align-items:center;justify-content:center}#topHomepageContainer .shutterstock-footage-container .usage-wrapper .usage-container .fill{background:#c871d7;display:block;width:190px;height:190px;position:absolute;left:0;bottom:0;z-index:1}#topHomepageContainer .shutterstock-footage-container .usage-wrapper .usage-container .shutterstock-usage-icon{position:absolute;z-index:2;width:121px;height:121px}#topHomepageContainer .shutterstock-footage-container .usage-wrapper .usage-labels{position:absolute;z-index:3;color:white}#topHomepageContainer .shutterstock-footage-container .usage-wrapper .usage-labels .usage-number{margin-bottom:20px;font-size:56px;font-family:\"Helvetica Neue for IBM\";font-weight:bold}#topHomepageContainer .shutterstock-footage-container .usage-wrapper .usage-labels .remaining-text{font-size:14px;line-height:20px;font-family:\"IBM Plex Sans\"}#topHomepageContainer .shutterstock-footage-container .usage-wrapper .usage-labels .usage-name{font-size:14px;line-height:20px;font-family:\"IBM Plex Sans\";font-weight:bold}#topHomepageContainer .shutterstock-footage-container .usage-wrapper .tooltip{position:absolute;z-index:4}#topHomepageContainer .shutterstock-footage-container .shutterstock-footer{position:relative}#topHomepageContainer .shutterstock-footage-container .shutterstock-footer .usage-used{left:0;float:left}#topHomepageContainer .shutterstock-footage-container .shutterstock-footer .shutterstock-logo{right:0;width:105px;float:right}\n", ""]);
	


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// homepage.js